import { tokens } from '../tokens'

export const ko = {
    [tokens.common.no_unassigned_sales_channel]: '미배정 발주처가 없습니다.',
    [tokens.common.sales_channel_id_sales_channel_address]: '발주처ID, 발주처, 주소',
    [tokens.common.unassigned_list]: '미배정 리스트',
    [tokens.common.number_of_sales_channels_monthly_average_order_total]: '{{totalSales}}개 발주처 / 월평균 주문금액 총 {{totalAvgAmt}} 원',
    [tokens.common.count]: '개',
    [tokens.common.assigned_sales_office_id]: '배정 발주처 ID',
    [tokens.common.sales_office_id_contact_driver_name_assigned_route]: '발주처ID, 기사연락처, 기사명, 배정 라우트',
    [tokens.common.manager_id]: '매니저 ID',
    [tokens.common.view_unassigned_managers_only]: '미배정 매니저만 보기',
    [tokens.common.business_registration_number]: '사업자 번호',
    [tokens.common.vehicle_unit]: '대',
    [tokens.common.urgent_dispatch_vehicle]: '긴급배차 {{emrgDsptCnt}} 대',
    [tokens.common.max_pinned_notices]: '고정 공지는 최대 6개까지 등록 가능합니다.',
    [tokens.common.notice]: '공지사항',
    [tokens.common.notice_details]: '공지사항 상세',
    [tokens.common.notice_termination_completed]: '공지사항 종료가 완료되었습니다.',
    [tokens.common.category_required]: '카테고리는 필수입니다',
    [tokens.common.fixed]: '고정',
    [tokens.common.list]: '목록',
    [tokens.common.return_exchange_code]: '반품&교환코드',
    [tokens.common.no_return_exchange_history]: '반품&교환 이력이 없습니다.',
    [tokens.common.incomplete_return_exchange_history_only]: '미완료 반품 & 교환 이력만 보기',
    [tokens.common.sales_place_info_4]: '발주처ID, 발주처, 반품&교환코드, 상세 내용',
    [tokens.common.return_exchange_history]: '반품 & 교환 이력',
    [tokens.common.incomplete]: '미완료',
    [tokens.common.sales_place_info_3]: '발주처ID, 발주처, 상세 내용',
    [tokens.common.sales_place_info_2]: '발주처ID, 발주처, 사업자번호',
    [tokens.common.send_sms]: '문자 발송',
    [tokens.common.no_claim_history_exists]: '클레임 이력이 존재하지 않습니다.',
    [tokens.common.view_unprocessed_claims_only]: '미처리 클레임만 보기',
    [tokens.common.sales_office_id_sales_office_consultation_content]: '발주처ID, 발주처, 상담 내용',
    [tokens.common.claim_history]: '클레임 이력',
    [tokens.common.minimum_length_9_digits_required]: '9자리 이상 입력하여 주십시오',
    [tokens.common.representative_name_length_limit]: '대표자명은 25자리 이하로 입력하여 주십시오.',
    [tokens.common.corporation_name_required]: '법인명은 필수 입니다.',
    [tokens.common.trading_corporation_id]: '법인 ID',
    [tokens.common.trading_corporation_info]: '법인ID, 법인명, 사업자상호, 사업자번호',
    [tokens.common.departure_center]: '출차지 센터',
    [tokens.common.unused]: '미사용',
    [tokens.common.not_in_use]: '미사용중',
    [tokens.common.required]: '필요',
    [tokens.common.sales_outlet_registration]: '발주처 등록',
    [tokens.common.sales_outlet_update]: '발주처 수정',
    [tokens.common.error]: '오류',
    [tokens.common.error_occurred_during_sales_outlet_save_or_update]: '발주처 저장/수정중 오류가 발생했습니다.',
    [tokens.common.error_while_saving_or_updating_sales_outlet]: '발주처 저장/수정 중 에러',
    [tokens.common.settlement_payment_month_required]: '정산 결제월은 필수 입니다',
    [tokens.common.sales_place_info]: '발주처ID, 발주처, 발주처코드',
    [tokens.common.contract_date_is_required]: '계약일자는 필수입니다.',
    [tokens.common.purchase_manager_selection_is_required]: '구매담당자 선택은 필수 입니다.',
    [tokens.common.registered_product_count]: '등록상품수',
    [tokens.common.purchase_place_info]: '매입처ID, 매입처, 사업자상호, 사업자번호, 대표자',
    [tokens.common.public_holiday_name_input]: '공휴일명 입력',
    [tokens.common.holiday_start_end_date]: '공휴일시작/종료일',
    [tokens.common.end_of_month_payment]: '말일 결제',
    [tokens.common.contract_start_end_date]: '계약시작/종료일',
    [tokens.common.trading_corporation]: '거래법인',
    [tokens.common.cannot_exceed_5_characters]: '5자리를 넘을 수 없습니다.',
    [tokens.common.enter_up_to_20_characters]: '20자리 이하로 입력하여 주십시오.',
    [tokens.common.enter_contact_person_2_name_phone_email]: '담당자2 저장하고 싶다면 이름,연락처,이메일 모두 입력해주세요.',
    [tokens.common.brandID_brand_business_number_representative]: '거래처ID, 거래처명, 사업자번호, 대표자',
    [tokens.common.contract_termination_completed]: '계약종료 처리 되었습니다.',
    [tokens.common.code_group_deletion_completed]: '코드 그룹 삭제가 완료 되었습니다.',
    [tokens.common.select_category_change]: '변경할 카테고리 선택',
    [tokens.common.category_classification]: '카테고리 구분',
    [tokens.common.count_product]: '개 상품',
    [tokens.common.category_name_required]: '카테고리명은 필수 입니다.',
    [tokens.common.category_name_50]: '카테고리명은 50자를 넘을 수 없습니다.',
    [tokens.common.category_name_required_n]: '카테고리명은 필수 입니다 카테고리명은 n자를 넘을 수 없습니다',
    [tokens.common.category_code_duplicate]: '카테고리 코드가 중복되었습니다',
    [tokens.common.languageChanged]: 'Language changed',
    [tokens.common.additional_fee]: '가산',
    [tokens.common.additional_payment_amount]: '가산 지급액',
    [tokens.common.virtual_account_transaction_history]: '가상계좌 거래내역 조회',
    [tokens.common.no_virtual_account_transaction]: '가상계좌 거래내역이 존재하지 않습니다',
    [tokens.common.manage_virtual_accounts]: '가상계좌 관리',
    [tokens.common.virtual_account_bulk_registration_completed]: '가상계좌 대량 등록이 완료 되었습니다',
    [tokens.common.virtual_account_number]: '가상계좌 번호',
    [tokens.common.virtual_account_number_registration]: '가상계좌 번호 등록',
    [tokens.common.virtual_account_deletion]: '가상계좌 삭제',
    [tokens.common.virtual_account_deletion_completed]: '가상계좌 삭제가 완료 되었습니다',
    [tokens.common.virtual_account_file]: '가상계좌 파일',
    [tokens.common.virtual_account_cancellation_approval]: '가상계좌 해지 승인',
    [tokens.common.virtual_account_cancellation_error]: '가상계좌 해지 중 오류가 발생했습니다',
    [tokens.common.virtual_account_cancellation_completed]: '가상계좌 해지가 완료 되었습니다',
    [tokens.common.virtual_account_sales_name]: '가상계좌번호 발주처 발주처명',
    [tokens.common.no_virtual_account_information]: '가상계좌정보가 존재하지 않습니다',
    [tokens.common.available_stock]: '가용 재고',
    [tokens.common.available_stock_quantity]: '가용 재고 수량',
    [tokens.common.available_inventory_stock]: '가용재고',
    [tokens.common.stock_holding]: '재고홀딩',
    [tokens.common.stock_holding_quantity]: '재고 홀딩 수량',
    [tokens.common.holding_quantity]: '현재 홀딩 수량',
    [tokens.common.stock_holding_warning_1]: '재고를 홀딩하는 경우 지정한 수량만큼 주문이 불가능 하니,',
    [tokens.common.stock_holding_warning_2]: '다시 한번 신중하게 ',
    [tokens.common.stock_holding_warning_3]: '확인 후 진행',
    [tokens.common.stock_holding_warning_4]: '하시기 바랍니다.',
    [tokens.common.individual_brand_sale_price]: '각 브랜드의 상위 그룹 에서 개별 설정한 판매가',
    [tokens.common.individual_brand_center_sale_price]: '각 브랜드의 출차 센터별 개별 설정한 판매가',
    [tokens.common.trunk_main]: '간선',
    [tokens.common.trunk_label_printing]: '간선 PLT 라벨 출력',
    [tokens.common.trunk_route]: '간선 라우트',
    [tokens.common.trunk_route_detail]: '간선 라우트 상세',
    [tokens.common.trunk_inbound]: '간선 입고',
    [tokens.common.trunk_inbound_detail]: '간선 입고 상세',
    [tokens.common.trunk_plt_printing]: '간선 출력',
    [tokens.common.trunk_route_modification]: '간선라우트 수정',
    [tokens.common.trunk_shipment]: '간선출고',
    [tokens.common.trunk_code]: '간선코드',
    [tokens.common.forced_inbound]: '강제 입고',
    [tokens.common.forced_inbound_registration]: '강제 입고 등록',
    [tokens.common.forced_inbound_processing_confirmation]: '강제 입하처리 확인',
    [tokens.common.forced_entry_registration]: '강제입고등록',
    [tokens.common.forced_arrival_processing]: '강제입하처리',
    [tokens.common.average_monthly_order_amount]: '발주처 월평균 주문금액 총 원',
    [tokens.common.product]: '상품',
    [tokens.common.individual_picking_label_printing]: '개별 피킹지 출력',
    [tokens.common.individual_setting_classification]: '개별설정구분',
    [tokens.common.individual_picking_paper_printing]: '개별피킹지 출력',
    [tokens.common.init_date]: '개시일',
    [tokens.common.confirm_early_shipment]: '개의 상품을 선출고 지시 하시겠습니까',
    [tokens.common.confirm_shipment]: '선택하신 {{totalConfirmShipment}}개의 주문을 출고 지시 하시겠습니까?\n\n',
    [tokens.common.adjustment_details]: '개의 조정금 처리 내역',
    [tokens.common.transaction_amount]: '거래 금액',
    [tokens.common.transaction_corporation]: '법인명',
    [tokens.common.transaction_classification]: '거래구분',
    [tokens.common.trading_volume]: '거래량',
    [tokens.common.transaction_statement_receipt_method]: '거래명세서 수취 방식',
    [tokens.common.transaction_statement_recipient]: '거래명세서 수취인',
    [tokens.common.transaction_statement_printing]: '거래명세서 출력',
    [tokens.common.transaction_statement_printing_options]: '거래명세서 출력 - 옵션선택',
    [tokens.common.transaction_volume]: '거래물량',
    [tokens.common.company]: '본사',
    [tokens.common.company_selection_required]: '본사 선택은 필수입니다',
    [tokens.common.trading_corporation_management]: '본사 관리',
    [tokens.common.trading_corporation_registration]: '법인 등록',
    [tokens.common.select_trading_corporation]: '거래법인 선택',
    [tokens.common.trading_corporation_selection_required]: '거래법인 선택은 필수 입니다',
    [tokens.common.trading_corporation_edit_and_registration]: '거래법인 수정',
    [tokens.common.trading_corporation_name_input]: '거래법인명은 30자리 이하로 입력하여 주십시오',
    [tokens.common.duplicate_trading_corporation_name]: '거래법인명이 중복되었습니다',
    [tokens.common.trading_corporation_required]: '거래법인은 필수 입니다',
    [tokens.common.transaction_type]: '거래유형',
    [tokens.common.trading_date]: '거래일',
    [tokens.common.transaction_serial_number]: '거래일련번호',
    [tokens.common.transaction_date_time]: '거래일시',
    [tokens.common.transaction_date]: '거래일자',
    [tokens.common.post_transaction_balance]: '거래후 잔액',
    [tokens.common.case_count]: '건',
    [tokens.common.case_processing]: '건씩 처리',
    [tokens.common.delete_faq_prompt]: '건의 자주 묻는 질문을 삭제하려면 비밀번호를 입력하세요',
    [tokens.common.search]: '검색',
    [tokens.common.no_search_results]: '검색 결과 없음',
    [tokens.common.search_results]: '검색 결과 입니다',
    [tokens.common.search_area]: '검색 영역',
    [tokens.common.no_searched_history]: '검색된 내역이 없습니다',
    [tokens.common.enter_search_term]: '검색어를 입력 하세요',
    [tokens.common.required_payment_month]: '결재월은 필수 입니다',
    [tokens.common.required_payment_date]: '결재일은 필수 입니다',
    [tokens.common.monthly_payment]: '결제 매월 일',
    [tokens.common.payment_amount_1]: '결제금액',
    [tokens.common.payment_status]: '결제상태',
    [tokens.common.overdue_payment_only]: '결제상태 - 미납 내역만 보기',
    [tokens.common.payment_based_on_month]: '결제월기준',
    [tokens.common.payment_date_adjustment]: '결제일 조정',
    [tokens.common.payment_date]: '결제일',
    [tokens.common.warning]: '경고',
    [tokens.common.gyeongnam]: '경남',
    [tokens.common.stopover]: '경유지',
    [tokens.common.contract]: '계약',
    [tokens.common.contract_date]: '계약일',
    [tokens.common.contract_status]: '계약 상태',
    [tokens.common.contract_start_and_end_date]: '계약 시작 / 종료일',
    [tokens.common.contract_start_date_required]: '계약 시작일은 필수 입니다',
    [tokens.common.contract_information]: '계약 정보',
    [tokens.common.contract_termination]: '계약 종료',
    [tokens.common.contract_termination_password_required]: '계약 종료 처리를 원하시는 경우 비밀번호를 입력해주세요',
    [tokens.common.contract_end_date]: '계약 종료일',
    [tokens.common.contract_end_date_required]: '계약 종료일은 필수 입니다',
    [tokens.common.contract_attached_documents]: '계약 첨부 서류',
    [tokens.common.contract_type]: '계약 형태',
    [tokens.common.contract_type_payment_date]: '계약 형태 / 결제일',
    [tokens.common.contract_type_collateral_type]: '계약 형태 / 담보 유형',
    [tokens.common.contract_type_required]: '계약 형태는 필수 입니다',
    [tokens.common.account_password]: '계정 비밀번호',
    [tokens.common.account_password_required]: '계정 비밀번호는 입력 필수입니다',
    [tokens.common.account_registration]: '계좌 등록',
    [tokens.common.account_cancellation]: '계좌 등록 해지',
    [tokens.common.account_deletion]: '계좌 삭제',
    [tokens.common.account_balance]: '계좌 잔액',
    [tokens.common.account_issuance_date]: '계좌발급일시',
    [tokens.common.account_number]: '계좌번호',
    [tokens.common.account_number_required]: '계좌번호는 필수 입니다',
    [tokens.common.account_status]: '계좌상태',
    [tokens.common.customer_list_1]: '고객 리스트',
    [tokens.common.customer_consultation_details]: '고객 상담 상세',
    [tokens.common.customer_consultation_history]: '발주처 상담 이력',
    [tokens.common.customer_notice_completed]: '고객 안내 완료 체크는 필수입니다',
    [tokens.common.fix_notice]: '고정 공지로 등록하기',
    [tokens.common.fixed_sale_price_input]: '고정 판매가 입력',
    [tokens.common.fixed_price]: '고정가',
    [tokens.common.fixed_price_recommendation]: '고정가(권장판매가)',
    [tokens.common.fixed_price_required]: '고정가는 필수입니다',
    [tokens.common.supplier_information]: '공급자 정보',
    [tokens.common.notification_registration]: '공지 등록',
    [tokens.common.notification_termination]: '공지 종료',
    [tokens.common.notice_contents]: '공지내용',
    [tokens.common.announcement_management]: '공지사항 관리',
    [tokens.common.announcement_termination_password_required]: '공지사항 노출을 종료하려면 비밀번호를 입력하세요',
    [tokens.common.public_holiday_period]: '공휴일 기간',
    [tokens.common.public_holiday_date_selection_required]: '공휴일 날짜 선택은 필수 입니다',
    [tokens.common.public_holiday_registration]: '공휴일 등록',
    [tokens.common.public_holiday_name]: '공휴일명',
    [tokens.common.public_holiday_name_required]: '공휴일명은 필수 입니다',
    [tokens.common.taxation_status]: '과세여부',
    [tokens.common.tax_inclusion]: '과세 시 부가세 포함',
    [tokens.common.exchange_return_screen]: '교환 반품 접수 화면',
    [tokens.common.exchange_processing_new_order_required]: '교환 처리 시 신규 주문을 반드시 등록해주세요',
    [tokens.common.purchase_manager]: '구매담당자',
    [tokens.common.purchase_manager_information]: '구매담당자 정보',
    [tokens.common.purchase_manager_search]: '구매담당자 검색',
    [tokens.common.search_select_purchase_manager]: '구매담당자를 검색/선택 해주세요',
    [tokens.common.purchase_profit_rate]: '구매이익율',
    [tokens.common.purchase_profit_rate_prompt]: '구매이익율 입력',
    [tokens.common.purchase_profit_rate_change_reservation_completed]: '구매이익율 변경 예약이 완료 되었습니다',
    [tokens.common.division]: '구분',
    [tokens.common.classification_code_required]: '구분코드 선택은 필수 입니다',
    [tokens.common.zone]: '구역',
    [tokens.common.variable_assignment_with_destructuring]: '구조 분해 할당을 통해 변수 설정',
    [tokens.common.select_nation]: '국가 선택',
    [tokens.common.country_required]: '국가는 필수 입니다',
    [tokens.common.citizens]: '국민',
    [tokens.common.recommended_price]: '권장 판매가',
    [tokens.common.set_recommended_price]: '권장 판매가 설정',
    [tokens.common.recommended_selling_price]: '권장판매가',
    [tokens.common.recommended_selling_price_settings]: '권장판매가설정구분',
    [tokens.common.authority_group]: '권한 그룹',
    [tokens.common.select_authority_group]: '권한 그룹 선택',
    [tokens.common.authority_group_required]: '권한 그룹은 필수입니다',
    [tokens.common.permission_group]: '권한그룹',
    [tokens.common.attribution]: '귀책',
    [tokens.common.attribution_amount]: '귀책 금액',
    [tokens.common.attribution_selection]: '귀책 선택',
    [tokens.common.attribution_selection_required]: '귀책 선택은 필수 입니다',
    [tokens.common.attributable_amount]: '귀책금액',
    [tokens.common.your_fault_required]: '귀책은 선택 필수입니다',
    [tokens.common.your_fault_mandatory]: '귀책은 필수입니다',
    [tokens.common.select_fault]: '귀책을 선택하세요',
    [tokens.common.specifications]: '규격',
    [tokens.common.specifications_required]: '규격은 필수 입니다',
    [tokens.common.enter_specifications]: '규격입력',
    [tokens.common.regulation]: '규제',
    [tokens.common.set_regulation_period]: '규제 기간 설정',
    [tokens.common.future_date_only_for_regulation]: '규제 기간은 미래 날짜로만 등록 가능합니다',
    [tokens.common.bulk_regulation]: '규제 대량 등록',
    [tokens.common.regulation_status]: '규제 상태',
    [tokens.common.view_regulation_items_only]: '규제 설정 상품만 보기',
    [tokens.common.regulation_timestamp]: '규제 설정일시',
    [tokens.common.regulation_termination]: '규제 종료',
    [tokens.common.irreversible_regulation_termination]: '규제 종료 처리 시에는 데이터 원복이 불가합니다',
    [tokens.common.regulation_period]: '규제기간',
    [tokens.common.regulation_start]: '규제시작',
    [tokens.common.regulation_scheduled]: '규제예정',
    [tokens.common.regulation_end]: '규제종료',
    [tokens.common.regulation_in_progress]: '규제중',
    [tokens.common.proceed_anyway]: '그래도 진행 하시겠습니까',
    [tokens.common.proceed_with_process]: '그래도 처리하시겠습니까',
    [tokens.common.cancel_recovery]: '그래도 회수를 취소하시겠습니까',
    [tokens.common.gold]: '금',
    [tokens.common.amount]: '금액',
    [tokens.common.amount_change_history]: '금액 변경 이력',
    [tokens.common.enter_amount]: '금액 입력',
    [tokens.common.amount_required]: '금액 입력은 필수 입니다',
    [tokens.common.period]: '기간',
    [tokens.common.period_regulation]: '기간 규제',
    [tokens.common.register_period_regulation]: '기간 규제 등록',
    [tokens.common.period_inquiry]: '기간 조회',
    [tokens.common.period_regulation_status]: '기간규제여부',
    [tokens.common.period_query]: '기간조회',
    [tokens.common.function]: '기능',
    [tokens.common.final]: '기말',
    [tokens.common.basic]: '기본',
    [tokens.common.basic_info]: '기본 정보',
    [tokens.common.basic_profit_rate]: '기본 판매 이익율',
    [tokens.common.basic_rate_of_profit]: '기본이익율',
    [tokens.common.enter_driver_details]: '기사님 이름과 전화번호를 입력해주세요',
    [tokens.common.existing_contract_restoration]: '기존 계약정보가 원복 되오니',
    [tokens.common.standard_recommended_price]: '기준 권장판매가',
    [tokens.common.reference_date]: '기준일',
    [tokens.common.reference_date_price]: '기준일 판매가',
    [tokens.common.foundation]: '기초',
    [tokens.common.emergency_dispatch_driver_registration]: '긴급 배차 기사 등록',
    [tokens.common.emergency_dispatch_driver_registration_complete]: '긴급 배차 기사가 등록이 완료 되었습니다',
    [tokens.common.emergency_shipment]: '긴급 출고',
    [tokens.common.emergency_shipment_detail]: '긴급 출고 상세',
    [tokens.common.emergency_shipment_request_complete]: '긴급 출고 신청이 완료되었습니다',
    [tokens.common.emergency_shipment_complete]: '화물 출고 완료 되었습니다',
    [tokens.common.no_emergency_shipment_requests]: '긴급 출고 요청 내역이 없습니다',
    [tokens.common.cancel_emergency_shipment_request]: '긴급 출고 요청 취소',
    [tokens.common.emergency_shipment_history]: '긴급 출고 이력',
    [tokens.common.emergency_shipment_registration]: '긴급 출고 접수',
    [tokens.common.emergency_shipment_processing]: '긴급 출고 처리',
    [tokens.common.emergency_shipment_issue_processing]: '긴급 출고 처리 이슈 처리',
    [tokens.common.emergency_dispatch]: '긴급배차',
    [tokens.common.emergency_dispatch_driver]: '긴급배차 기사',
    [tokens.common.emergency_dispatch_driver_contact]: '긴급배차 기사 연락처',
    [tokens.common.no_emergency_dispatch_records]: '긴급배차 내역이 없습니다',
    [tokens.common.emergency_dispatch_registration]: '긴급배차 등록',
    [tokens.common.emergency_dispatch_route]: '긴급배차 라우트',
    [tokens.common.emergency_dispatch_list]: '긴급배차 리스트',
    [tokens.common.emergency_dispatch_cost]: '긴급배차 비용',
    [tokens.common.emergency_dispatch_status]: '긴급배차여부',
    [tokens.common.urgent_delivery]: '긴급출고',
    [tokens.common.urgent_delivery_1]: '긴급 출고',
    [tokens.common.no_urgent_delivery_records]: '긴급출고 내역이 없습니다',
    [tokens.common.urgent_delivery_shipment_label]: '긴급출고 배송 표시',
    [tokens.common.urgent_delivery_cost]: '긴급출고 비용',
    [tokens.common.urgent_delivery_detail]: '긴급출고 상세',
    [tokens.common.urgent_delivery_item_count]: '긴급출고 상품수',
    [tokens.common.no_urgent_delivery_history]: '긴급출고 이력이 없습니다',
    [tokens.common.emergency_delivery_cost_required]: '긴급출고시 배송 비용은 입력 필수입니다',
    [tokens.common.emergency_delivery_contact_required]: '긴급출고시 배송기사 전화번호는 입력 필수입니다',
    [tokens.common.urgent_delivery_date]: '긴급출고일',
    [tokens.common.view_my_claim_history]: '나의 담당 클레임 이력만 보기',
    [tokens.common.view_my_urgent_shipment_history]: '나의 상담 긴급출고 이력만 보기',
    [tokens.common.view_my_pending_cases]: '나의 처리중 내역만 보기',
    [tokens.common.date_1]: '날짜',
    [tokens.common.date_selection_start_end]: '날짜 선택 (시작 -> 종료)',
    [tokens.common.payment_deadline_extension]: '납부 기한 연장',
    [tokens.common.payment_deadline_extension_notice]: '납부 기한 연장 시 연장 종료일까지 미납 처리가 유예 됩니다',
    [tokens.common.payment_deadline_extension_end_date]: '납부 기한 연장 종료일',
    [tokens.common.payment_extension]: '납부 연장',
    [tokens.common.payment_amount_2]: '납부금액',
    [tokens.common.payment_due_date]: '납부기한',
    [tokens.common.payment_due_date_required]: '납부기한 연장 종료일은 필수 입니다',
    [tokens.common.payment_extension_completed]: '납부기한 연장이 완료 되었습니다',
    [tokens.common.my_notifications_only]: '내가 등록한 공지만 보기',
    [tokens.common.history_quantity_and_amount]: '내역 수량 금액',
    [tokens.common.content]: '내용',
    [tokens.common.no_content]: '내용 없음',
    [tokens.common.content_max_length]: '내용은 2000자 이내 입니다',
    [tokens.common.content_max_length_prompt]: '내용은 자 이내로 입력해 주세요',
    [tokens.common.content_required]: '내용은 필수입니다',
    [tokens.common.tomorrow]: '내일',
    [tokens.common.frozen]: '냉동',
    [tokens.common.refrigerated]: '냉장',
    [tokens.common.year_month]: '년 월',
    [tokens.common.annual_disposal_rate]: '년간 폐기율',
    [tokens.common.exposure]: '노출',
    [tokens.common.exposure_change]: '노출 변경',
    [tokens.common.exposure_period]: '노출기간',
    [tokens.common.exposure_change_completed]: '노출변경이 완료 되었습니다',
    [tokens.common.exposure_status_change]: '노출상태 변경',
    [tokens.common.cumulative_arrears]: '누적 미납금액',
    [tokens.common.double_check_file]: '다시 한번 파일을 확인해주시기 바랍니다',
    [tokens.common.double_check_and_proceed]: '다시 한번 확인 후 처리 해주시기 바랍니다',
    [tokens.common.file_name_to_download]: '다운로드될 파일명',
    [tokens.common.unit_price]: '단가',
    [tokens.common.unit_price_order_information]: '단가・발주 정보',
    [tokens.common.no_unit_price_change_history]: '단가 변경 내역이 없습니다',
    [tokens.common.unit_price_change_date_time]: '단가 변경 일시',
    [tokens.common.unit_price_change_info]: '단가 변경 정보',
    [tokens.common.unit_price_information]: '단가 정보',
    [tokens.common.unit_price_adjustment_history]: '단가 조정이력 조회',
    [tokens.common.unit_price_history]: '단가 히스토리',
    [tokens.common.unit_price_application_date_selection]: '단가적용일 선택',
    [tokens.common.unit]: '단위',
    [tokens.common.unit_specifications]: '단위 규격',
    [tokens.common.close]: '닫기',
    [tokens.common.chicken_breast]: '닭가슴살 하림',
    [tokens.common.person_in_charge]: '담당자',
    [tokens.common.person_in_charge_selection]: '담당자 선택',
    [tokens.common.person_in_charge_contact]: '담당자 연락처',
    [tokens.common.person_in_charge_contact_required]: '담당자 연락처 필수입니다',
    [tokens.common.person_in_charge_contact_prompt]: '담당자 연락처는 필수 입니다',
    [tokens.common.person_in_charge_contact_max_length_prompt]: '담당자 연락처는 자리 이하로 입력하여 주십시오',
    [tokens.common.person_in_charge_email]: '담당자 이메일',
    [tokens.common.person_in_charge_email_required]: '담당자 이메일은 필수 입니다.',
    [tokens.common.person_in_charge_email_required_2]: '이메일형식이 올바르지 않습니다',
    [tokens.common.save_person_in_charge_info]: '담당자 저장하고 싶다면 이름 연락처 이메일 모두 입력해주세요',
    [tokens.common.person_in_charge_information]: '담당자 정보',
    [tokens.common.enter_person_in_charge_info]: '담당자 정보를 입력 해주세요',
    [tokens.common.name_of_person_in_charge_required]: '담당자명은 20자리 이하로 입력하여 주십시오',
    [tokens.common.name_of_person_in_charge_required_short]: '담당자명은 필수입니다',
    [tokens.common.collateral_start_end_date]: '담보개시 / 종료일',
    [tokens.common.collateral_start_date_required]: '담보 개시일은 필수 입니다',
    [tokens.common.collateral_amount_required]: '담보 설정금액은 필수 입니다',
    [tokens.common.collateral_type_amount]: '담보 유형 / 설정 금액',
    [tokens.common.collateral_end_date_required]: '담보 종료일은 필수 입니다',
    [tokens.common.collateral_commencement]: '담보개시',
    [tokens.common.collateral_status]: '담보상태',
    [tokens.common.collateral_type]: '담보유형',
    [tokens.common.collateral_credit_limit]: '담보유형 / 여신한도',
    [tokens.common.collateral_type_required]: '담보유형은 필수 입니다',
    [tokens.common.collateral_termination]: '담보종료',
    [tokens.common.answer]: '답변',
    [tokens.common.answer_required]: '답변은 필수입니다',
    [tokens.common.this_month_inbound]: '당월 입고',
    [tokens.common.this_month_outbound]: '당월 출고',
    [tokens.common.delivery_status_today]: '당일 배송 현황',
    [tokens.common.daegu_branch]: '대구분',
    [tokens.common.standby]: '대기',
    [tokens.common.large_company_usage]: '대기업 사용 여부',
    [tokens.common.large_company_integration_needed]: '대기업 연동 필요 여부',
    [tokens.common.large_company_code_entry]: '대기업 코드 입력',
    [tokens.common.corporate_code_and_large_company_required]: '대기업과 대기업코드는 필수 입니다',
    [tokens.common.large_company_sales_code]: '대기업발주처코드',
    [tokens.common.large_company_usage_status]: '대기업사용여부',
    [tokens.common.large_company_product_code]: '대기업상품코드',
    [tokens.common.large_company_product_code_required]: '대기업상품코드는 필수 입니다',
    [tokens.common.large_company_integration_needed_status]: '대기업연동필요여부',
    [tokens.common.duplicate_large_company]: '대기업은 중복될 수 없습니다',
    [tokens.common.large_company_code]: '대기업코드',
    [tokens.common.duplicate_corporate_code]: '대기업코드는 중복될 수 없습니다',
    [tokens.common.corporate_code_required]: '대기업코드는 필수 입니다',
    [tokens.common.bulk_upload]: '대량 업로드',
    [tokens.common.bulk_registration]: '대량등록',
    [tokens.common.uppercase_only]: '대문자만 입력 가능합니다',
    [tokens.common.major_category]: '대분류',
    [tokens.common.major_category_selection]: '대분류 선택',
    [tokens.common.major_category_middle_category]: '대분류 - 중분류',
    [tokens.common.major_category_required]: '대분류 카테고리는 필수입니다',
    [tokens.common.major_category_required_short]: '대분류는 필수 입니다',
    [tokens.common.representative_email]: '대표 이메일',
    [tokens.common.representative_email_address_1]: '대표 이메일 주소',
    [tokens.common.representative_email_required_1]: '대표 이메일은 필수 입니다.',
    [tokens.common.representative_email_required_2]: '대표 이메일형식이 올바르지 않습니다',
    [tokens.common.representative_email_format_invalid]: '대표 이메일은 필수 입니다 이메일 형식이 맞지 않습니다',
    [tokens.common.representative_email_address_2]: '대표이메일주소',
    [tokens.common.representative]: '대표자',
    [tokens.common.representative_contact]: '대표자 연락처',
    [tokens.common.representative_contact_required_2]: '대표자 연락처는 필수 입니다',
    [tokens.common.representative_contact_prompt]: '대표자 연락처는 자리 이하로 입력하여 주십시오',
    [tokens.common.representative_name]: '대표자 이름',
    [tokens.common.representative_name_contact]: '대표자 이름 / 연락처',
    [tokens.common.representative_name_required]: '대표자 이름은 필수 입니다',
    [tokens.common.representative_name_prompt]: '대표자 이름은 자리 이하로 입력하여 주십시오',
    [tokens.common.representative_email_required]: '대표자 이메일은 필수 입니다',
    [tokens.common.same_as_representative_info]: '대표자 정보 동일',
    [tokens.common.representative_full_name]: '대표자명',
    [tokens.common.representative_contact_info]: '대표자연락처',
    [tokens.common.representative_name_short]: '대표자이름',
    [tokens.common.see_more]: '더보기',
    [tokens.common.data_too_large_for_excel_download]: '데이터가 많아서 엑셀 다운로드가 어렵습니다',
    [tokens.common.data_invalid]: '데이터가 유효하지 않습니다',
    [tokens.common.door_lock]: '도어락',
    [tokens.common.arrival_location_code]: '도착 로케이션 코드',
    [tokens.common.arrival_center]: '도착센터',
    [tokens.common.destination]: '도착지',
    [tokens.common.destination_contact_name_prompt]: '도착지 담당자명은 50자리 이하로 입력해주세요',
    [tokens.common.destination_contact_name_max_length]: '도착지 담당자명은 최고 2자리를 입력해주세요',
    [tokens.common.destination_contact_name_required]: '도착지 담당자명을 필수로 입력해주세요',
    [tokens.common.destination_center_required]: '도착지 센터를 필수로 선택해주세요',
    [tokens.common.destination_contact_required]: '도착지 연락처를 필수로 입력해주세요',
    [tokens.common.destination_information]: '도착지 정보',
    [tokens.common.destination_address]: '도착지 주소',
    [tokens.common.destination_center]: '도착지센터',
    [tokens.common.dock_number]: '도크 번호',
    [tokens.common.dongicheon]: '동이천',
    [tokens.common.same_purchase_vendor_settlement]: '동일한 매입처의 매입 내역만 정산서 생성이 가능합니다 확인 후 다시 선택해 주시기 바랍니다',
    [tokens.common.same_sales_vendor_assigned]: '동일한 발주처({{salesPlace}})가 배정되어 있습니다',
    [tokens.common.same_brand_sales_only]: '동일한 브랜드 내 연결 발주처에 한하여 가능합니다',
    [tokens.common.cannot_select_same_time]: '동일한 시간을 선택할 수 없습니다 다시 선택해 주세요',
    [tokens.common.registration]: '등록',
    [tokens.common.registration_completed]: '등록 되었습니다',
    [tokens.common.registered_product]: '등록 상품',
    [tokens.common.registered_product_order_history_excel_download]: '등록 상품 주문 내역 엑셀 다운로드',
    [tokens.common.registration_edit]: '등록/수정',
    [tokens.common.registration_confirmation_needed]: '등록 후 반드시 확인',
    [tokens.common.no_registered_corporation]: '등록된 거래법인이 없습니다',
    [tokens.common.no_registered_notifications]: '등록된 공지사항이 없습니다',
    [tokens.common.no_registered_locations]: '등록된 로케이션이 없습니다',
    [tokens.common.no_registered_managers]: '등록된 매니저가 없습니다',
    [tokens.common.no_registered_sales_clients]: '등록된 발주처가 없습니다',
    [tokens.common.no_registered_brands]: '등록된 거래처가 없습니다',
    [tokens.common.no_registered_consultation_history]: '등록된 상담이력이 없습니다',
    [tokens.common.no_registered_product_regulations]: '등록된 상품 규제가 존재하지 않습니다',
    [tokens.common.no_registered_products]: '등록된 상품이 없습니다',
    [tokens.common.no_registered_faqs]: '등록된 자주 묻는 질문이 없습니다',
    [tokens.common.no_registered_inventory_history]: '등록된 재고 이력이 없습니다',
    [tokens.common.no_registered_inventory_adjustment_history]: '등록된 재고 조정 내역이 없습니다',
    [tokens.common.no_registered_inventory_items]: '등록된 재고 항목이 없습니다',
    [tokens.common.no_registered_inventory_audit_history]: '등록된 재고조사 내역이 없습니다',
    [tokens.common.no_registered_inventory_audit_items]: '등록된 재고조사 항목이 없습니다',
    [tokens.common.registration_date]: '등록일',
    [tokens.common.registration_timestamp]: '등록일시',
    [tokens.common.registrant]: '등록자',
    [tokens.common.careful_before_registration]: '등록전에 신중히 고려 후 등록해주세요',
    [tokens.common.label]: '라벨',
    [tokens.common.label_generation]: '라벨 생성',
    [tokens.common.no_label_generation_or_quantity_invalid]: '라벨 생성할 대상이 없거나 라벨 수량을 으로 입력한 것은 발행하지 않습니다',
    [tokens.common.label_quantity]: '라벨 수량',
    [tokens.common.label_quantity_count]: '라벨수 개',
    [tokens.common.label_reprint]: '라벨 재출력',
    [tokens.common.label_printing]: '라벨 출력',
    [tokens.common.print_label]: '라벨을 출력 하시겠습니까?',
    [tokens.common.label_print_button]: '[PLT라벨 출력] 버튼으로 라벨 생성 작업을 하십시요',
    [tokens.common.label_code]: '라벨 코드',
    [tokens.common.number_of_labels]: '라벨수',
    [tokens.common.route]: '라우트',
    [tokens.common.route_management]: '라우트 관리',
    [tokens.common.route_list]: '라우트 리스트',
    [tokens.common.route_assignment]: '라우트 배정',
    [tokens.common.route_assignment_completed]: '라우트 배정이 완료 되었습니다',
    [tokens.common.route_deletion]: '라우트 삭제',
    [tokens.common.route_details]: '라우트 상세',
    [tokens.common.route_selection]: '라우트 선택',
    [tokens.common.route_addition]: '라우트 추가',
    [tokens.common.no_route]: '라우트가 없습니다',
    [tokens.common.route_deletion_confirmation]: '라우트를 삭제하시겠습니까',
    [tokens.common.route_name]: '라우트명',
    [tokens.common.route_name_entry]: '라우트명을 입력하고 저장해주세요',
    [tokens.common.route_name_required]: '라우트명을 입력해주세요',
    [tokens.common.route_assignment_short]: '라우트배정',
    [tokens.common.lag]: '렉',
    [tokens.common.log_out]: '로그아웃',
    [tokens.common.log_out_button]: '로그아웃 시 이 버튼을 눌러주세요',
    [tokens.common.location_management]: '로케이션 관리',
    [tokens.common.location_classification]: '로케이션 구분',
    [tokens.common.location_zone]: '로케이션 구역',
    [tokens.common.location_label_printing]: '로케이션 라밸 출력',
    [tokens.common.location_label_reprinting]: '로케이션 라벨 재출력',
    [tokens.common.location_label_printing_short]: '로케이션 라벨 출력',
    [tokens.common.location_list]: '로케이션 리스트',
    [tokens.common.location_alias]: '로케이션 명칭',
    [tokens.common.location_barcode_scan]: '로케이션 바코드를 찍고 로케이션 정보를 등록해주세요',
    [tokens.common.location_details]: '로케이션 상세',
    [tokens.common.location_option]: '로케이션 옵션',
    [tokens.common.location_position]: '로케이션 위치',
    [tokens.common.location_auto_sort]: '로케이션 위치 순으로 자동 정렬 됩니다',
    [tokens.common.location_name]: '로케이션 이름',
    [tokens.common.location_name_input]: '로케이션 이름 입력',
    [tokens.common.location_name_prompt]: '로케이션 이름을 입력해주세요',
    [tokens.common.location_add]: '로케이션 추가',
    [tokens.common.location_code]: '로케이션 코드',
    [tokens.common.location_code_product_name]: '로케이션 코드 상품명',
    [tokens.common.location_label_code]: '로케이션라벨 코드',
    [tokens.common.location_label_location_code]: '로케이션라벨 코드 로케이션 코드',
    [tokens.common.location_status]: '로케이션상태',
    [tokens.common.location_disposal_qty]: '로케이션의 폐기 예정 수량만 표시',
    [tokens.common.location_address]: '로케이션주소',
    [tokens.common.create_prompt]: '를 생성해주세요',
    [tokens.common.select_prompt]: '를 선택해주세요',
    [tokens.common.exclude_shipment_processed]: '를 제외한 출고를 정상 출고 처리 했습니다',
    [tokens.common.lead_time]: '리드타임',
    [tokens.common.lead_time_prevention]: '리드타임 이면 당일입고 막기 위함',
    [tokens.common.lead_time_required]: '리드타임은 필수 입니다',
    [tokens.common.input_only]: '만 입력',
    [tokens.common.word]: '말',
    [tokens.common.end_of_month]: '말일',
    [tokens.common.tax_and_non_tax]: '면/과세',
    [tokens.common.tax]: '과세',
    [tokens.common.non_tax]: '면세',
    [tokens.common.manager]: '매니저',
    [tokens.common.manager_search]: '매니저 검색',
    [tokens.common.manager_management]: '매니저 관리',
    [tokens.common.manager_registration]: '매니저 등록',
    [tokens.common.manager_detail]: '매니저 상세',
    [tokens.common.manager_selection]: '매니저 선택',
    [tokens.common.manager_update]: '매니저 수정',
    [tokens.common.manager_name]: '매니저 이름',
    [tokens.common.manager_name_contact]: '매니저 이름 / 연락처',
    [tokens.common.manager_name_below_limit]: '매니저 이름은 50자리 이하로 입력해주세요',
    [tokens.common.manager_name_above_limit]: '매니저 이름은 최고 2자리를 입력해주세요',
    [tokens.common.manager_name_required]: '매니저 이름을 필수로 입력해주세요',
    [tokens.common.manager_phone]: '매니저, 전화번호',
    [tokens.common.manager_info]: '매니저 정보',
    [tokens.common.manager_management_overview]: '매니저관리',
    [tokens.common.search_select_manager]: '매니저를 검색/선택 해주세요',
    [tokens.common.register_manager_prompt]: '매니저를 등록 해주세요',
    [tokens.common.select_manager_prompt]: '매니저를 선택해주세요',
    [tokens.common.select_manager_required]: '매니저를 필수로 선택해주세요',
    [tokens.common.manager_name_label]: '매니저명',
    [tokens.common.manager_name_alternate]: '매니저이름',
    [tokens.common.manager_save]: '매니저저장',
    [tokens.common.manager_info_overview]: '매니저정보',
    [tokens.common.every_month]: '매월',
    [tokens.common.settlement_start_date]: '매월 정산이 시작되는 기준일',
    [tokens.common.purchase_period]: '매입 기간',
    [tokens.common.purchase_details]: '매입 내역',
    [tokens.common.purchase_count]: '매입 내역 갯수',
    [tokens.common.purchase_positive_details]: '매입 양수 내역',
    [tokens.common.no_purchase_positive_details]: '매입 양수 내역이 존재하지 않습니다',
    [tokens.common.purchase_settlement]: '매입 정산',
    [tokens.common.purchase_invoice_resend_complete]: '매입 정산서 메일 재전송이 완료 되었습니다',
    [tokens.common.purchase_invoice_delete]: '매입 정산서 삭제',
    [tokens.common.purchase_invoice_delete_complete]: '매입 정산서 삭제가 완료 되었습니다',
    [tokens.common.purchase_invoice_edit_complete]: '매입 정산서 수정이 완료되었습니다',
    [tokens.common.purchase_invoice_confirm_all]: '매입 정산서 일괄 확정',
    [tokens.common.purchase_invoice_confirm]: '매입 정산서 확인',
    [tokens.common.purchase_invoice_finalize]: '매입 정산서 확정',
    [tokens.common.purchase_invoice_finalize_complete]: '매입 정산서 확정이 완료 되었습니다',
    [tokens.common.total_purchase_amount]: '매입 후 총 금액',
    [tokens.common.price]: '판매가',
    [tokens.common.purchase_price]: '판매가',
    [tokens.common.purchase_price_taxable]: '판매가 / 과세여부',
    [tokens.common.purchase_price_change]: '판매가 변경',
    [tokens.common.bulk_purchase_price_change]: '매입가 변경 대량 등록은 한 번에 최대 {{totalBulkPurchasePriceChange}}개 까지 가능합니다',
    [tokens.common.purchase_price_change_warning]:
        '매입가 변경 시 재고수불부 정산 등 데이터 오류에 영향을 미칠 수 있으니 꼭 필요한 경우에 한해서 다시 한번 확인 후 처리하시기 바랍니다',
    [tokens.common.purchase_price_reservation]: '판매가 변경 예약',
    [tokens.common.purchase_price_reservation_details]: '판매가 변경 예약 내역',
    [tokens.common.no_purchase_price_reservation_details]: '판매가 변경 예약 내역이 없습니다',
    [tokens.common.bulk_purchase_price_reservation]: '판매가 변경 예약 대량 등록',
    [tokens.common.purchase_price_reservation_complete]: '판매가 변경 예약이 완료되었습니다',
    [tokens.common.purchase_price_registration]: '판매가 예약 등록',
    [tokens.common.bulk_purchase_price_change_file]: '판매가 일괄 변경 예약 Excel 파일',
    [tokens.common.bulk_purchase_price_edit]: '판매가 일괄 수정',
    [tokens.common.bulk_purchase_price_reservation_complete]: '판매가 일괄 예약 등록이 완료 되었습니다',
    [tokens.common.bulk_purchase_price_adjustment]: '판매가 일괄 조정',
    [tokens.common.purchase_price_input]: '판매가 입력',
    [tokens.common.purchase_price_required]: '판매가는 필수입니다',
    [tokens.common.purchase_price_can_not_minus]: '판매가는 음수일 수 없습니다',
    [tokens.common.purchase_cost]: '매입원가',
    [tokens.common.purchase_settlement_details]: '매입정산내역이 존재하지 않습니다',
    [tokens.common.empty_page_purchase_history]: '입고 내역이 존재하지 않습니다',
    [tokens.common.purchaser]: '브랜드',
    [tokens.common.purchaser_id]: '브랜드 ID',
    [tokens.common.purchaser_search]: '브랜드 검색',
    [tokens.common.purchaser_holiday_registration]: '매입처 공휴일 등록',
    [tokens.common.purchaser_management]: '브랜드 관리',
    [tokens.common.purchaser_buyer]: '브랜드 / 담당자',
    [tokens.common.purchaser_liability_amount]: '매입처 귀책 금액',
    [tokens.common.purchaser_liability_amount_currency]: '매입처 귀책 금액 원',
    [tokens.common.purchaser_liability_return]: '매입처 귀책 의 경우 귀책금액으로 반품내역이 생성됩니다',
    [tokens.common.purchaser_same_standard]: '매입처 기준동일',
    [tokens.common.purchaser_contact]: '브랜드 담당자',
    [tokens.common.purchaser_contact_info]: '브랜드 담당자 정보',
    [tokens.common.purchaser_contact_info_1]: '브랜드 담당자 1) 정보',
    [tokens.common.purchaser_contact_info_2]: '브랜드 담당자 2) 정보',
    [tokens.common.purchaser_registration]: '브랜드 등록',
    [tokens.common.purchaser_deadline_adjustment]: '브랜드 마감시간 일괄 조정',
    [tokens.common.no_purchaser_list]: '브랜드 목록이 존재하지 않습니다',
    [tokens.common.purchaser_selection]: '브랜드 선택',
    [tokens.common.purchaser_edit]: '브랜드 수정',
    [tokens.common.purchaser_incoming_schedule]: '브랜드 입고 예정서 일재고',
    [tokens.common.purchaser_info]: '브랜드 정보',
    [tokens.common.purchaser_holiday_registration_complete]: '브랜드 휴일 등록이 완료 되었습니다',
    [tokens.common.purchaser_holiday_deletion_complete]: '브랜드 휴일삭제가 완료 되었습니다',
    [tokens.common.purchaser_holiday_info]: '브랜드 휴일정보',
    [tokens.common.purchaser_required]: '브랜드는 필수 입니다',
    [tokens.common.purchaser_manager]: '브랜드담당자',
    [tokens.common.search_select_purchaser]: '브랜드를 검색 선택 해주세요',
    [tokens.common.purchaser_visibility_toggle]: '{{purchaserForExposureOrNo}}브랜드를 정말 {{exposureOrNo}} 전환 하시겠습니까',
    [tokens.common.purchaser_name]: '브랜드명',
    [tokens.common.purchaser_name_required]: '브랜드명은 필수입니다',
    [tokens.common.purchaser_name_duplicate]: '브랜드명이 중복되었습니다',
    [tokens.common.no_items_registered_in_purchaser]: '브랜드에 등록된 상품이 없습니다',
    [tokens.common.purchaser_direct_delivery]: '브랜드에서 각 업장으로 직배송',
    [tokens.common.purchaser_info_overview]: '브랜드정보',
    [tokens.common.sales_reflection]: '매출 반영',
    [tokens.common.no_sales_report]: '매출 신고 내역이 존재하지 않습니다',
    [tokens.common.sales_report_pending]: '매출 신고 대기 내역',
    [tokens.common.sales_transfer]: '매출 이관',
    [tokens.common.sales_invoice]: '매출 정산서',
    [tokens.common.sales_invoice_updated]: '매출 정산서 갱신이 완료 되었습니다',
    [tokens.common.sales_invoice_resend_complete]: '매출 정산서 메일 재전송이 완료 되었습니다',
    [tokens.common.sales_invoice_deleted]: '매출 정산서 삭제',
    [tokens.common.sales_invoice_delete_complete]: '매출 정산서 삭제가 완료 되었습니다',
    [tokens.common.sales_invoice_confirm_all]: '매출 정산서 일괄 확정',
    [tokens.common.sales_invoice_finalize]: '매출 정산서 확정',
    [tokens.common.sales_invoice_finalize_complete]: '매출 정산서 확정이 완료 되었습니다',
    [tokens.common.sales_price_reservation]: '매출가 일괄 변경 • 예약',
    [tokens.common.sales_price_edit_excel_file]: '매출가 일괄 수정 - Excel 파일',
    [tokens.common.unit_sales_price_management]: '매출단가 관리',
    [tokens.common.unit_sales_price_reservation]: '매출단가 변경 예약 등록은 한 번에 최대 {{maxUnitSalesPriceReservation}}개 까지 가능합니다',
    [tokens.common.unit_sales_price_bulk_change]: '매출단가 일괄 변경',
    [tokens.common.unit_sales_price_bulk_complete]: '매출단가 일괄 변경 등록이 완료되었습니다',
    [tokens.common.unit_sales_price_query]: '매출단가 조회',
    [tokens.common.reflection_of_sales]: '매출반영',
    [tokens.common.sales_transfer_order_selection]: '매출이관 대상 주문을 하나 이상 선택하세요',
    [tokens.common.sales_transfer_irreversible]:
        '매출이관 완료 시 원복은 불가하며, 수관 발주처 정산 내 반영 청구 되오니 다시 한 번 확인 후 처리하시기 바랍니다.',
    [tokens.common.sales_profit_margin_1]: '매출이익률',
    [tokens.common.sales_settlement_details]: '매출정산내역이 존재하지 않습니다',
    [tokens.common.customer]: '발주처',
    [tokens.common.customer_id]: '발주처 ID',
    [tokens.common.customer_search]: '발주처 검색',
    [tokens.common.customer_management]: '발주처 관리',
    [tokens.common.customer_purchasing_agent]: '발주처 구매처 작업자',
    [tokens.common.customer_classification_brand]: '발주처 구분 / 브랜드',
    [tokens.common.customer_classification_type]: '발주처 구분 / 업태 / 업종',
    [tokens.common.customer_classification_required]: '발주처 구분은 필수 입니다',
    [tokens.common.customer_driver_contact]: '발주처 기사연락처 기사명 배정 라우트',
    [tokens.common.customer_contact]: '발주처 담당자 연락처',
    [tokens.common.customer_contact_name]: '발주처 담당자 이름',
    [tokens.common.customer_contact_email]: '발주처 담당자 이메일',
    [tokens.common.customer_contact_info]: '발주처 담당자 정보',
    [tokens.common.customer_contact_info_1]: '발주처 담당자 1) 정보',
    [tokens.common.customer_contact_info_2]: '발주처 담당자 2) 정보',
    [tokens.common.customer_bulk_registration_limit]: '발주처 대량 등록은 한 번에 최대 {{customerBulkRegistrationLimit}}개 까지 가능합니다',
    [tokens.common.customer_bulk_registration_complete]: '발주처 대량 등록이 완료 되었습니다',
    [tokens.common.customer_registration]: '발주처 등록',
    [tokens.common.customer_bulk_registration]: '발주처 등록 - 대량',
    [tokens.common.customer_route_management]: '발주처 라우트 추가 / 삭제는 12시~19시 내에서만 가능합니다',
    [tokens.common.customer_list_2]: '발주처 리스트',
    [tokens.common.customer_virtual_account]: '발주처 발주처 가상계좌번호',
    [tokens.common.customer_return_exchange_code]: '발주처 발주처 반품 교환코드 상세 내용',
    [tokens.common.customer_business_id]: '발주처 발주처 사업자 번호',
    [tokens.common.customer_representative]: '발주처 발주처 사업자번호 대표자',
    [tokens.common.customer_consultation_notes]: '발주처 발주처 상담 내용',
    [tokens.common.customer_details]: '발주처 발주처 상세 내용',
    [tokens.common.customer_address]: '발주처 발주처 주소',
    [tokens.common.customer_delivery_date]: '발주처 배송일',
    [tokens.common.customer_brand]: '발주처 브랜드',
    [tokens.common.customer_selection]: '발주처 선택',
    [tokens.common.customer_edit_registration]: '발주처 수정 발주처 등록',
    [tokens.common.customer_avg_monthly_order]: '발주처 월 평균 총 주문금액',
    [tokens.common.customer_info]: '발주처 정보',
    [tokens.common.customer_info_bulk_adjustment]: '발주처 정보 일괄 조정',
    [tokens.common.customer_info_excel_file]: '발주처 정보 Excel 파일',
    [tokens.common.customer_settlement]: '발주처 정산',
    [tokens.common.customer_total_refund]: '발주처 총 환불 금액',
    [tokens.common.customer_addition]: '발주처 추가',
    [tokens.common.customer_refund_amount]: '발주처 환불 금액',
    [tokens.common.customer_classification]: '발주처구분',
    [tokens.common.search_select_customer]: '발주처를 검색/선택 해주세요',
    [tokens.common.customer_selection_required]: '발주처를 선택하여 주시기 바랍니다',
    [tokens.common.customer_selection_prompt]: '발주처를 선택해주세요',
    [tokens.common.customer_add_prompt]: '발주처를 추가 해주세요',
    [tokens.common.customer_name]: '발주처명',
    [tokens.common.customer_name_entry_limit]: '발주처명은 50자리 이하로 입력하여 주십시오',
    [tokens.common.customer_name_required]: '발주처명은 필수 입니다',
    [tokens.common.customer_name_duplicate]: '발주처명이 중복되었습니다',
    [tokens.common.number_of_sales_outlets]: '발주처수',
    [tokens.common.customer_preorder_cancellation]: '발주처에서 사전에 주문한 내역은 취소되지 않습니다',
    [tokens.common.customer_order_handling]: '발주처에서 상품 주문 시',
    [tokens.common.customer_inbound_routing]: '발주처의 출차 센터별 지정된 입고 센터로 상품이 입고 됩니다',
    [tokens.common.menu_delete]: '메뉴 삭제',
    [tokens.common.menu_delete_success]: '메뉴 삭제에 성공 하였습니다',
    [tokens.common.menu_create_success]: '메뉴 생성에 성공 하였습니다',
    [tokens.common.memo]: '메모',
    [tokens.common.message_required]: '메시지 내용은 필수입니다',
    [tokens.common.message_input_prompt]: '메시지 내용을 입력하세요',
    [tokens.common.delete_success]: '삭제에 성공 하였습니다',
    [tokens.common.document]: '문서',
    [tokens.common.logistic_code]: '물류코드',
    [tokens.common.select_checkbox_list]: '목록 체크 박스 선택',
    [tokens.common.non_payment]: '미납',
    [tokens.common.non_payment_price]: '미납 {{nonPaymentPrice}} 원',
    [tokens.common.return_history]: '반품 내역',
    [tokens.common.return_type]: '반품 유형',
    [tokens.common.return_code]: '반품 코드',
    [tokens.common.return_quantity]: '반품 수량',
    [tokens.common.return_reason]: '반품 사유',
    [tokens.common.empty_page_return_history]: '반품 내역이 존재하지 않습니다',
    [tokens.common.report_return_quantity]: '반환량',
    [tokens.common.occurrence_date]: '발생일',
    [tokens.common.purchase.order]: '발주',
    [tokens.common.purchase.order_possible_days]: '발주 가능 요일',
    [tokens.common.purchase.order_holidays_registration]: '발주 가능 요일 외 별도 공휴일을 등록합니다',
    [tokens.common.purchase.order_classification]: '발주 구분',
    [tokens.common.purchase.order_classification_required]: '발주 구분은 필수 입니다',
    [tokens.common.purchase.order_amount]: '발주 금액',
    [tokens.common.purchase.order_details]: '발주 내역',
    [tokens.common.purchase.order_details_not_available]: '발주 내역이 없습니다',
    [tokens.common.purchase.order_unit]: '발주 단위',
    [tokens.common.purchase.order_request_sent_to_supplier]: '발주 등록 시 해당 상품의 매입처로 발주 요청서 가 발송 됩니다',
    [tokens.common.purchase.order_lead_time]: '발주 리드타임',
    [tokens.common.purchase.order_deadline_time]: '발주 마감 시간',
    [tokens.common.purchase.order_expired_warning]: '발주 마감시간이 지난 상품이 포함되어 있습니다 발주 상품을 다시 확인해주시기 바랍니다',
    [tokens.common.purchase.order_multiple_units]: '발주 배수',
    [tokens.common.purchase.order_products]: '발주 상품',
    [tokens.common.purchase.order_product_classification]: '발주 상품 구분',
    [tokens.common.purchase.order_inactive_product_warning]: '발주 상품 중 미사용 중인 상품이 포함되어 있습니다 계속 발주를 진행 하시겠습니까',
    [tokens.common.purchase.order_quantity_input]: '발주 수량 입력',
    [tokens.common.purchase.order_request_information]: '발주 요청 정보',
    [tokens.common.purchase.order_request_form_details]: '발주 요청서 상세',
    [tokens.common.purchase.order_request_form_edit]: '발주 요청서 수정',
    [tokens.common.purchase.order_request_form_edit_to_supplier]: '발주 요청서 수정 시 해당 상품의 매입처로',
    [tokens.common.purchase.order_request_form_updated]: '발주 요청서가 수정 되었습니다',
    [tokens.common.purchase.order_request_form_selection]: '발주 요청서를 선택해 주세요',
    [tokens.common.purchase.order_request_date]: '발주 요청일',
    [tokens.common.purchase.order_warehouse_receipt_settings]: '발주/입고 설정',
    [tokens.common.purchase.order_warehouse_receipt_check_required]: '발주/입고 설정은 한개 이상 체크되어야 합니다',
    [tokens.common.purchase.order_warehouse_receipt_time_required]: '발주/입고 센터 설정 시, 상품 입고 센터/입고 예정시간은 필수 입니다',
    [tokens.common.purchase.order_receipt_quantity]: '발주 입고 시 입수량',
    [tokens.common.purchase.order_receipt_information]: '발주 입고 정보',
    [tokens.common.purchase.order_information]: '발주 정보',
    [tokens.common.purchase.order_view_permission]: '발주 조회 허용',
    [tokens.common.purchase.order_cancellation_1]: '발주 취소',
    [tokens.common.purchase.order_cancellation_include_history]: '발주 취소 내역 포함',
    [tokens.common.purchase.order_notes]: '발주 특이사항',
    [tokens.common.purchase.order_available]: '발주가능 상품구분',
    [tokens.common.purchase.order_available_days_select]: '발주가능 요일 선택',
    [tokens.common.purchase.order_available_days_required]: '발주가능 요일은 필수입니다',
    [tokens.common.purchase.ordering_category]: '발주구분',
    [tokens.common.purchase.ordering_calendar]: '발주달력',
    [tokens.common.purchase.deadline_for_ordering_weekend_minutes_required]: '발주마감(주말) -분은 필수 입니다',
    [tokens.common.purchase.deadline_for_ordering_weekend_hours_required]: '발주마감(주말) -시간은 필수 입니다',
    [tokens.common.purchase.deadline_for_ordering_weekday_minutes_required]: '발주마감(평일) -분은 필수 입니다',
    [tokens.common.purchase.deadline_for_ordering_weekday_hours_required]: '발주마감(평일) 시간은 필수 입니다',
    [tokens.common.purchase.order_multiple]: '발주배수',
    [tokens.common.purchase.order_status]: '발주상태',
    [tokens.common.purchase.order_quantity]: '발주수량',
    [tokens.common.purchase.order_quantity_unit]: '발주수량/단위',
    [tokens.common.purchase.order_quantity_order_unit]: '발주수량 / 발주단위',
    [tokens.common.purchase.order_request]: '발주요청',
    [tokens.common.purchase.order_request_cancellation_available]: '발주요청 상태만 발주 취소가 가능합니다',
    [tokens.common.purchase.order_request_internal_states]: '발주요청 상태코드 내부 발주요청 발주취소 입고대기 입고확인 입고완료 입고확정',
    [tokens.common.purchase.order_request_form_search]: '발주요청서 검색',
    [tokens.common.purchase.order_request_form_select]: '발주요청서 선택',
    [tokens.common.purchase.order_request_form_code]: '발주요청서 코드',
    [tokens.common.purchase.order_request_date_select]: '발주요청일 선택',
    [tokens.common.purchase.order_date]: '발주일',
    [tokens.common.purchase.order_date_lead_time]: '발주일{{purchaseLeadDay}}로부터 센터 입고까지 소요 기간',
    [tokens.common.purchase.order_date_and_time]: '발주일시',
    [tokens.common.purchase.orderer]: '발주자',
    [tokens.common.purchase.orderer_search]: '발주자 검색',
    [tokens.common.purchase.orderer_select_prompt]: '발주자 검색/선택 해주세요',
    [tokens.common.purchase.orderer_information]: '발주자 정보',
    [tokens.common.purchase.order_cancellation_2]: '발주취소',
    [tokens.common.purchase.order_cancellation_confirmed]: '발주취소가 완료 되었습니다',
    [tokens.common.purchase.ordering_code]: '수주번호',
    [tokens.common.purchase.ordering_code_product]: '발주코드 발주상품',
    [tokens.common.publication_date]: '발행일',
    [tokens.common.date_of_publication]: '발행일자',
    [tokens.common.banner_photo]: '배너사진',
    [tokens.common.delivery]: '배송',
    [tokens.common.delivery_driver_phone]: '배송 기사 전화번호',
    [tokens.common.delivery_person_in_charge]: '배송 담당자',
    [tokens.common.delivery_manager]: '배송 매니저',
    [tokens.common.delivery_cost]: '배송 비용',
    [tokens.common.delivery_photo]: '배송 사진',
    [tokens.common.delivery_no_photo]: '배송 사진이 없습니다',
    [tokens.common.delivery_entry_method_1]: '배송 시 진입 방법',
    [tokens.common.delivery_expected_date]: '배송 예정일',
    [tokens.common.delivery_completed]: '배송 완료',
    [tokens.common.delivery_no_completion_records]: '배송 완료 내역이 없습니다',
    [tokens.common.delivery_day_selection_1]: '배송 요일 선택',
    [tokens.common.delivery_day_adjustment]: '배송 요일 조정',
    [tokens.common.delivery_day_required]: '배송 요일은 필수 입니다',
    [tokens.common.delivery_information]: '배송 정보',
    [tokens.common.delivery_departure_info]: '배송 출차지 정보',
    [tokens.common.delivery_notes]: '배송 특이사항',
    [tokens.common.delivery_schedule_day]: '배송 형태 / 배송 요일',
    [tokens.common.delivery_type_selection]: '배송 형태 선택',
    [tokens.common.delivery_center_departure]: '배송 형태 / 출차 센터',
    [tokens.common.delivery_person_selection]: '배송담당자 선택',
    [tokens.common.delivery_manager_line_code]: '배송매니저 간선코드',
    [tokens.common.delivery_non_delivery_days]: '배송불가 요일',
    [tokens.common.non_delivery_days]: '배송불가요일',
    [tokens.common.delivery_photo_confirmation]: '배송사진을 확인할 수 있습니다',
    [tokens.common.delivery_status]: '배송상태',
    [tokens.common.delivery_quantity]: '배송수량',
    [tokens.common.delivery_excess_quantity]: '배송수량 초과',
    [tokens.common.expected_delivery_date]: '배송예정일',
    [tokens.common.delivery_complete]: '배송완료',
    [tokens.common.delivery_complete_unsettled_orders_only]: '배송완료 및 매출정산 미반영 주문만 가능합니다',
    [tokens.common.delivery_partial]: '배송완료 부분배송',
    [tokens.common.delivery_loaded]: '배송완료 상차완료',
    [tokens.common.delivery_issue_unprocessable]: '배송완료와 정상 상태 건 이슈 처리 불가',
    [tokens.common.delivery_completion_datetime]: '배송완료일시',
    [tokens.common.delivery_completed_date]: '배송완료일',
    [tokens.common.delivery_day]: '배송요일',
    [tokens.common.delivery_day_selection_2]: '배송요일 선택',
    [tokens.common.delivery_type]: '배송유형',
    [tokens.common.delivery_vehicle_number]: '배송유형 / 차량번호',
    [tokens.common.delivery_date]: '배송일',
    [tokens.common.delivery_date_return_policy]: '배송일이 현재 월과 달라 반품 교환 접수가 불가합니다',
    [tokens.common.shipper]: '배송자',
    [tokens.common.preparing_for_delivery]: '배송준비중',
    [tokens.common.in_delivery]: '배송중',
    [tokens.common.delivery_address_photo_upload]: '배송지 사진 업로드',
    [tokens.common.delivery_address_photo_attachment]: '배송지 사진 첨부',
    [tokens.common.delivery_address]: '배송지 주소',
    [tokens.common.delivery_address_direct_input]: '배송지 주소 직접 입력',
    [tokens.common.delivery_address_required]: '배송지 주소는 필수 입니다',
    [tokens.common.postal_code_must_be_7_digits]: '우편번호는 7자리만 입력 가능합니다',
    [tokens.common.delivery_address_photo]: '배송지 첨부 사진',
    [tokens.common.shipping_address_road_name]: '배송지기본주소(도로명)',
    [tokens.common.shipping_address_jibun]: '배송지기본주소(지번)',
    [tokens.common.detailed_delivery_address]: '배송지상세주소',
    [tokens.common.shipping_address_zip_code]: '배송지우편번호',
    [tokens.common.delivery_address_same_check]: '배송지주소동일여부',
    [tokens.common.delivery_entry_method_2]: '배송진입방법',
    [tokens.common.special_delivery_information]: '배송특이사항',
    [tokens.common.delivery_form]: '배송형태',
    [tokens.common.delivery_form_required]: '배송형태는 필수 입니다',
    [tokens.common.number_of_deliveries]: '배송횟수',
    [tokens.common.drainage]: '배수',
    [tokens.common.drainage_order]: '배수 발주',
    [tokens.common.assignment]: '배정',
    [tokens.common.assignment_route]: '배정 라우트',
    [tokens.common.assignment_sales_location]: '배정 발주처',
    [tokens.common.assignment_datetime]: '배정일시',
    [tokens.common.assignment_date_selection]: '배정일자 선택',
    [tokens.common.assignor]: '배정자',
    [tokens.common.arrangement_success]: '배치 실행 성공',
    [tokens.common.arrangement_failure]: '배치 실행 실패 했습니다',
    [tokens.common.placement_confirmation]: '배치를 실행 하시겠습니까 기존 실행되는 시간대에 실행하지 않는 경우에는 문제가 발생 할 수 있습니다',
    [tokens.common.placement_prompt]: '배치를 실행하시겠습니까',
    [tokens.common.button_document_add]: '버튼을 클릭하여 문서 추가 (20MB 이하, 최대 10개)',
    [tokens.common.button_photo_add]: '버튼을 클릭하여 사진 추가 ({{lessCapacity}}이하 최대 {{maxFileCount}}개)',
    [tokens.common.button_file_upload]: '버튼을 클릭하여 파일을 업로드 하세요',
    [tokens.common.button_event]: '버튼이벤트',
    [tokens.common.number_1]: '번호',
    [tokens.common.universal_product]: '범용 상품',
    [tokens.common.bay]: '베이',
    [tokens.common.bay_rack]: '베이 / 렉',
    [tokens.common.change]: '변경',
    [tokens.common.change_amount_input]: '변경 금액 입력',
    [tokens.common.change_purchase_price]: '변경 판매가',
    [tokens.common.change_reason]: '변경 사유',
    [tokens.common.change_reason_input]: '변경 사유 입력',
    [tokens.common.change_cancel_ignore]: '변경 사항을 무시하고 취소 하시겠습니까',
    [tokens.common.change_no_modifications]: '변경 사항이 없습니다',
    [tokens.common.change_not_applied]: '변경 사항이 적용되지 않습니다 변경 사항을 무시하고 취소 하시겠습니까',
    [tokens.common.change_not_effective]: '변경 사항이 적용되지 않았습니다',
    [tokens.common.change_reservation]: '변경 예약',
    [tokens.common.change_expected_purchase_margin]: '변경 예정 구매 이익율',
    [tokens.common.change_expected_date]: '변경 예정일',
    [tokens.common.change_history_purchase_price]: '변경 이력 매입가',
    [tokens.common.change_datetime]: '변경 일시',
    [tokens.common.change_effective_date_1]: '변경 적용일',
    [tokens.common.change_effective_date_limit]: '변경 적용일은 [당일 +1] 로부터 최대 3개월까지 가능합니다',
    [tokens.common.change_effective_date_required]: '변경 적용일은 필수입니다',
    [tokens.common.change_before]: '변경 전',
    [tokens.common.change_before_amount]: '변경 전 금액',
    [tokens.common.change_immediate_settlement]: '변경 즉시 정산금액이 수정됩니다 계속 저장 하시겠습니까',
    [tokens.common.change_departure_center_selection]: '변경 출차 센터 선택',
    [tokens.common.change_category]: '변경 카테고리',
    [tokens.common.change_sales_margin]: '변경 판매 이익율',
    [tokens.common.change_after]: '변경 후',
    [tokens.common.change_after_amount]: '변경 후 금액',
    [tokens.common.changed_no_records]: '변경된 내역이 없습니다',
    [tokens.common.changed_no_changes]: '변경된 사항이 없습니다',
    [tokens.common.changed_credit_limit_reset]: '변경된 여신 한도 금액은 변경 전 금액까지 결제가 되면 자동 원복 됩니다',
    [tokens.common.change_reservation_deleted]: '변경예약 삭제가 완료 되었습니다',
    [tokens.common.change_reservation_completed]: '변경예약이 완료 되었습니다',
    [tokens.common.change_completed]: '변경이 완료 되었습니다',
    [tokens.common.change_history]: '변경이력',
    [tokens.common.changer]: '변경자',
    [tokens.common.change_effective_date_2]: '변경적용일',
    [tokens.common.change_amount_variation]: '변동 금액',
    [tokens.common.change_rate]: '변동율',
    [tokens.common.conversion]: '변환 수량',
    [tokens.common.conversion_quantity]: '변환수량',
    [tokens.common.custody_inventory]: '보관 재고',
    [tokens.common.storage_inventory]: '보관재고',
    [tokens.common.storage_inventory_receiving_center]: '(보관재고)입고센터',
    [tokens.common.storage_inventory_auto_order_status]: '(보관재고)자동발주여부',
    [tokens.common.storage_inventory_no_auto_order]: '보관재고는 자동발주를 선택할 수 없습니다',
    [tokens.common.storage_inventory_quantity]: '보관재고량',
    [tokens.common.storage_order_cancel_possible]: '보관재고만 발주 취소가 가능합니다',
    [tokens.common.supplement_quantity]: '보충 수량',
    [tokens.common.supplement_order]: '보충 지시',
    [tokens.common.supplement_order_list]: '보충 지시 리스트',
    [tokens.common.supplementary_quantity]: '보충수량',
    [tokens.common.value_added_tax]: '소비세',
    [tokens.common.partially_not_received]: '부분미입고',
    [tokens.common.partial_delivery]: '부분배송',
    [tokens.common.partial_loading_unloading]: '부분상차 미상차',
    [tokens.common.partial_completion]: '부분완료',
    [tokens.common.inventory_slump]: '부진 재고',
    [tokens.common.inventory_date]: '재고일자',
    [tokens.common.no_sluggish_inventory]: '부진재고가 없습니다',
    [tokens.common.minute]: '분',
    [tokens.common.minute_input_limit]: '00 ~ 59분 까지 입력해주세요',
    [tokens.common.classification]: '분류',
    [tokens.common.location_distribution]: '분배 로케이션',
    [tokens.common.location_distribution_info]: '분배 로케이션 정보',
    [tokens.common.unnecessary]: '불필요',
    [tokens.common.brand]: '거래처',
    [tokens.common.brand_search]: '거래처 검색',
    [tokens.common.brand_contract_end]: '거래처 계약종료 시 하위 발주처도 모두 계약종료 됩니다',
    [tokens.common.brand_management]: '브랜드 관리',
    [tokens.common.brand_exposure_products]: '거래처 노출상품',
    [tokens.common.brand_contact_info]: '거래처 담당자 1) 정보',
    [tokens.common.brand_contact_info_2]: '거래처 담당자 2) 정보',
    [tokens.common.brand_registration]: '거래처 등록',
    [tokens.common.brand_revenue_percentage]: '브랜드 매출액의',
    [tokens.common.brand_business_number]: '브랜드 브랜드 사업자번호 대표자',
    [tokens.common.brand_selection]: '거래처 선택',
    [tokens.common.brand_edit]: '브랜드 수정',
    [tokens.common.brand_information_1]: '거래처 정보',
    [tokens.common.brand_settlement]: '거래처 정산',
    [tokens.common.brand_settlement_classification]: '거래처 정산 구분',
    [tokens.common.brand_settlement_payment_date]: '거래처 정산 기준 / 결제일',
    [tokens.common.brand_no_settlement_records]: '브랜드 정산내역이 존재하지 않습니다',
    [tokens.common.brand_statement_resent]: '브랜드 정산서 메일 재전송이 완료 되었습니다',
    [tokens.common.brand_statement_batch_confirm]: '브랜드 정산서 일괄 확정',
    [tokens.common.brand_statement_confirmed]: '브랜드 정산서 확정이 완료 되었습니다',
    [tokens.common.brand_ID_1]: '거래처 ID',
    [tokens.common.brand_mandatory]: '거래처는 필수 입니다',
    [tokens.common.brand_manager]: '브랜드담당자',
    [tokens.common.brand_search_prompt]: '거래처를 검색/선택 해주세요',
    [tokens.common.brand_name]: '거래처명',
    [tokens.common.brand_name_length_limit]: '거래처명은 자리 이하로 입력하여 주십시오',
    [tokens.common.brand_name_mandatory]: '거래처명은 필수 입니다',
    [tokens.common.brand_name_duplicate]: '거래처명이 중복되었습니다',
    [tokens.common.brand_ID_2]: '거래처아이디',
    [tokens.common.brand_information_2]: '브랜드정보',
    [tokens.common.note]: '비고',
    [tokens.common.note_requests]: '비고 요청사항',
    [tokens.common.password]: '비밀번호',
    [tokens.common.password_input]: '비밀번호 입력',
    [tokens.common.password_mismatch_1]: '비밀번호가 일치하지 않습니다',
    [tokens.common.password_match_1]: '비밀번호가 일치합니다',
    [tokens.common.password_registration_condition]: '비밀번호가 일치해야 등록 가능합니다',
    [tokens.common.password_enter_prompt]: '비밀번호를 입력해주세요',
    [tokens.common.expense]: '비용',
    [tokens.common.cost_input_prompt]: '비용을 입력해주세요',
    [tokens.common.non_member]: '비회원',
    [tokens.common.non_member_consultation_history]: '비회원 상담이력만 보기',
    [tokens.common.business_registration_address]: '사업등록증 상 주소',
    [tokens.common.business_registration_number_1]: '사업자 등록번호',
    [tokens.common.business_number_duplicate_1]: '사업자 등록번호가 중복되었습니다',
    [tokens.common.business_number_length]: '사업자 등록번호는 13자리입니다',
    [tokens.common.business_number_mandatory]: '사업자 등록번호는 필수 입니다',
    [tokens.common.business_registration_number_length]: '사업자 등록자번호는 자리입니다',
    [tokens.common.business_registration_zip_code]: '사업자 등록증상 우편번호',
    [tokens.common.business_number]: '사업자 번호',
    [tokens.common.business_name_registration]: '사업자 상호',
    [tokens.common.business_name_number_registration]: '사업자 상호 / 등록번호',
    [tokens.common.business_name_length_limit]: '사업자 상호는 30자리 이하로 입력하여 주십시오',
    [tokens.common.business_name_mandatory]: '사업자 상호는 필수 입니다',
    [tokens.common.business_name_input_prompt]: '사업자 상호를 입력해주세요',
    [tokens.common.business_name_required]: '사업자 상호명은 필수 입니다.',
    [tokens.common.business_name_mandatory_full]: '사업자 상호명은 30자리 이하로 입력하여 주십시오',
    [tokens.common.business_name_duplicate_1]: '사업자 상호명이 중복되었습니다',
    [tokens.common.business_type_1]: '사업자 유형',
    [tokens.common.business_registration_number_2]: '사업자등록번호',
    [tokens.common.business_number_duplicate_2]: '사업자등록번호가 중복되었습니다',
    [tokens.common.business_registration_address_standard]: '사업자등록증 상 주소',
    [tokens.common.business_registration_address_same]: '사업자등록증 상 주소 동일',
    [tokens.common.business_registration_address_mandatory]: '사업자등록증 상 주소는 필수 입니다',
    [tokens.common.business_registration_road_name]: '사업자등록증상도로명',
    [tokens.common.business_registration_detailed_address]: '사업자등록증상상세주소',
    [tokens.common.business_registration_jibun]: '사업자등록증상지번',
    [tokens.common.business_number_input_limit]: '사업자번호 10자리를 입력해주세요',
    [tokens.common.business_number_mandatory_input]: '사업자번호를 필수로 입력해주세요',
    [tokens.common.business_name]: '사업자상호',
    [tokens.common.business_name_duplicate_2]: '사업자상호가 중복되었습니다',
    [tokens.common.business_name_label]: '사업자상호명',
    [tokens.common.business_type_2]: '사업자유형',
    [tokens.common.use]: '사용',
    [tokens.common.exceed_storage_rate]: '사용 적치율 초과',
    [tokens.common.use_conversion]: '사용 전환',
    [tokens.common.use_status]: '사용여부',
    [tokens.common.user_selection]: '사용자 선택',
    [tokens.common.username]: '사용자명',
    [tokens.common.user_information]: '사용자정보',
    [tokens.common.use_conversion_unuse]: '사용전환 미사용 전환',
    [tokens.common.in_use]: '사용중',
    [tokens.common.reason]: '사유',
    [tokens.common.reason_content]: '사유 내용',
    [tokens.common.reason_detail_input]: '사유 상세 입력',
    [tokens.common.reason_selection]: '사유 선택',
    [tokens.common.reason_input]: '사유 입력',
    [tokens.common.reason_input_confirmation]: '사유 입력 확정 처리',
    [tokens.common.reason_mandatory]: '사유는 필수 입니다',
    [tokens.common.reason_selection_prompt]: '사유를 선택하세요',
    [tokens.common.enter_reason]: '사유입력',
    [tokens.common.excel_file]: 'EXCEL 파일',
    [tokens.common.picture]: '사진',
    [tokens.common.picture_upload]: '사진 업로드',
    [tokens.common.delete]: '삭제',
    [tokens.common.deleted]: '삭제 되었습니다',
    [tokens.common.delete_complete]: '삭제 완료',
    [tokens.common.delete_completed]: '삭제가 완료되었습니다',
    [tokens.common.delete_status]: '삭제여부',
    [tokens.common.mountainous_district]: '산지',
    [tokens.common.acknowledged_above_content]: '상기 내용을 확인했습니다',
    [tokens.common.top_summary]: '상단 요약',
    [tokens.common.counsel_category]: '상담 구분',
    [tokens.common.counsel_details]: '상담 내역',
    [tokens.common.no_counsel_details]: '상담 내역이 없습니다',
    [tokens.common.counsel_content]: '상담 내용',
    [tokens.common.counsel_content_required]: '상담 내용은 필수입니다',
    [tokens.common.counsel_registration]: '상담 등록',
    [tokens.common.counsel_detail]: '상담 상세',
    [tokens.common.counsel_status_change_completed]: '상담 상태 변경이 완료 되었습니다',
    [tokens.common.counsel_type]: '상담 유형',
    [tokens.common.counsel_type_detail_required]: '상담 유형 상세는 필수입니다',
    [tokens.common.counsel_type_required]: '상담 유형은 필수입니다',
    [tokens.common.counsel_datetime]: '상담 일시',
    [tokens.common.counsel_processing_datetime]: '상담(처리) 일시',
    [tokens.common.counsel_processing_date]: '상담(처리) 일자',
    [tokens.common.consultation_category]: '상담구분',
    [tokens.common.consultation_details]: '상담내용',
    [tokens.common.consultation_details_enter]: '상담내용을 입력하세요',
    [tokens.common.consultation_type]: '상담유형',
    [tokens.common.consultation_type_selection]: '상담유형을 선택하세요',
    [tokens.common.consultation_date]: '상담일',
    [tokens.common.consultation_datetime]: '상담일시',
    [tokens.common.consultation_status_datetime]: '상담일시 / 상태',
    [tokens.common.counselor]: '상담자',
    [tokens.common.counselor_selection]: '상담자 선택',
    [tokens.common.particular]: '상세',
    [tokens.common.particular_details]: '상세 내역',
    [tokens.common.particular_content]: '상세 내용',
    [tokens.common.particular_content_required]: '상세 내용은 필수입니다',
    [tokens.common.particular_content_enter]: '상세 내용을 입력해주세요',
    [tokens.common.particular_reason_enter]: '상세 사유를 입력해주세요',
    [tokens.common.particular_edit]: '상세 수정',
    [tokens.common.particular_address]: '상세 주소',
    [tokens.common.detailed_reason]: '상세사유',
    [tokens.common.detailed_type]: '상세유형',
    [tokens.common.detailed_type_selection]: '상세유형을 선택하세요',
    [tokens.common.details_information]: '상세정보',
    [tokens.common.detailed_address_required]: '상세주소는 필수 입니다',
    [tokens.common.loading_inspection]: '상차 검수중',
    [tokens.common.loading_waiting]: '상차 대기',
    [tokens.common.loading_in_progress]: '상차 대기중',
    [tokens.common.no_loading_jobs]: '상차 대기중인 작업이 없습니다',
    [tokens.common.loading_ready]: '상차 준비 완료 & 입차 지시',
    [tokens.common.loading_inspection_datetime]: '상차검수일시',
    [tokens.common.situation]: '상태',
    [tokens.common.situation_change]: '상태 변경',
    [tokens.common.situation_change_completed]: '상태 변경이 완료 되었습니다',
    [tokens.common.situation_selection]: '상태 선택',
    [tokens.common.register_in_state]: '상태로 등록',
    [tokens.common.goods]: '상품',
    [tokens.common.goods_id]: '상품 ID',
    [tokens.common.goods_individual_registration]: '상품 개별 등록',
    [tokens.common.goods_search_popup]: '상품 검색 팝업',
    [tokens.common.goods_management]: '상품 관리',
    [tokens.common.lot_management]: 'LOT 관리',
    [tokens.common.package_management]: '패키지 관리',
    [tokens.common.package_registration]: '패키지 등록',
    [tokens.common.update_package]: '패키지 수정',
    [tokens.common.package]: '패키지',
    [tokens.common.goods_search]: '상품 조회',
    [tokens.common.package_component_goods_list]: '구성상품리스트',
    [tokens.common.package_component_goods_required]: '패키지 구성상품은 필수입니다',
    [tokens.common.composition_code]: '구성코드',
    [tokens.common.composition_code_select]: '구성코드 선택',
    [tokens.common.config_code_outbound_instruction]: '구성코드 출고 지시',
    [tokens.common.confirm_config_code_shipment]: '{{count}}건의 주문을 출고 지시합니다.',
    [tokens.common.bulk_inspection_single_outbcnt_only]: '일괄 검수는 하나의 출고회차만 가능합니다.',
    [tokens.common.bulk_inspection_by_outbcnt_confirm]: '출고회차 {{outbCnt}} 전체를 일괄 검수합니다.',
    [tokens.common.bulk_inspection_search_outbcnt]: '출고회차를 검색하거나 항목을 선택해주세요.',
    [tokens.common.bulk_inspection_with_invoice_confirm]: '송장 일괄 출력도 같이 하시겠습니까?',
    [tokens.common.normal_inspection_outbound_complete]: '일반검수 출고완료',
    [tokens.common.batch_inspection_outbound_complete]: '일괄검수 출고완료',
    [tokens.common.existing_outbound_complete]: '기존 출고완료',
    [tokens.common.outbound_complete_irreversible_warning]: '출고완료 처리는 되돌릴 수 없습니다.',
    [tokens.common.outbound_complete_target_count]: '대상 주문: {{count}}건',
    [tokens.common.outbound_complete_confirm]: '{{count}}건의 주문을 출고완료 처리합니다. 되돌릴 수 없습니다.',
    [tokens.common.select_outbound_round]: '출고회차를 선택해주세요',
    [tokens.common.no_outbound_complete_target]: '출고완료 가능한 대상이 없습니다.',
    [tokens.common.partial_inspection_warning]: '부분검수 {{partialCount}}건 / 미검수 {{notInspectedCount}}건이 포함되어 있습니다. 검수 완료된 {{completedCount}}건만 출고완료 처리됩니다.',
    [tokens.common.not_allowed_order_code]: '선택한 주문에 포함되지 않는 피킹코드입니다.',
    [tokens.common.please_select_order]: '주문을 선택해주세요.',
    [tokens.common.package_type]: '패키지타입',
    [tokens.common.package_id]: '패키지ID',
    [tokens.common.package_code]: '패키지코드',
    [tokens.common.package_name]: '패키지명',
    [tokens.common.package_type_required]: '패키지타입 선택은 필수입니다',
    [tokens.common.package_name_required]: '패키지명은 필수입니다',
    [tokens.common.no_registered_packages]: '등록된 패키지가 없습니다.',
    [tokens.common.goods_regulation_management]: '상품 규제 관리',
    [tokens.common.goods_regulation_registration_completed]: '상품 규제 등록이 완료 되었습니다',
    [tokens.common.goods_period_regulation_bulk_registration]: '상품 기간 규제 대량 등록',
    [tokens.common.goods_period_regulation_registration]: '상품 기간 규제 등록',
    [tokens.common.goods_date_excel]: '상품 날짜 구분 엑셀',
    [tokens.common.contact_goods_manager]: '상품 담당자에게 문의해주세요',
    [tokens.common.goods_bulk_registration]: '상품 대량 등록',
    [tokens.common.goods_bulk_registration_limit]: '상품 대량 등록은 한 번에 최대 {{totalGoodsBulkRegistration}}개 까지 가능합니다',
    [tokens.common.goods_bulk_registration_completed]: '상품 대량 등록이 완료 되었습니다',
    [tokens.common.lot_bulk_registration]: 'LOT 대량 등록',
    [tokens.common.lot_bulk_registration_limit]: 'LOT 대량 등록은 한 번에 최대 {{totalGoodsBulkRegistration}}개 까지 가능합니다',
    [tokens.common.inbound_expected_bulk_registration_completed]: '입고예정서 일괄 등록이 완료 되었습니다.',
    [tokens.common.goods_bulk_edit]: '상품 대량 수정',
    [tokens.common.goods_bulk_expected_inbound]: '입고예정서 일괄 등록',
    [tokens.common.goods_second_image]: '상품 두번째 이미지',
    [tokens.common.goods_bulk_register]: '상품 등록 - 대량',
    [tokens.common.goods_inbound_expected_bulk_register]: '입고예정서 일괄 등록',
    [tokens.common.goods_list_deletion_restriction]: '상품 목록이 있을 경우 삭제 할 수 없습니다',
    [tokens.common.no_goods_list]: '상품 목록이 존재하지 않습니다',
    [tokens.common.goods_order_notes]: '상품 및 발주 특이사항',
    [tokens.common.goods_order]: '상품 발주',
    [tokens.common.goods_order_completed]: '상품 발주가 완료 되었습니다',
    [tokens.common.goods_inbound_plan_completed]: '입고 예정서 등록이 완료 되었습니다',
    [tokens.common.goods_photo]: '상품 사진',
    [tokens.common.goods_photo_registration]: '상품 사진 등록',
    [tokens.common.goods_photo_upload]: '상품 사진 업로드',
    [tokens.common.goods_photo_notes]: '상품 사진・특이사항',
    [tokens.common.goods_status]: '상품 상태',
    [tokens.common.goods_status_change_completed]: '상품 상태 변경이 완료되었습니다',
    [tokens.common.goods_status_batch_change]: '상품 상태 일괄 변경',
    [tokens.common.goods_lot_delete_change]: '상품 LOT 일괄 삭제 ',
    [tokens.common.goods_status_change_restriction]: '상품 상태를 사용 으로 바꿀 수 없는 상품이 존재합니다',
    [tokens.common.goods_product]: '상품',
    [tokens.common.goods_name]: '상품명',
    [tokens.common.goods_product_name_supplier]: '상품 상품명 매입처 매입처',
    [tokens.common.goods_selection]: '상품 선택',
    [tokens.common.goods_selection_then_input]: '상품 선택 후 입력',
    [tokens.common.goods_count]: '상품 수',
    [tokens.common.goods_edit_register]: '상품 수정 상품 등록',
    [tokens.common.goods_start_end_date]: '상품 시작일 종료일',
    [tokens.common.goods_type_brand]: '상품 유형 / 브랜드',
    [tokens.common.goods_type_required]: '상품 유형은 필수 입니다',
    [tokens.common.sku_code_required]: 'SKU 코드는 필수 입니다',
    [tokens.common.goods_batch_edit]: '상품 일괄 수정',
    [tokens.common.goods_batch_info_change_completed]: '상품 일괄정보 변경이 완료 되었습니다',
    [tokens.common.goods_receiving]: '상품 입고',
    [tokens.common.goods_receiving_center]: '상품 입고 센터',
    [tokens.common.goods_exposure_settings]: '상품 전체 노출 설정',
    [tokens.common.goods_info_file]: '상품 정보 EXCEL 파일',
    [tokens.common.lot_info_file]: 'LOT 정보 EXCEL 파일',
    [tokens.common.goods_order_unit]: '상품 주문 단위',
    [tokens.common.goods_order_unit_specification]: '상품 주문 단위 / 규격',
    [tokens.common.goods_order_unit_required]: '상품 주문 단위는 필수 입니다',
    [tokens.common.goods_order_unit_conversion_quantity_input]: '상품 주문 단위에 따른 {{quantityAccordingToUnit}} 변환 수량 입력',
    [tokens.common.goods_order_unit_spec]: '상품 주문단위 규격',
    [tokens.common.goods_first_image]: '상품 첫번째 이미지',
    [tokens.common.goods_additional_edit]: '상품 추가/수정',
    [tokens.common.goods_category]: '상품 카테고리',
    [tokens.common.goods_category_change]: '상품 카테고리 변경',
    [tokens.common.goods_category_sales_margin_change_record]: '상품 카테고리별 판매 이익율 변경 내역',
    [tokens.common.goods_category_sales_margin_setting]: '상품 카테고리별 판매 이익율 설정',
    [tokens.common.goods_category_sales_margin_set]: '상품 카테고리별 판매 이익율을 설정 합니다',
    [tokens.common.goods_item_code_product_name]: '상품 타품목코드 상품명',
    [tokens.common.goods_particulars]: '상품 특이사항',
    [tokens.common.goods_temperature_1]: '상품 품온',
    [tokens.common.goods_temperature_2]: '품온',
    [tokens.common.goods_temperature_origin]: '상품 품온 / 원산지',
    [tokens.common.goods_temperature_required]: '상품 품온은 필수 입니다',
    [tokens.common.product_specifications]: '상품규격',
    [tokens.common.product_name]: '상품명',
    [tokens.common.product_name_input]: '상품명 입력',
    [tokens.common.product_name_length_limit]: '상품명은 {{productNameLengthLimit}}자 이내로 작성하여 주십시오',
    [tokens.common.product_name_required]: '상품명은 필수 입니다',
    [tokens.common.split_string_info]: '구분자(,)로 다중검색',
    [tokens.common.barcode]: '상품 바코드',
    [tokens.common.enter_barcode]: '상품 바코드 입력',
    [tokens.common.enter_sku_code]: 'SKU 코드 입력',
    [tokens.common.enter_goodsIrCd]: '센터관리코드 입력',
    [tokens.common.product_number]: '상품번호',
    [tokens.common.product_adjustment_by_item_reason]: '상품별 조정 금액 조정 사유',
    [tokens.common.product_adjustment_case]: '상품별 조정금액인 경우',
    [tokens.common.product_order_details]: '상품별 주문내역',
    [tokens.common.product_order_details_excel_download]: '상품별 주문내역 엑셀 다운로드',
    [tokens.common.product_status]: '상품상태',
    [tokens.common.product_selection]: '상품선택',
    [tokens.common.lot_bulk_register]: 'LOT 등록 - 대량',
    [tokens.common.number_of_products]: '상품수 개',
    [tokens.common.product_id]: '상품아이디',
    [tokens.common.product_id_details]: '상품아이디 상품명 매입가 권장판매가설정구분 구매이익율 고정가 권장판매가 변경적용일',
    [tokens.common.total_sku_count]: '총SKU수',
    [tokens.common.total_quantity]: '전체수량',
    [tokens.common.product_type]: '상품유형',
    [tokens.common.product_exposure_switch_prompt]: '상품을 정말 {{exposureOrNo}} 전환 하시겠습니까',
    [tokens.common.product_exposure_priority]: '상품의 판매가 매출가 는 아래의 우선순위에 따라 자동으로 노출 됩니다',
    [tokens.common.setting_overall_product_exposure]: '상품전체노출설정',
    [tokens.common.product_information]: '상품정보',
    [tokens.common.product_order_unit]: '상품주문단위',
    [tokens.common.product_category_code]: '상품카테고리코드',
    [tokens.common.product_code]: '상품코드',
    [tokens.common.mutual]: '상호',
    [tokens.common.repayment]: '상환',
    [tokens.common.refresh]: '새로고침',
    [tokens.common.sprout]: '새싹',
    [tokens.common.sprout_customer_emergency_shipment_only]: '새싹 고객 긴급출고 이력만 보기',
    [tokens.common.sprout_customer_return_exchange_only]: '새싹 고객 & 반품 교환 이력만 보기',
    [tokens.common.sprout_customer_consultation_history_only]: '새싹 고객 상담이력만 보기',
    [tokens.common.sprout_customers_only]: '새싹 고객만 보기',
    [tokens.common.sprout_customer_claims_only]: '새싹고객 클레임만 보기',
    [tokens.common.omission]: '생략',
    [tokens.common.generation]: '생성',
    [tokens.common.creation_completed]: '생성이 완료 되었습니다',
    [tokens.common.creation_date]: '생성일',
    [tokens.common.constructor]: '생성자',
    [tokens.common.document_upload]: '서류 업로드',
    [tokens.common.server_error]: '서버 에러',
    [tokens.common.invalid_data_from_server]: '서버에서 유효하지 않은 데이터를 받았습니다',
    [tokens.common.seo_hwaseong]: '서화성',
    [tokens.common.pre_order_inventory_deduction_period]: '선주문 재고차감 기간',
    [tokens.common.pre_order_print]: '선주문 출력',
    [tokens.common.pre_order_inventory_deduction_period_setting]: '선주문재고차감기간',
    [tokens.common.elected_high_school]: '선출고',
    [tokens.common.inbound_expected_bulk_registration_limit]: '입고예정서 일괄 등록은 한 번에 최대 {{cnt}}개 까지 가능합니다.',
    [tokens.common.warning_invalid_early_shipment_day_goods]: '[물류코드: {{logisticCodeForEarlyShipment}}] - 일재고 상품은 선출고 할 수 없습니다',
    [tokens.common.elected_high_school_work_order]: '선출고 작업지시',
    [tokens.common.elected_high_school_instruction_completed]: '선출고 지시 완료 되었습니다',
    [tokens.common.elected_high_school_irreversible_warning]: '선출고 지시 후에는 되돌릴 수 없으며 금일 출고작업 단계로 넘어갑니다',
    [tokens.common.notice_of_election]: '선출고지시',
    [tokens.common.select]: '선택',
    [tokens.common.select_details]: '선택 내역',
    [tokens.common.not_selected_orders]: '선택되지 않은 주문',
    [tokens.common.not_selected_order_check]: '선택되지 않은 주문이 있습니다 다시 확인 해주세요',
    [tokens.common.no_selected_details]: '선택된 내역이 없습니다',
    [tokens.common.selected_products_regulation_end]: '선택된 상품들이 즉시 규제 종료 처리 됩니다',
    [tokens.common.selected_departure_center_no_supplier]: '선택된 출차지센터에 연결된 매입처가 없습니다',
    [tokens.common.selected_departure_center_no_products]: '선택된 출차지센터에 연결된 상품이 없습니다',
    [tokens.common.selected_product_exposure_switch_prompt]: '선택하신 {{totalGoodsExposureOrNo}}개 상품을 정말 {{exposureOrNo}} 전환 하시겠습니까?',
    [tokens.common.selected_total_goods_for_early_shipment]:
        '선택하신 {{totalGoodsForEarlyShipment}} 개의 상품을 선출고 지시 하시겠습니까? 선출고 지시 후에는 되돌릴 수 없으며, 금일 출고작업 단계로 넘어갑니다',
    [tokens.common.selected_product_label_print]: '선택하신 개의 상품에 대해 라벨 을 출력 하시겠습니까',
    [tokens.common.selected_product_label_printing]: '선택하신 {{totalGoodsForPrintingLabel}}개의 상품에 대해 라벨 을 출력하시겠습니까',
    [tokens.common.selected_product_total_quantity_picking]: '선택하신 {{totalGoods}} 개의 주문에 대해 총량 피킹지 를 출력 하시겠습니까',
    [tokens.common.selected_location_label_reprint]: '선택하신 로케이션 라벨 을 재출력하시겠습니까',
    [tokens.common.selected_label_reprint]: '이미 출력된 라벨입니다. 해당 상품의 라벨을 재출력하시겠습니까?',
    [tokens.common.selected_supplier_exposure_switch_prompt]:
        '선택하신 {{totalPurchaserExposureOrNo}}개 매입처를 정말 {{exposureOrNo}} 전환 하시겠습니까?',
    [tokens.common.selected_order_handling_warning]:
        '선택하신 발주 내역이 입하 처리 되고 입고 확인서가 발행되며 이후에는 수정이 불가합니다 그래도 정말 강제 입고를 등록 하시겠습니까',
    [tokens.common.selected_purchase_price_change_date]: '선택하신 일자에 매입가 권장 판매가가 자동으로 변경됩니다',
    [tokens.common.selected_statement_update]: '선택하신 정산서를 갱신합니다 진행하시겠습니까',
    [tokens.common.selected_statement_delete]: '선택하신 정산서를 삭제합니다',
    [tokens.common.selected_statement_batch_confirm]: '선택하신 정산서를 일괄 확정 처리 합니다',
    [tokens.common.selected_statement_confirm]: '선택하신 정산서를 확정 처리 합니다',
    [tokens.common.selected_order_all_delivery_complete]: '선택하신 주문 건이 모두 배송완료 처리 되고 원복이 불가 합니다',
    [tokens.common.selected_notice_password_entry]: '선택한 {{totalSelectedNotice}}건의 공지사항 노출을 종료하려면 비밀번호를 입력하세요',
    [tokens.common.setting_save]: '설정 저장',
    [tokens.common.success]: '성공',
    [tokens.common.success_forced_entry_complete]: '강제 입하처리가 완료 되었습니다',
    [tokens.common.sector]: '섹터',
    [tokens.common.sector_select_prompt]: '섹터를 선택해주세요',
    [tokens.common.center]: '센터',
    [tokens.common.center_selection]: '센터 선택',
    [tokens.common.center_lead_time]: '센터 입고 리드타임',
    [tokens.common.center_registration_required]: '센터 입고설정 등록이 필요 합니다',
    [tokens.common.center_information]: '센터 정보',
    [tokens.common.center_info_retrieval]: '센터 정보 가져오기',
    [tokens.common.center_add_prompt]: '센터를 추가 해주세요',
    [tokens.common.center_name]: '센터명',
    [tokens.common.center_specific_conditions]: '센터별 세부 출고 조건을 설정해주세요',
    [tokens.common.center_new_product_storage_conditions]:
        '센터의 신규상품(보관재고) 세부 입고 조건을 설정해주세요 \n 시간당 입고량은 짝수로 입력해주세요',
    [tokens.common.subcategory]: '소분류',
    [tokens.common.subcategory_addition_requirement]: '소분류 카테고리 추가시 대 중분류는 필수입니다',
    [tokens.common.subcategory_required]: '소분류 카테고리는 필수입니다',
    [tokens.common.subcategories_required]: '소분류는 필수 입니다',
    [tokens.common.consumption_period]: '유통 기한',
    [tokens.common.consumption_period_select]: '유통 기한을 선택해 주세요',
    [tokens.common.lot_no_select]: 'LOT 번호를 선택해 주세요',
    [tokens.common.expiration_date]: '유통기한',
    [tokens.common.expiration_date_option]: '유통기한 기재 여부',
    [tokens.common.expiration_date_deadline]: '유통기한 마지노선',
    [tokens.common.expiration_date_deadline_preorder]: '유통기한 마지노선 선주문 재고차감',
    [tokens.common.expiration_date_adjustment_preorder_inventory]:
        '유통기한 마지노선 변경 시 재고 로스가 발생할 수 있으니 설정한 기간에 따라 선주문 상품의 가용재고가 차감 됩니다',
    [tokens.common.expiration_date_deadline_preorder_period]: '유통기한 마지노선 선주문 재고차감 기간',
    [tokens.common.expiration_date_input_required]: '유통기한 입력 - 선택된 발주 요청서가 없습니다',
    [tokens.common.expiration_date_remaining_days]: '유통기한 잔여일',
    [tokens.common.expiration_date_remaining_days_query]: '유통기한 잔여일 조회',
    [tokens.common.expiration_date_adjustment]: '유통기한 조정',
    [tokens.common.expiration_date_addition]: '유통기한 추가',
    [tokens.common.expiration_date_indicated]: '유통기한기재여부',
    [tokens.common.consumption_period_limit]: '유통기한마지노선',
    [tokens.common.expiration_date_specific_inventory]: '유통기한별 재고 상세',
    [tokens.common.time_taken]: '소요시간',
    [tokens.common.loss_recovery]: '손망실 복구',
    [tokens.common.loss_processing]: '손망실 처리',
    [tokens.common.loss_amount]: '손실금액',
    [tokens.common.number_2]: '수',
    [tokens.common.water_channel_select_required]: '수관 발주처 선택은 필수 입니다',
    [tokens.common.manual_order]: '수기 발주',
    [tokens.common.manual]: '수동',
    [tokens.common.quantity]: '수량',
    [tokens.common.quantity_unit_specification]: '수량 / 단위 / 규격',
    [tokens.common.quantity_input]: '수량 입력',
    [tokens.common.quantity_required]: '수량은 필수 입니다',
    [tokens.common.enter_quantity]: '수량입력',
    [tokens.common.recipient_or_storage_location_input]: '수령자 또는 보관 위치 입력',
    [tokens.common.reception_contact]: '수신 연락처',
    [tokens.common.recipient]: '수신자',
    [tokens.common.recipient_number]: '수신자 번호',
    [tokens.common.recipient_selection]: '수신자 선택',
    [tokens.common.recipient_max_limit]: '수신자는 최대 {{recipientMaxCount}}명까지 가능합니다',
    [tokens.common.recipient_required]: '수신자는 필수입니다',
    [tokens.common.recipient_name]: '수신자명',
    [tokens.common.import_country_code]: '수입국가코드',
    [tokens.common.import_declaration_number]: '수입신고번호',
    [tokens.common.modification]: '수정',
    [tokens.common.modification_completed]: '수정 되었습니다',
    [tokens.common.modification_registration]: '수정 등록',
    [tokens.common.modification_history]: '수정 이력',
    [tokens.common.modification_addition]: '수정 추가',
    [tokens.common.modification_history_absent]: '수정이력이 없습니다',
    [tokens.common.modification_datetime]: '수정일시',
    [tokens.common.modifier]: '수정자',
    [tokens.common.edit_setting]: '수정정보를 위한 세팅',
    [tokens.common.edit_item]: '수정항목',
    [tokens.common.turn_order]: '순번',
    [tokens.common.enter_number]: '숫자',
    [tokens.common.enter_number_prompt]: '숫자로 입력하여 주십시오',
    [tokens.common.numbers_only_prompt]: '숫자만 입력하세요',
    [tokens.common.enter_numbers_prompt]: '숫자입력',
    [tokens.common.city]: '시',
    [tokens.common.enter_city_prompt]: '00 ~ 23시 까지 입력해주세요',
    [tokens.common.hour]: '시간',
    [tokens.common.hourly_intake_even]: '시간당 입고량은 짝수이어야 합니다',
    [tokens.common.hourly_intake_required]: '시간당 입고량은 필수입니다',
    [tokens.common.system_default_setting]: '시스템 기본 설정 : D + {{shlfDay}} 일',
    [tokens.common.start_time_future_constraint]: '시작시간은 종료시간의 미래시간을 선택할 수 없습니다',
    [tokens.common.start_date]: '시작일',
    [tokens.common.start_date_required]: '시작일은 필수 입니다',
    [tokens.common.report_date]: '신고일',
    [tokens.common.new_registration]: '신규 등록',
    [tokens.common.reenter_new_password]: '신규 비밀번호를 재 입력 해주세요',
    [tokens.common.new_password]: '신규 패스워드',
    [tokens.common.enter_new_password]: '신규 패스워드를 입력해주세요',
    [tokens.common.application_datetime]: '신청일시',
    [tokens.common.application_date]: '신청일자',
    [tokens.common.actual_stock]: '실 재고',
    [tokens.common.actual_stock_quantity]: '실 재고 수량',
    [tokens.common.actual_delivery]: '실배송 수량',
    [tokens.common.actual_delivery_quantity]: '실배송수량',
    [tokens.common.real_picture_expiration]: '실사 유통기한',
    [tokens.common.real_picture_quantity]: '실사 수량',
    [tokens.common.room_temperature]: '실온',
    [tokens.common.actual_inventory]: '실재고',
    [tokens.common.actual_inventory_quantity]: '실재고 수량',
    [tokens.common.actual_order_process]: '실제 발주는 상품의 판매 단위로 진행됩니다',
    [tokens.common.actual_received_quantity]: '실제입고수량',
    [tokens.common.failure]: '실패',
    [tokens.common.not_confirmed_statement_included]: '미확정 정산서가 아닌 정산서가 포함되어 있습니다. 다시 선택해주시기 바랍니다',
    [tokens.common.confirmed_statement_included]: '미확정 정산서가 포함되어 있습니다. 다시 선택해주시기 바랍니다',
    [tokens.common.execution]: '실행',
    [tokens.common.print_all_labels_under_condition]: '아래 조건의 주문 라벨을 모두 출력합니다',
    [tokens.common.release_all_orders_under_condition]: '아래 조건의 주문이 모두 출고 지시 됩니다',
    [tokens.common.print_all_bulk_picking_under_condition]: '아래 조건의 총량 피킹지를 모두 출력합니다',
    [tokens.common.guide]: '안내',
    [tokens.common.anpyeong]: '안평',
    [tokens.common.nighttime]: '야간',
    [tokens.common.food_download_form]: '양식 다운로드',
    [tokens.common.yesterday]: '어제',
    [tokens.common.upload_success]: '업로드 성공',
    [tokens.common.industry_is_required]: '업종은 필수 입니다',
    [tokens.common.industry_code]: '업종코드',
    [tokens.common.company_name]: '업체명',
    [tokens.common.company_type]: '업체유형',
    [tokens.common.company_code]: '업체코드',
    [tokens.common.business_status]: '업태 / 업종',
    [tokens.common.business_type_is_required]: '업태는 필수 입니다',
    [tokens.common.business_status_code]: '업태코드',
    [tokens.common.not_exist]: '없음',
    [tokens.common.error]: '에러',
    [tokens.common.error_retrieving_virtual_account_list]: '에러 가상 계좌 목록을 가져오는 중 문제가 발생했습니다',
    [tokens.common.error_occurred]: '에러 발생',
    [tokens.common.error_invalid_data_from_server]: '에러 서버에서 유효하지 않은 데이터를 받았습니다',
    [tokens.common.excel_download_image]: '엑셀 다운로드 이미지',
    [tokens.common.excel_file_download_request]: '엑셀 파일 다운로드는 개발자에게 요청해주세요',
    [tokens.common.excel_only]: '엑셀만 가능',
    [tokens.common.tsv_only]: 'TSV 파일만 올릴 수 있습니다 (.tsv, .txt)',
    [tokens.common.goddess_credit_status]: '여신(채권) 상태',
    [tokens.common.goddess_limit_adjustment_warning]: '여신 한도 조정 시 손실 회수 가능성이 발생 할 수 있으니 주의 하시기 바랍니다',
    [tokens.common.goddess_credit_limit]: '여신 한도금액',
    [tokens.common.goddess_insufficient_credit]:
        '여신이 부족한 발주처나 재고가 부족한 상품이 포함되어 있습니다 다시 확인 후 업로드 해주시기 바랍니다',
    [tokens.common.credit_limit]: '여신한도',
    [tokens.common.credit_limit_amount_required]: '여신한도 금액은 필수입니다',
    [tokens.common.credit_limit_in_currency]: '여신한도 원',
    [tokens.common.connected_sales_source]: '연결 발주처',
    [tokens.common.consolidated_sales_source]: '연결발주처',
    [tokens.common.related_code]: '연관코드',
    [tokens.common.related_code_length_limit]: '연관코드는 자를 넘을 수 없습니다',
    [tokens.common.contact]: '연락처',
    [tokens.common.contact_information_required]: '연락처는 필수입니다',
    [tokens.common.enter_required_contact_information]: '연락처를 필수로 입력해주세요',
    [tokens.common.heat]: '열 단',
    [tokens.common.heat_column]: '열 열',
    [tokens.common.key]: '열쇠/카드키',
    [tokens.common.sales_representative_corporate]: '영업 담당자 / 거래법인',
    [tokens.common.sales_manager]: '영업담당자',
    [tokens.common.sales_manager_corporate]: '영업담당자 / 거래법인',
    [tokens.common.sales_manager_search]: '영업담당자 검색',
    [tokens.common.sales_manager_selection_required]: '영업담당자 선택은 필수 입니다',
    [tokens.common.sales_manager_info]: '영업담당자 정보',
    [tokens.common.sales_manager_not_found]: '영업담당자가 존재하지 않습니다',
    [tokens.common.select_sales_manager]: '영업담당자를 검색 선택 해주세요',
    [tokens.common.depositor]: '예금주',
    [tokens.common.depositor_required]: '예금주는 필수 입니다',
    [tokens.common.estimated_depletion_days]: '예상 소진 일수',
    [tokens.common.reservation]: '예약',
    [tokens.common.reservation_details]: '예약 내역',
    [tokens.common.reservation_datetime]: '예약일시',
    [tokens.common.reservation_person]: '예약자',
    [tokens.common.reservation_pending]: '예약중',
    [tokens.common.reservation_confirmation]: '예약확인',
    [tokens.common.scheduled_product_info]: '예정서 상품 정보',
    [tokens.common.scheduled_info]: '예정서 정보',
    [tokens.common.today]: '오늘',
    [tokens.common.account_requirement]: 'CMS 계정 는 필수 입니다',
    [tokens.common.error_handling]: '오류 처리',
    [tokens.common.temperature]: '온도',
    [tokens.common.options]: '옵션',
    [tokens.common.complete]: '완료',
    [tokens.common.completion_time]: '완료시간',
    [tokens.common.except]: '외 {{totalExceptBasic}}개',
    [tokens.common.except_2]: '외 {{totalExceptBasic2}}건',
    [tokens.common.except_supplier]: '외 {{totalExceptPurchaser}}개 매입처',
    [tokens.common.except_sales_source]: '외 {{totalExceptSales}}개 발주처',
    [tokens.common.except_product]: '외 {{totalExceptProduct}}개 상품',
    [tokens.common.except_product_lot]: '외 {{totalExceptProductLot}}개',
    [tokens.common.rate]: '요율',
    [tokens.common.daily_landing_count]: '요일별 착지수',
    [tokens.common.request]: '요청 사항',
    [tokens.common.request_quantity]: '요청 수량',
    [tokens.common.execute_request]: '요청 실행',
    [tokens.common.cancel_request]: '요청 취소',
    [tokens.common.quantity_available_for_request]: '요청가능수량',
    [tokens.common.number_of_requests]: '요청건수',
    [tokens.common.reason_for_request]: '요청사유',
    [tokens.common.select_reason_for_request]: '요청사유 선택',
    [tokens.common.additional_request_details]: '요청사항',
    [tokens.common.requested_quantity]: '요청수량',
    [tokens.common.request_date]: '요청일',
    [tokens.common.request_datetime]: '요청일시',
    [tokens.common.requester]: '요청자',
    [tokens.common.search_requester]: '요청자 검색',
    [tokens.common.requester_info]: '요청자 정보',
    [tokens.common.select_requester]: '요청자를 검색 선택 해주세요',
    [tokens.common.purpose]: '용도',
    [tokens.common.purpose_selection]: '용도 선택',
    [tokens.common.zip_code]: '우편번호',
    [tokens.common.zipcode_search]: '우편번호 검색',
    [tokens.common.zipcode_search_placeholder]: '우편번호 입력 (예: 3591123)',
    [tokens.common.zipcode_no_result]: '검색 결과가 없습니다',
    [tokens.common.tiktok_order_receive_empty]: '수집할 스토어 설정이 없습니다. channel-proxy.tiktok.stores 를 확인해주세요.',
    [tokens.common.outbound_request]: '출고요청',
    [tokens.common.outbound_request_confirm]: '선택한 주문을 출고요청합니다. 재고가 확보되고 출하관리로 넘어갑니다. 상품이 하나라도 모자라면 그 주문은 남습니다.',
    [tokens.common.tiktok_order_receive]: '틱톡 주문 접수',
    [tokens.common.tiktok_order_receive_confirm]: '틱톡의 발송대기 주문을 접수합니다. 이미 받아둔 주문은 건너뜁니다.',
    [tokens.common.collect_failure_list]: '수집 실패',
    [tokens.common.collect_failure_step]: '단계',
    [tokens.common.collect_failure_reason]: '사유',
    [tokens.common.collect_failure_resolved]: '해소',
    [tokens.common.collect_failure_show_resolved]: '해소된 건도 보기',
    [tokens.common.collect_failure_empty]: '수집 실패 건이 없습니다',
    [tokens.common.collect_failure_guide]: '수집하다 못 받은 주문입니다. 상품을 등록한 뒤 다시 수집하면 들어오고, 그때 해소로 닫힙니다.',
    [tokens.common.external_order_no]: '채널 주문번호',
    [tokens.common.collected_at]: '수집일시',
    [tokens.common.store_id]: '스토어',
    [tokens.common.tsv_upload]: 'TSV 업로드',
    [tokens.common.addr_lv1]: '도도부현',
    [tokens.common.addr_lv2]: '시구정촌',
    [tokens.common.addr_area]: '정역',
    [tokens.common.operable_days_absent]: '운영가능한 요일이 없습니다',
    [tokens.common.currency_unit]: '엔',
    [tokens.common.total_order_count]: '총 주문수',
    [tokens.common.total_box_count]: '총 박스수',
    [tokens.common.total_box_count_question]: '총 박스 수',
    [tokens.common.enter_total_box_count]: '총 박스수를 입력하세요',
    [tokens.common.total_box_count_required]: '총 박스수를 먼저 입력해주세요',
    [tokens.common.count_unit]: '개',
    [tokens.common.issue_processing]: '이슈 처리',
    [tokens.common.outbound_completed]: '출고 완료',
    [tokens.common.pending_outbound]: '미출',
    [tokens.common.not_inspected]: '미검수',
    [tokens.common.origin]: '원산지',
    [tokens.common.origin_other_mandatory]: '원산지 기타 사항 필수입니다',
    [tokens.common.origin_other_input]: '원산지 기타 입력',
    [tokens.common.origin_required]: '원산지는 필수 입니다',
    [tokens.common.month]: '월',
    [tokens.common.month_retrieve]: '월 조회',
    [tokens.common.month_week]: '월 주',
    [tokens.common.month_sales_volume]: '월 판매량',
    [tokens.common.month_average_order_amount]: '월 평균 주문 금액',
    [tokens.common.month_average_order_frequency]: '월 평균 주문 횟수',
    [tokens.common.month_disposal_rate]: '월 폐기율',
    [tokens.common.month_meeting]: '월 회',
    [tokens.common.distribution_identification_number]: '유통식별번호',
    [tokens.common.distribution_history_report]: '유통이력신고 정보',
    [tokens.common.type]: '유형',
    [tokens.common.type_selection]: '유형 선택',
    [tokens.common.invalid_response_handling]: '유효하지 않은 응답 처리',
    [tokens.common.bank]: '은행',
    [tokens.common.bank_virtual_account_error]: '은행 가상계좌번호 에러',
    [tokens.common.bank_selection_required]: '은행 선택은 필수 입니다',
    [tokens.common.search_results_by]: '의 검색결과입니다',
    [tokens.common.record_quantity]: '이력 수량',
    [tokens.common.record_report_number]: '이력 신고 번호',
    [tokens.common.record_report_number_alternative]: '이력 신고번호',
    [tokens.common.history_classification]: '이력구분',
    [tokens.common.name]: '이름',
    [tokens.common.enter_name_prompt]: '이름을 입력해주세요',
    [tokens.common.email]: '이메일',
    [tokens.common.email_format_error]: '이메일 형식이 올바르지 않습니다',
    [tokens.common.already_statement_generated]: '이미 정산서 생성이 완료된 내역은 중복 생성이 불가합니다 확인 후 다시 선택해 주시기 바랍니다',
    [tokens.common.already_settled_statement_included]: '이미 정산이 확정된 정산서가 포함되어 있습니다 다시 선택해주시기 바랍니다',
    [tokens.common.already_settled_statement_deletion]: '이미 정산이 확정된 정산서는 삭제할 수 없습니다 다시 선택해주시기 바랍니다',
    [tokens.common.already_reserved_sale_change]: '이미 판매가 예약이 되어 있는 상품의 경우 최종 업로드 기준으로 변경됩니다',
    [tokens.common.already_picked]: '이미 피킹 되었습니다',
    [tokens.common.image_download]: '이미지 다운로드',
    [tokens.common.image_download_repeat]: '이미지 다운로드',
    [tokens.common.this_month]: '이번달',
    [tokens.common.this_week]: '이번주',
    [tokens.common.enter_amount_above]: '이상 입력해주세요.',
    [tokens.common.enter_quantity_above]: '수량을 입력해주세요.',
    [tokens.common.issue]: '이슈',
    [tokens.common.issue_details]: '이슈 내역',
    [tokens.common.issue_details_view_only]: '이슈 내역만 보기',
    [tokens.common.no_issues_found]: '이슈 내역이 없습니다',
    [tokens.common.issue_handling]: '이슈 처리',
    [tokens.common.issue_handling_details]: '이슈 처리 상세',
    [tokens.common.issue_quantity]: '이슈수량',
    [tokens.common.issue_date]: '이슈일',
    [tokens.common.issue_handling_no_logistics_code]: '이슈처리 - 선택된 물류코드가 없습니다',
    [tokens.common.issue_handling_no_incoming_logistics_code]: '이슈처리 - 선택된 입고 물류코드가 없습니다',
    [tokens.common.issue_handling_no_outgoing_logistics_code]: '이슈처리 - 선택된 출고 물류코드가 없습니다',
    [tokens.common.issue_handling_no_logistics_code_found]: '이슈처리 - 조회된 물류코드 정보가 없습니다',
    [tokens.common.issue_handling_datetime]: '이슈처리일시',
    [tokens.common.utilization]: '이용',
    [tokens.common.utilization_stop_with_password_prompt]: '이용 중지 처리를 하시는 경우 비밀번호를 입력해주세요',
    [tokens.common.utilization_processing]: '이용 처리 하시겠습니까',
    [tokens.common.utilization_completed]: '처리가 완료 되었습니다',
    [tokens.common.stop_using]: '이용중지',
    [tokens.common.stop_using_completed]: '이용중지가 완료 되었습니다',
    [tokens.common.profit_margin]: '이익율',
    [tokens.common.profit_margin_fixed_required]: '이익율 고정가는 필수입니다',
    [tokens.common.profit_margin_change]: '이익율 변경',
    [tokens.common.no_profit_margin_change_history]: '이익율 변경내역이 존재하지 않습니다',
    [tokens.common.profit_margin_change_next_day_effect]: '이익율 변경은 익일 적용 됩니다',
    [tokens.common.profit_margin_setting]: '이익율 설정',
    [tokens.common.profit_margin_reservation_mandatory]: '이익율 예약시 판매 이익율과 예정일은 필수입니다',
    [tokens.common.profit_rate_required]: '이익율은 필수입니다',
    [tokens.common.before]: '이전',
    [tokens.common.below]: '이하',
    [tokens.common.day]: '일',
    [tokens.common.day_payment]: '일 결제',
    [tokens.common.day_sales]: '일 매출',
    [tokens.common.day_less_than]: '{{lessDate}}일 미만',
    [tokens.common.month_less_than]: '{{lessMonth}}개월 미만',
    [tokens.common.year_less_than]: '{{lessYear}}년 미만',
    [tokens.common.day_more_than]: '{{moreDate}}일 이상',
    [tokens.common.day_prior_product_disposal]: '일 이전 상품 폐기',
    [tokens.common.day_prior_product_disposal_inventory_adjustment]: '일 이전 주문상품 가용재고 차감',
    [tokens.common.day_day]: '일 일',
    [tokens.common.day_inventory]: '일 재고',
    [tokens.common.batch_exposure_setting]: '일괄 노출 설정',
    [tokens.common.batch_registration_form_download]: '일괄 등록 양식 다운로드',
    [tokens.common.batch_change]: '일괄 변경',
    [tokens.common.batch_edit_form_download]: '일괄 수정양식 다운로드',
    [tokens.common.batch_adjustment]: '일괄 조정',
    [tokens.common.batch_adjustment_irreversible_warning]:
        '일괄 조정 시에는 데이터 원복이 불가능하므로 다시 한번 신중하게 확인 후 진행하시기 바랍니다.',
    [tokens.common.batch_adjustment_completed]: '일괄 조정이 완료 되었습니다',
    [tokens.common.batch_confirmation]: '일괄 확정',
    [tokens.common.general_inquiry_details]: '일반 문의 상세',
    [tokens.common.general_inquiry]: '일반문의',
    [tokens.common.date_time]: '일시',
    [tokens.common.date_2]: '일자',
    [tokens.common.daily_inventory]: '일재고',
    [tokens.common.daily_inventory_product_selection]: '일재고 상품 선택',
    [tokens.common.daily_inventory_individual_order_impossible]: '일재고 상품은 개별 발주가 불가능 합니다 발주 상품을 다시 확인해주시기 바랍니다',
    [tokens.common.daily_inventory_order_center_requirement]: '일재고 선택시, 주문가능센터는 1개 이상 입력 되어야 합니다',
    [tokens.common.daily_inventory_only_disposal_possible]: '일재고는 폐기만 가능',
    [tokens.common.daily_inventory_no_joint_statement_with_storage]:
        '일재고와 보관재고는 함께 정산서를 생성할 수 없습니다 확인 후 다시 선택해 주시기 바랍니다',
    [tokens.common.daily_average_sales]: '일평균 판매량',
    [tokens.common.average_daily_sales_volume]: '일평균판매량',
    [tokens.common.view_imminent_products_only]: '임박 상품만 보기',
    [tokens.common.imminent_rate]: '임박율',
    [tokens.common.temporary_adjustment_limit_amount]: '임시 조정 한도 금액',
    [tokens.common.temporary_adjustment_limit_required]: '임시 조정 한도 금액은 필수 입니다',
    [tokens.common.temporary_adjustment_limit_end_date]: '임시 조정 한도 적용 종료일',
    [tokens.common.temporary_adjustment_limit_end_date_required]: '임시 조정 한도 적용 종료일은 필수 입니다',
    [tokens.common.temporary_order_restriction_date_setting]: '임시 주문 제한일 설정',
    [tokens.common.all_products_order_prohibited_during_period]: '해당 기간에는 모든 상품 주문불가',
    [tokens.common.inbound.receiving]: '입고',
    [tokens.common.inbound.receiving_management]: '입고내역',
    [tokens.common.inbound.receiving_unit]: '입고 단위',
    [tokens.common.inbound.receiving_available_days]: '입고 가능 요일',
    [tokens.common.inbound.receiving_available_days_required]: '입고 가능 요일은 필수입니다',
    [tokens.common.inbound.receiving_manager]: '입고 담당자',
    [tokens.common.inbound.receiving_manager_contact]: '입고 담당자 연락처',
    [tokens.common.inbound.waiting_for_receiving]: '입고 대기',
    [tokens.common.inbound.no_receiving_waiting_tasks]: '입고 대기 작업이 없습니다',
    [tokens.common.inbound.receiving_list]: '입고 관리',
    [tokens.common.inbound.receiving_deadline_time]: '입고 마감 시간',
    [tokens.common.inbound.receiving_deadline_time_required]: '입고 마감 시간은 필수 입니다',
    [tokens.common.inbound.enter_receiving_deadline_time]: '입고 마감 시간을 입력 해주세요',
    [tokens.common.inbound.receiving_shipping_info]: '입고・배송 정보',
    [tokens.common.inbound.receiving_settings]: '입고 설정',
    [tokens.common.inbound.receiving_center]: '입고 센터',
    [tokens.common.inbound.select_receiving_center]: '입고 센터 선택',
    [tokens.common.inbound.number_of_receivings]: '입고 수',
    [tokens.common.inbound.receiving_slots]: '입고 슬롯',
    [tokens.common.inbound.receiving_slot_list]: '입고 슬롯 리스트',
    [tokens.common.inbound.receiving_slot_list_product_details]: '입고 슬롯 리스트 상품 상세',
    [tokens.common.inbound.receiving_slot_details]: '입고 슬롯 상세',
    [tokens.common.inbound.receiving_slot_time]: '입고 슬롯 시간',
    [tokens.common.inbound.quantity_at_receiving]: '입고 시 입수량',
    [tokens.common.inbound.receiving_start_time]: '입고 시작 시간',
    [tokens.common.inbound.receiving_expected_time]: '입고 예정 시간',
    [tokens.common.inbound.receiving_start_time_fixed]: '입고 시작 시간은 으로 고정',
    [tokens.common.inbound.nighttime_receiving_slot]: '입고 야간 슬롯',
    [tokens.common.inbound.scheduled_receiving]: '입고 예정',
    [tokens.common.inbound.scheduled_receiving_time]: '입고 예정 시간',
    [tokens.common.inbound.scheduled_receiving_time_weekday_weekend]: '입고 예정 시간(평일/주말)',
    [tokens.common.inbound.scheduled_receiving_date]: '입고(예정)일자',
    [tokens.common.inbound.scheduled_receiving_document_storage]: '입고 예정서 보관',
    [tokens.common.inbound.scheduled_receiving_datetime]: '입고 예정일시',
    [tokens.common.inbound.receiving_quantity]: '입고 수량',
    [tokens.common.inbound.receiving_quantity_less_than_ordered]:
        '입고 요청 수량보다 실입고 수량이 작습니다 선택하신 발주 내역이 입하 처리 되고 입고 확인서가 발행되며 이후에는 수정이 불가합니다 그래도 정말 강제 입고를 등록 하시겠습니까',
    [tokens.common.inbound.requested_receiving_date]: '입고 요청일',
    [tokens.common.inbound.receiving_info]: '입고 정보',
    [tokens.common.inbound.receiving_expected_info]: '입고 예정 정보',
    [tokens.common.inbound.weekly_receiving_slot]: '입고 주간 슬롯',
    [tokens.common.inbound.processed_receiving_quantity]: '입고 처리수량',
    [tokens.common.inbound.processed_receiving_datetime]: '입고 처리일시',
    [tokens.common.inbound.receiving_code]: '입고 코드',
    [tokens.common.inbound.receiving_confirmation_process]: '입고 확인 처리',
    [tokens.common.inbound.receiving_confirmation_completed]: '입고 확인 처리 되었습니다',
    [tokens.common.inbound.receiving_confirmation_document]: '입고 확인서',
    [tokens.common.inbound.receiving_confirmation_final_document]: '입고 확인서 입고 확정서',
    [tokens.common.inbound.receiving_method]: '입고 방식',
    [tokens.common.inbound.completed_receiving_eligible_for_statement_creation]:
        '입고가 완료된 내역 입고완료 상태 만 정산서 생성이 가능합니다 확인 후 다시 선택해 주시기 바랍니다',
    [tokens.common.inbound.select_available_receiving_days]: '입고가능 요일 선택',
    [tokens.common.inbound.available_receiving_days_required]: '입고가능 요일은 필수입니다',
    [tokens.common.inbound.receiving_result]: '입고결과',
    [tokens.common.inbound.waiting_for_receiving_status]: '입고대기',
    [tokens.common.inbound.emergency_release_disabled_in_waiting_for_receiving]: '입고대기 상태 긴급출고 비활성 처리',
    [tokens.common.inbound.deadline_for_receiving]: '입고마감',
    [tokens.common.inbound.deadline_minutes_for_receiving_required]: '입고마감 분은 필수 입니다',
    [tokens.common.inbound.deadline_time_for_receiving_required]: '입고마감 시간은 필수 입니다',
    [tokens.common.inbound.closing_time_for_receiving]: '입고마감시간',
    [tokens.common.inbound.receiving_status]: '입고상태',
    [tokens.common.inbound.receiving_settings_completed]: '입고설정 등록이 완료되었습니다',
    [tokens.common.inbound.scheduled_receiving_center]: '입고센터/입고예정일',
    [tokens.common.inbound.scheduled_receiving_datetime_center]: '입고센터/입고일시',
    [tokens.common.inbound.receiving_center_required]: '입고센터는 필수 입니다',
    [tokens.common.inbound.received_quantity]: '실제입고수량',
    [tokens.common.inbound.received_quantity_unit]: '입고수량/단위',
    [tokens.common.inbound.received_quantity_order_unit]: '입고수량/주문단위',
    [tokens.common.inbound.stocking_slot_force_order_request_document_product_lookup]: '입고슬롯 강제입고 발주요청서 상품 조회',
    [tokens.common.inbound.scheduled_to_be_in_stock]: '입고예정',
    [tokens.common.inbound.expected_stock_quantity]: '입고예정수량',
    [tokens.common.inbound.expected_stock_quantity_order_unit]: '입고예정수량/주문단위',
    [tokens.common.inbound.expected_arrival_date]: '입고예정일',
    [tokens.common.inbound.expected_arrival_time]: '입고예정시간',
    [tokens.common.inbound.expected_plt_count]: 'PLT수',
    [tokens.common.inbound.expected_plt_count_time]: 'PLT수 / 입고 시간',
    [tokens.common.inbound.expected_arrival_date_time_count]: '입고예정일 / 시간 / PLT수',
    [tokens.common.inbound.stock_completed]: '입고완료',
    [tokens.common.inbound.receiving_request_more_than_stock_quantity]: '입고요청 수량보다 실입고 수량이 많습니다 수량 조정해 주시기 바랍니다',
    [tokens.common.inbound.stock_request_date]: '입고요청일',
    [tokens.common.inbound.select_stock_request_date]: '입고요청일 선택',
    [tokens.common.inbound.date_of_receipt]: '입고일',
    [tokens.common.inbound.date_of_receipt_period]: '입고일 기간',
    [tokens.common.inbound.date_of_arrival]: '입고일시',
    [tokens.common.inbound.place_of_receipt]: '입고지',
    [tokens.common.inbound.receiving_processing]: '입고처리',
    [tokens.common.inbound.receiver]: '입고처리자',
    [tokens.common.inbound.receiving_invoice_no]: 'INVOICE NO',
    [tokens.common.inbound.receiving_invoice_no_input]: 'INVOICE NO 입력',
    [tokens.common.inbound.receiver]: '입고처리자',
    [tokens.common.inbound.confirm_receipt]: '입고확인',
    [tokens.common.inbound.receipt_confirmed_by]: '입고확인자',
    [tokens.common.inbound.search_receipt_confirmer]: '입고확인자 검색',
    [tokens.common.inbound.receipt_confirmer_info]: '입고확인자 정보',
    [tokens.common.inbound.select_receipt_confirmer]: '입고확인자를 검색/선택 해주세요',
    [tokens.common.inbound.confirmed_receipt]: '입고확정',
    [tokens.common.inbound.confirmed_receipt_date]: '입고확정일',
    [tokens.common.inbound.scheduled_receiving_quantity_input]: '입고 예정 수량 입력',
    [tokens.common.inbound.scheduled_receiving_quantity_unit]: '입고예정수량 / 단위',
    [tokens.common.inbound.total_amount]: '총 입고 금액',
    [tokens.common.inbound.receiving_expected_excel_registration]: '입고예정서 엑셀 등록',
    [tokens.common.inbound.receiving_expected_lot_no]: '입고 예정 LOT 번호',
    [tokens.common.inbound.receiving_expected_lot_no_input]: '입고 예정 LOT 번호 입력',
    [tokens.common.inbound.receiving_expected_goods_remark]: '입고 상품 특이사항',
    [tokens.common.inbound.receiving_expected_goods_remark_input]: '입고 상품 특이사항 입력',

    [tokens.common.deposit]: '입금',
    [tokens.common.deposit_account_info]: '입금 계좌 정보',
    [tokens.common.deposit_processing]: '입금 처리',
    [tokens.common.deposit_amount_processing]: '입금 처리 금액',
    [tokens.common.deposit_reason]: '입금 처리 사유',
    [tokens.common.deposit_immediate_reflection]: '입금 처리 시 즉시 채권에 반영되오니 확인 후 적용해 주시기 바랍니다',
    [tokens.common.location_label_print_for_input_quantity]: '입력 수량만큼 로케이션 라벨 출력',
    [tokens.common.quantity_received]: '입수량',
    [tokens.common.quantity_received_per_order_unit]: '입수량 주문단위',
    [tokens.common.waiting_for_entry]: '입차 대기중',
    [tokens.common.entry_instructions_completed]: '입차지시가 완료 되었습니다',
    [tokens.common.in_stock_processing]: '입하 처리',
    [tokens.common.in_stock_processing_completed]: '입하 처리가 되었습니다',
    [tokens.common.automatic]: '자동',
    [tokens.common.automatic_ordering]: '자동 발주',
    [tokens.common.automatic_ordering_manual]: '자동 발주 수동 발주',
    [tokens.common.automatic_declaration_processing]: '자동 신고 처리',
    [tokens.common.automatic_refund]: '자동 환불',
    [tokens.common.automatic_ordering_not_available]: '자동발주를 선택할 수 없습니다',
    [tokens.common.seating_required]: '6자리 이상 입력하여 주십시오',
    [tokens.common.frequently_asked_questions]: '자주 묻는 질문',
    [tokens.common.faq_registration_completed]: '자주 묻는 질문 등록이 완료되었습니다',
    [tokens.common.faq_deletion]: '자주 묻는 질문 삭제',
    [tokens.common.faq_details]: '자주 묻는 질문 상세',
    [tokens.common.faq_modification]: '자주 묻는 질문 수정',
    [tokens.common.faq_registration]: '자주 묻는 질문 등록',
    [tokens.common.self_disposal]: '자체 폐기',
    [tokens.common.no_work_without_history]: '작업 내역 없으면 실행되지 않도록',
    [tokens.common.no_work_target_list]: '작업 대상 목록이 없습니다',
    [tokens.common.work_completion_datetime]: '작업완료일시',
    [tokens.common.select_option_for_work_instruction]: '작업을 지시할 옵션을 선택해주세요',
    [tokens.common.remaining_amount]: '잔량',
    [tokens.common.remaining_days]: '잔여일',
    [tokens.common.remaining_days_count]: '잔여일수',
    [tokens.common.frequent_mass_data_upload_warning]:
        '잦은 대량 데이터 업로드는 서버 부하를 일으킬 수 있으며, 고객 주문 또는 출고에 영향을 미칠 수 있으니 한번 더 파일을 확인하시기 바랍니다',
    [tokens.common.frequent_statement_creation_deletion_warning]:
        '잦은 정산서 생성 삭제는 시스템 과부하의 주요 원인 이므로 다시 한번 확인 후 신중하게 처리 하시기 바랍니다',
    [tokens.common.re_recovery_status]: '(재)회수상태',
    [tokens.common.re_recovery_scheduled_date]: '(재)회수예정일',
    [tokens.common.re_recovery_completion_date]: '(재)회수완료일',
    [tokens.common.re_recovery_code]: '(재)회수코드',
    [tokens.common.contract_renewal]: '재계약',
    [tokens.common.contract_renewal_termination]: '계약 종료',
    [tokens.common.contract_renewal_processed]: '재계약 처리 되었습니다',
    [tokens.common.contract_renewal_processing_warning]:
        '재계약 처리 시에는 신규 가상계좌번호가 부여되며 기존 계약정보가 원복되오니 반드시 재확인 후 시도해주시기 바랍니다.',
    [tokens.common.contract_renewal_confirmation]: '재계약 처리 하시겠습니까',
    [tokens.common.contract_renewal_completed]: '재계약 처리가 완료 되었습니다',
    [tokens.common.inventory_classification_1]: '재고 구분',
    [tokens.common.inventory_classification_2]: '재고구분',
    [tokens.common.inventory_order_classification]: '재고 구분 / 발주 구분',
    [tokens.common.inventory_list]: '재고 리스트',
    [tokens.common.inventory_snapshot_list]: '재고 리스트 스냅샷',
    [tokens.common.inventory_list_details]: '재고 리스트 상세',
    [tokens.common.inventory_replenishment]: '재고 보충',
    [tokens.common.inventory_replenishment_order]: '재고 보충 지시',
    [tokens.common.inventory_discrepancy_view_only]: '재고 불일치 상품만 보기',
    [tokens.common.inventory_depletion_view_only]: '재고 소진 상품만 보기',
    [tokens.common.inventory_depletion_rate]: '재고 소진율',
    [tokens.common.inventory_quantity]: '재고 수량',
    [tokens.common.inventory_ledger_finalization]: '재고 수불부 확정',
    [tokens.common.inventory_ledger_finalization_confirmation]: '재고 수불부 확정 처리를 하시는 경우 비밀번호를 입력해주세요',
    [tokens.common.inventory_information]: '재고 정보',
    [tokens.common.inventory_audit]: '재고 조사',
    [tokens.common.last_week_1]: '저번주',
    [tokens.common.low_temperature]: '저온',
    [tokens.common.low_temperature_frozen]: '저온 냉동',
    [tokens.common.save]: '저장',
    [tokens.common.save_register]: '등록',
    [tokens.common.save_add]: '저장 추가',
    [tokens.common.save_confirm]: '저장·확정',
    [tokens.common.save_completed]: '저장이 완료 되었습니다',
    [tokens.common.apply_period]: '적용 기간',
    [tokens.common.apply_edit]: '적용 수정',
    [tokens.common.apply_start_date]: '적용 시작일',
    [tokens.common.apply_end_date]: '적용 종료일',
    [tokens.common.select_apply_end_date]: '적용 종료일 선택',
    [tokens.common.number_of_applicable_products]: '적용상품수',
    [tokens.common.expected_date_of_application]: '적용예정일',
    [tokens.common.expected_date_of_application_required]: '적용예정일은 필수 입니다',
    [tokens.common.date_of_application]: '적용일',
    [tokens.common.until_the_date_of_application]: '적용일까지 기존 여신 한도 금액이 임시 조정 한도 금액으로 변경 됩니다',
    [tokens.common.date_of_application_required]: '적용일자는 필수 입니다',
    [tokens.common.applying]: '적용중',
    [tokens.common.accumulation_amount]: '적치 SKU 수',
    [tokens.common.accumulation_period]: '적치기간',
    [tokens.common.status_of_accumulation]: '적치상태',
    [tokens.common.accumulation_rate]: '적치율',
    [tokens.common.accumulation_rate_replenishment_order]: '적치율 기준 보충 지시',
    [tokens.common.view_below_accumulation_rate]: '적치율 {{automaticReplenishmentLessPercent}}%미만 보기',
    [tokens.common.automatic_replenishment_below_accumulation_rate]:
        '*적치율이 {{automaticReplenishmentLessPercent}}% 미만으로 떨어지는 경우 자동으로 재고 보충 지시 됩니다',
    [tokens.common.jeonnam]: '전남',
    [tokens.common.computation_expiration_date]: '전산 유통기한',
    [tokens.common.computation_quantity]: '전산 수량',
    [tokens.common.forwarding]: '전송',
    [tokens.common.exclusive_products]: '전용 상품',
    [tokens.common.entire]: '전체',
    [tokens.common.register_as_entire_exposure]: '전체 노출 상태로 등록',
    [tokens.common.register_as_entire_non_exposure]: '전체 미노출 상태로 등록',
    [tokens.common.entire_non_exposed_included]: '전체 미노출 상품이 포함되어있습니다',
    [tokens.common.entire_non_exposed_product]: '전체 미노출 상품입니다',
    [tokens.common.view_all_products]: '전체 상품보기',
    [tokens.common.entire_receiving_results]: '전체 입고결과',
    [tokens.common.view_entire_receiving_history]: '전체 입고내역 보기',
    [tokens.common.entire_receiving_status]: '전체 입고상태',
    [tokens.common.entire_receiving_slots]: '전체 입고슬롯',
    [tokens.common.entire_picking_list]: '전체 피킹 리스트',
    [tokens.common.entire_total_amount]: '전체 합계 금액',
    [tokens.common.phone_number]: '전화번호',
    [tokens.common.enter_phone_number]: '전화번호 입력',
    [tokens.common.enter_phone_number_prompt]: '전화번호를 입력하세요',
    [tokens.common.enter_phone_number_please]: '전화번호를 입력해주세요',
    [tokens.common.lunch]: '점심 시간',
    [tokens.common.lunch_start_time]: '점심 시작 시간',
    [tokens.common.lunch_end_time]: '점심 종료 시간',
    [tokens.common.lunch_time_required]: '점심시간은 필수 설정해야 저장이 가능합니다',
    [tokens.common.no_access_rights]: '접근권한이 없습니다',
    [tokens.common.receipt_reason]: '접수 사유',
    [tokens.common.receipt_reason_required]: '접수 사유는 필수입니다',
    [tokens.common.receipt_quantity]: '접수 수량',
    [tokens.common.acceptable_quantity]: '접수가능수량',
    [tokens.common.reason_for_submission]: '접수사유',
    [tokens.common.date_of_receipt]: '접수일',
    [tokens.common.confirm_receipt_change]: '접수하신 상담 상태를 변경하시겠습니까',
    [tokens.common.really_delete_reservation]: '정말 변경예약건을 삭제 하시겠습니까',
    [tokens.common.really_delete]: '정말 삭제하시겠습니까',
    [tokens.common.really_delete_holiday]: '정말 휴일을 삭제하시겠습니까',
    [tokens.common.information]: '정보',
    [tokens.common.copy_information]: '정보 복사',
    [tokens.common.batch_edit_information]: '정보 일괄 수정',
    [tokens.common.batch_edit_information_file]: '정보 일괄 수정 - Excel 파일',
    [tokens.common.settlement_payment_date]: '정산 결제일',
    [tokens.common.settlement_payment_date_required]: '정산 결제일은 필수 입니다',
    [tokens.common.settlement_base_date]: '정산 기준일',
    [tokens.common.settlement_base_date_cannot_be_earlier]: '정산 기준일은 결제일보다 빠를 수 없습니다',
    [tokens.common.settlement_base_date_required]: '정산 기준일은 필수 입니다',
    [tokens.common.settlement_edit]: '정산 수정',
    [tokens.common.settlement_total_amount]: '정산 합계금액',
    [tokens.common.confirm_settlement]: '정산 확정',
    [tokens.common.settlement_classification]: '정산구분',
    [tokens.common.settlement_period]: '정산기간',
    [tokens.common.settlement_standard_payment_date]: '정산기준 (결제일)',
    [tokens.common.settlement_date]: '정산기준일',
    [tokens.common.settlement_year_and_month]: '정산년월',
    [tokens.common.settlement_status]: '정산상태',
    [tokens.common.settlement_document]: '정산서',
    [tokens.common.settlement_document_ID]: '정산서 ID',
    [tokens.common.renew_settlement_document]: '정산서 갱신',
    [tokens.common.settlement_document_purchase_station]: '정산서 매입처 매입처',
    [tokens.common.view_uncreated_settlement_document]: '정산서 미생성 내역만 보기',
    [tokens.common.add_return_details_to_settlement_document]: '정산서 반품 내역 추가',
    [tokens.common.delete_settlement_document]: '정산서 삭제',
    [tokens.common.create_settlement_document]: '정산서 생성',
    [tokens.common.settlement_document_creation_completed]: '정산서 생성이 완료 되었습니다',
    [tokens.common.edit_settlement_document]: '정산서 수정',
    [tokens.common.resend_settlement_document_1]: '정산서 재전송',
    [tokens.common.settlement_document_modification_not_possible]: '정산서 확정 이후에는 수정이 불가',
    [tokens.common.settlement_document_modification_not_possible2]: '하며, 정산서가 발송됩니다.',
    [tokens.common.settlement_document_sent]: '정산서가 발송됩니다.',
    [tokens.common.settlement_document_modification_not_possible_due_to_creation]: '정산서가 생성되어 있어 매입가 수정이 불가합니다',
    [tokens.common.resend_settlement_document_2]: '정산서를 재전송',
    [tokens.common.resend_settlement_document_prompt]: '정산서를 재전송 하시겠습니까?',
    [tokens.common.frequent_creation_deletion_of_settlement_document]:
        '정산서를 재전송 하시겠습니까, 정산서의 잦은 생성 삭제는 시스템 과부화의 주요 원인이므로 다시 한번 확인 후 신중하게 처리 하시기 바랍니다',
    [tokens.common.check_settlement_document]: '정산서확인',
    [tokens.common.settlement_date_required]: '정산일은 필수 입니다',
    [tokens.common.normal]: '정상',
    [tokens.common.normal_operation_close]: '정상 동작하면 닫기 처리',
    [tokens.common.normal_success]: '정상 성공',
    [tokens.common.normal_shipping_processing]: '정상 출고 처리',
    [tokens.common.normal_shipping_no_logistics_code]: '정상 출고 처리 - 선택된 물류코드가 없습니다',
    [tokens.common.normal_shipping_completed]: '정상 출고 처리 완료 되었습니다',
    [tokens.common.normal_shipping_confirm]: '정상 출고 처리 하시겠습니까',
    [tokens.common.order_transferred_normally]: '정상적으로 주문이 이관되었습니다',
    [tokens.common.correction_request_management_return]: '정정요청관리반품',
    [tokens.common.suspension_date]: '정지일',
    [tokens.common.warning_confirm_inout_history]: '재고수불부 최종 확정 처리 하시겠습니까?\n확정 처리후에는 수정 불가합니다.',
    [tokens.common.finalization_inout_history]: '재고수불부 확정',
    [tokens.common.completed_inout_history]: '재고수불부 확정이 완료되었습니다',
    [tokens.common.inout_history]: '재고수불부',
    [tokens.common.empty_page_inout_history]: '재고수불부',
    [tokens.common.title]: '제목',
    [tokens.common.title_required]: '제목은 필수입니다',
    [tokens.common.enter_title]: '제목을 입력하세요',
    [tokens.common.product_inquiry]: '제품문의',
    [tokens.common.investigation_result_reflection]: '조사 결과 반영 여부',
    [tokens.common.select_investigation_result_reflection]: '조사 결과 반영 여부를 선택하세요',
    [tokens.common.select_investigation_year]: '조사 년도 선택',
    [tokens.common.investigation_year_query]: '조사 년도 조회',
    [tokens.common.investigation_status_1]: '조사 상태',
    [tokens.common.select_investigation]: '조사 선택',
    [tokens.common.investigation_expiration_date]: '조사 유통기한',
    [tokens.common.investigation_quantity]: '조사 수량',
    [tokens.common.investigation_upload]: '조사 업로드',
    [tokens.common.investigation_status_check_1]: '조사 여부',
    [tokens.common.completed_investigation_unsurveyed]: '조사 여부 완료 미조사',
    [tokens.common.investigation_completion_datetime]: '조사 완료 일시',
    [tokens.common.investigation_datetime]: '조사 일시',
    [tokens.common.investigation_order_datetime]: '조사 지시 일시',
    [tokens.common.survey_year]: '조사년도',
    [tokens.common.investigation_status_2]: '조사상태',
    [tokens.common.investigation_status_check_2]: '조사여부',
    [tokens.common.adjustment]: '조정',
    [tokens.common.adjustment_classification]: '조정 구분',
    [tokens.common.adjustment_classification_required]: '조정 구분은 필수 입니다',
    [tokens.common.adjustment_amount]: '조정 금액',
    [tokens.common.adjustment_date_1]: '조정 년월일',
    [tokens.common.adjustment_reason]: '조정 사유',
    [tokens.common.enter_adjustment_reason]: '조정 사유 입력',
    [tokens.common.adjustment_reason_detailed]: '조정 사유가 상세히 작성되지 않은 경우 조정 내역이 반려될 수 있습니다',
    [tokens.common.enter_adjustment_reason_prompt]: '조정 사유를 입력해주세요',
    [tokens.common.adjustment_expiration_date]: '조정 유통기한 년월일',
    [tokens.common.adjustment_quantity]: '조정 수량',
    [tokens.common.enter_adjustment_quantity]: '조정 수량 입력',
    [tokens.common.enter_adjustment_lot_no]: '조정 LOT 입력',
    [tokens.common.prompt_adjustment_quantity]: '조정 수량을 입력해 주세요',
    [tokens.common.adjustment_impacts_reservation]: '조정 시 기존 예약 정보는 사라지며 변경 내용으로 일괄 적용됩니다',
    [tokens.common.adjustment_type_1]: '조정 유형',
    [tokens.common.select_adjustment_type]: '조정 유형 선택',
    [tokens.common.choose_adjustment_type]: '조정 유형을 선택해 주세요',
    [tokens.common.adjustment_effective_date]: '조정 적용일',
    [tokens.common.adjustment_before_expiration]: '조정 전 유통기한',
    [tokens.common.adjustment_before_lot_no]: '조정 전 LOT',
    [tokens.common.adjustment_before_quantity]: '조정 전 수량',
    [tokens.common.adjustment_method_required]: '조정 처리 방식은 필수 입니다',
    [tokens.common.adjustment_confirm]: '조정 확정',
    [tokens.common.adjustment_after_expiration]: '조정 후 유통기한',
    [tokens.common.adjustment_after_lot_no]: '조정 후 LOT',
    [tokens.common.adjustment_after_quantity]: '조정 후 수량',
    [tokens.common.adjustment_category]: '조정구분',
    [tokens.common.adjustment_fee]: '조정금',
    [tokens.common.adjustment_fee_details]: '조정금 내역',
    [tokens.common.adjustment_fee_processing]: '조정금 처리',
    [tokens.common.adjustment_fee_processing_query]: '조정금 처리 내역 조회',
    [tokens.common.no_adjustment_fee_processing]: '조정금 처리 내역이 없습니다',
    [tokens.common.adjustment_fee_processing_target]: '조정금 처리 대상중 선불 발주처가 존재합니다',
    [tokens.common.adjustment_fee_processing_impact]:
        '조정금 처리 시 조정금액이 즉시 채권에 반영되며,정산서에 반영 청구 되오니 다시 한번 확인 후 처리하시기 바랍니다',
    [tokens.common.no_adjustment_fee_details]: '조정금 처리내역이 없습니다',
    [tokens.common.adjustment_fee_processing_unavailable]: '조정금 처리를 할 수 없습니다',
    [tokens.common.select_adjustment_fee_liability]: '조정금 처리에 따른 귀책 선택',
    [tokens.common.select_adjustment_fee_category]: '조정금 처리에 따른 카테고리 선택',
    [tokens.common.adjustment_amount_added]: '조정금액 추가가 완료 되었습니다',
    [tokens.common.reason_for_adjustment]: '조정사유',
    [tokens.common.adjusted_quantity]: '조정수량',
    [tokens.common.adjustment_type_2]: '조정유형',
    [tokens.common.adjustment_type_expiration_adjustment]: '조정유형 유통기한 조정',
    [tokens.common.adjustment_type_disposal_loss_recovery]: '조정유형 폐기 손망실 처리 손망실복구',
    [tokens.common.adjustment_date_2]: '조정일',
    [tokens.common.coordinator]: '조정자',
    [tokens.common.search_coordinator]: '조정자 검색',
    [tokens.common.coordinator_info]: '조정자 정보',
    [tokens.common.select_coordinator]: '조정자를 검색 선택 해주세요',
    [tokens.common.adjustment_processing_datetime]: '조정처리 년월일 시분',
    [tokens.common.adjustment_processing_details]: '조정처리내용',
    [tokens.common.adjustment_processor]: '조정처리자',
    [tokens.common.approved_by_organization_leader]: '조직장 팀장 승인이 완료 된 건입니다',
    [tokens.common.calculate_date_from_today]: '조회 날짜 계산 현재기준으로 일',
    [tokens.common.search_basis]: '조회기준',
    [tokens.common.no_incoming_logistics_details_found]: '조회된 간선 입고 내역이 없습니다',
    [tokens.common.no_results_found]: '조회된 결과가 없습니다',
    [tokens.common.no_details_found]: '조회된 내역이 없습니다',
    [tokens.common.no_contents_found]: '조회된 내용이 없습니다',
    [tokens.common.no_inventory_info_found]: '조회된 재고 정보가 없습니다',
    [tokens.common.no_order_details_found]: '조회된 주문 내역이 없습니다',
    [tokens.common.view_only_terminated_products]: '종결 상품만 보기',
    [tokens.common.terminated_products_included]: '종결 상품이 포함되어 있습니다 발주 상품을 다시 확인해주시기 바랍니다',
    [tokens.common.end]: '종료',
    [tokens.common.end_date]: '종료일',
    [tokens.common.end_date_required]: '종료일은 필수 입니다',
    [tokens.common.imminent_termination]: '종료임박',
    [tokens.common.employee_id]: '종사업자번호',
    [tokens.common.main_weekly_delivery]: '주 {{weeklyDeliveryCount}}일 배송',
    [tokens.common.weekly]: '주간',
    [tokens.common.day_night_cycle]: '주간 야간',
    [tokens.common.weekend]: '주말',
    [tokens.common.weekend_closure]: '주말 마감',
    [tokens.common.no_weekend]: '주말 없음',
    [tokens.common.order]: '주문',
    [tokens.common.order_available_center]: '주문 가능 센터',
    [tokens.common.order_management]: '출하 관리',
    [tokens.common.order_received]: '주문 접수',
    [tokens.common.order_management_excel_download]: '출하 관리 엑셀 다운로드',
    [tokens.common.order_management_detail_excel_download]: '출하 관리 상세 엑셀 다운로드',
    [tokens.common.order_management_excel_upload_failure]: '출하 관리 엑셀 업로드 실패',
    [tokens.common.order_amount]: '주문 금액',
    [tokens.common.order_history]: '주문 내역',
    [tokens.common.excel_month_limit]: '엑셀 다운로드는 최대 31일 까지만 가능합니다. 조회 기간을 31일 이내로 다시 선택해 주세요.',

    [tokens.common.no_order_history]: '주문 내역이 없습니다',
    [tokens.common.order_download_limit]: '주문 다운로드는 {{totalOrderExcelDownload}} 건까지만 가능합니다',
    [tokens.common.order_unit]: '주문 단위',
    [tokens.common.order_unit_specification]: '주문 단위 규격',
    [tokens.common.order_deadline]: '주문 마감 시간',
    [tokens.common.order_deadline_required]: '주문 마감 시간은 필수 입니다',
    [tokens.common.order_deadline_format_incorrect]: '주문 마감시간 양식에 맞지 않습니다',
    [tokens.common.order_sales_selection]: '주문(매출) 선택',
    [tokens.common.order_frequency]: '주문 빈도',
    [tokens.common.order_detail]: '주문 상세',
    [tokens.common.order_products]: '주문 상품',
    [tokens.common.order_quantity]: '주문 수량',
    [tokens.common.order_upload]: '주문 업로드',
    [tokens.common.order_AdrVerify]: '주소 검증',
    [tokens.common.order_upload_limit]: '주문 업로드는 한 번에 최대 {{orderUploadLimit}}개 까지 가능합니다',
    [tokens.common.order_upload_brand_warning]: '하나의 수주번호에는 동일 브랜드의 상품만 업로드해 주세요.',
    [tokens.common.order_moment]: '주문 일시',
    [tokens.common.order_info_excel_file]: '주문 정보 EXCEL파일',
    [tokens.common.order_content]: '주문 주문 내용',
    [tokens.common.cancel_order]: '주문 취소',
    [tokens.common.order_cancellation_process]: '주문 취소 시',
    [tokens.common.order_cancellation_no_logistic_code]: '주문취소 - 선택된 출고 물류코드가 없습니다.',
    [tokens.common.order_cancellation_no_orders]: '선택된 주문이 없습니다.',
    [tokens.common.order_cancellation_immediate]:
        '주문 취소 시 상품을 즉시 주문 취소합니다. 주문 취소 시 자동 환불 되므로 신중하게 확인 후 처리하시기 바랍니다.',
    [tokens.common.order_receive_cancellation]: '주문 취소 시 상품을 즉시 주문 취소합니다. 주문을 취소하시겠습니까?',
    [tokens.common.order_cancellation_completed]: '주문 취소 완료 되었습니다',
    [tokens.common.order_amount_vat_included]: '주문금액은 VAT 포함',
    [tokens.common.order_unit_temperature]: '주문단위 / 품온',
    [tokens.common.order_deadline_minute_weekend]: '주문마감분 주말 은 자리로 입력하여 주십시오',
    [tokens.common.order_deadline_minute_weekday]: '주문마감분 평일 은 자리로 입력하여 주십시오',
    [tokens.common.order_deadline_weekend]: '주문마감시간 주말',
    [tokens.common.order_deadline_weekend_required]: '주문마감시간 주말 은 자리로 입력하여 주십시오',
    [tokens.common.order_deadline_weekday]: '주문마감시간 평일',
    [tokens.common.order_deadline_weekday_required]: '주문마감시간 평일 은 자리로 입력하여 주십시오',
    [tokens.common.order_number]: '주문번호',
    [tokens.common.order_unavailable_days]: '주문불가 요일',
    [tokens.common.order_status]: '주문상태',
    [tokens.common.ordered_product_inventory_deduction]: '주문상품 가용재고 차감',
    [tokens.common.order_selection]: '주문선택',
    [tokens.common.order_date_query]: '주문일 조회',
    [tokens.common.order_date_and_time]: '주문일시',
    [tokens.common.receipt_date_and_time]: '접수일시',
    [tokens.common.receipt_date]: '접수일',
    [tokens.common.address_verification]: '주소검증',
    [tokens.common.address_verified]: '통과',
    [tokens.common.address_unverified]: '주소 미검증',
    [tokens.common.outbound_requestable]: '요청가능',
    [tokens.common.outbound_request_done]: '요청됨',
    [tokens.common.outbound_request_failed]: '요청실패',
    [tokens.common.outbound_fail_not_received]: '접수상태 아님',
    [tokens.common.outbound_fail_stock_shortage]: '재고부족',
    [tokens.common.outbound_fail_invoice_rejected]: '송장채번 거절',
    [tokens.common.outbound_fail_no_history]: '실패 이력이 없습니다',
    [tokens.common.outbound_fail_date]: '일시',
    [tokens.common.label_partially_printed]: '송장 {{count}}건이 출력되지 않았습니다. 목록을 파일로 저장했습니다.',
    [tokens.common.order_channel]: '주문채널',
    [tokens.common.select_order_channel]: '주문채널 선택',
    [tokens.common.withdraw_order]: '주문취소',
    [tokens.common.withdraw_order_no_logistics_code]: '주문취소 선택된 출고 물류코드가 없습니다',
    [tokens.common.order_code]: '주문코드',
    [tokens.common.purchase_code]: '수주번호',
    [tokens.common.search_order_code]: '주문코드 검색',
    [tokens.common.order_code_sales_product_name]: '주문코드 발주처 발주처 상품 상품명',
    [tokens.common.order_confirmed]: '주문확정',
    [tokens.common.address]: '주소',
    [tokens.common.search_address]: '주소 검색',
    [tokens.common.address_detail]: '주소 상세',
    [tokens.common.address_search]: '주소검색',
    [tokens.common.address_required]: '주소는 필수 입니다',
    [tokens.common.precautions_confirmed]: '주의사항을 확인하였습니다',
    [tokens.common.preparing]: '준비중',
    [tokens.common.current_excel_coming_soon]: '현재 엑셀 다운로드 기능을 준비 중 입니다.',
    [tokens.common.duplicated_category_name]: '중복된 카테고리명이 존재합니다',
    [tokens.common.middle_classification]: '중분류',
    [tokens.common.select_middle_classification]: '중분류 선택',
    [tokens.common.middle_classification_required_if_adding]: '중분류 카테고리 추가시 대분류는 필수입니다',
    [tokens.common.middle_classification_required]: '중분류 카테고리는 필수입니다',
    [tokens.common.middle_classification_is_required]: '중분류는 필수 입니다',
    [tokens.common.immediate_regulation_termination]: '즉시 규제 종료',
    [tokens.common.favorites_only]: '즐겨찾기만 보기',
    [tokens.common.payment_amount_3]: '지급액',
    [tokens.common.last_month]: '지난달',
    [tokens.common.last_week_2]: '지난주',
    [tokens.common.branch_line]: '지선',
    [tokens.common.branch_route]: '지선 라우트',
    [tokens.common.branch_route_detail]: '지선 라우트 상세',
    [tokens.common.adjust_feeder_route]: '지선라우트 수정',
    [tokens.common.instruction]: '지시',
    [tokens.common.irreversible_instruction_warning]: '지시 후에는 되돌릴 수 없으며 다음 작업 단계로 넘어갑니다',
    [tokens.common.no_inventory_replenishment_instruction]: '지시된 재고보충 내역이 없습니다',
    [tokens.common.indicator]: '지시자',
    [tokens.common.search_indicator]: '지시자 검색',
    [tokens.common.indicator_info]: '지시자 정보',
    [tokens.common.select_indicator]: '지시자를 검색 선택 해주세요',
    [tokens.common.designation_needed]: '지정 필요',
    [tokens.common.direct_shipping]: '직송',
    [tokens.common.direct_shipping_order_impossible]: '직송 상품은 개별 발주가 불가능 합니다 발주 상품을 다시 확인해주시기 바랍니다',
    [tokens.common.direct_shipping_receipt]: '직송 입고 확인서',
    [tokens.common.direct_input]: '직접 입력',
    [tokens.common.direct_input_selection]: '직접입력 선택한 경우',
    [tokens.common.entry_method_details]: '진입방법상세',
    [tokens.common.progress_status]: '진행상태',
    [tokens.common.in_progress]: '진행중 조사 로케이션수 총 로케이션 수',
    [tokens.common.deducted]: '차감',
    [tokens.common.deducted_payment_amount]: '차감 지급액',
    [tokens.common.vehicle]: '차량 정보',
    [tokens.common.no_vehicle_information]: '차량 정보 없음',
    [tokens.common.vehicle_classification_fixed_departures]: '차량구분 : 고정 / 출차횟수 : {{totalDlv}}',
    [tokens.common.vehicle_number]: '차량번호',
    [tokens.common.vehicle_number_more]: '차량번호 더',
    [tokens.common.vehicle_number_maximum_entries]: '차량번호 최대 10자리를 입력해주세요',
    [tokens.common.vehicle_number_minimum_entries]: '차량번호 최소 7자리를 입력해주세요',
    [tokens.common.vehicle_number_required]: '차량번호를 필수로 입력해주세요',
    [tokens.common.vehicle_cost]: '차량비용',
    [tokens.common.vehicle_information]: '차량정보',
    [tokens.common.vehicle_information_details]: '차량정보 정보',
    [tokens.common.landing]: '착지',
    [tokens.common.select_landing]: '착지 선택',
    [tokens.common.find]: '찾기',
    [tokens.common.bonds]: '채권 관리',
    [tokens.common.bonds_management_suspended]: '채권 관리가 정지되며 한도금액 내에서 즉시 주문이 가능합니다',
    [tokens.common.bonds_balance]: '채권 잔액',
    [tokens.common.no_bond_details]: '채권내역이 존재하지 않습니다',
    [tokens.common.bond_status]: '채권상태',
    [tokens.common.bond_balance_currency]: '채권잔액',
    [tokens.common.treatment]: '처리',
    [tokens.common.treatable_quantity]: '처리 가능 수량',
    [tokens.common.treatment_result_search]: '처리 결과 검색 재조회',
    [tokens.common.treatment_result_warning]: '처리 결과는 수정이 불가하오니',
    [tokens.common.treatment_classification]: '처리 구분',
    [tokens.common.treatment_amount]: '처리 금액',
    [tokens.common.treatment_details]: '처리 내용',
    [tokens.common.enter_treatment_details]: '처리 내용 입력',
    [tokens.common.treatment_details_required]: '처리 내용은 필수입니다',
    [tokens.common.detailed_treatment_required]: '처리 내용은 필수입니다 처리내용은 자리 이하로 입력하여 주십시오',
    [tokens.common.enter_treatment_details_prompt]: '처리 내용을 입력하세요',
    [tokens.common.treatment_method]: '처리 방식',
    [tokens.common.treatment_reason]: '처리 사유',
    [tokens.common.treatment_status_required]: '처리 상태 필수입니다',
    [tokens.common.select_treatment_product]: '처리 상품 선택',
    [tokens.common.select_treatment]: '처리 선택',
    [tokens.common.treatment_quantity_exceeds]: '처리 수량은 실배송수량을 초과할 수 없습니다',
    [tokens.common.treatment_completed]: '처리 완료',
    [tokens.common.treatment_request]: '처리 요청',
    [tokens.common.treatment_type]: '처리 유형',
    [tokens.common.treatment_datetime]: '처리 일시',
    [tokens.common.treatment_date_required]: '처리 적용일은 필수 입니다',
    [tokens.common.treatment_needed]: '처리 필요',
    [tokens.common.quantity_that_can_be_processed]: '처리가능수량',
    [tokens.common.number_of_cases_processed]: '처리건수',
    [tokens.common.processing_result]: '처리결과',
    [tokens.common.address_delete_fail]: 'Etomars ERROR 개발팀에 문의해주세요',
    [tokens.common.processing_classification]: '처리구분',
    [tokens.common.select_processing_classification]: '처리구분을 선택하세요',
    [tokens.common.processing_details]: '처리내용',
    [tokens.common.processing_details_detail]: '처리내용 상세',
    [tokens.common.processing_details_limit]: '처리내용은 {{processingDetail}} 자리 이하로 입력하여 주십시오',
    [tokens.common.processing_manager]: '처리담당자',
    [tokens.common.reason_for_processing]: '처리사유',
    [tokens.common.reason_for_processing_required]: '처리사유는 선택 필수입니다',
    [tokens.common.reason_for_processing_mandatory]: '처리사유는 필수입니다',
    [tokens.common.processing_status]: '처리상태',
    [tokens.common.processing_status_mandatory]: '처리상태 필수',
    [tokens.common.processing_quantity]: '처리수량',
    [tokens.common.enter_processing_quantity]: '처리수량 입력',
    [tokens.common.enter_processing_quantity_prompt]: '처리수량을 입력하세요',
    [tokens.common.processing_time]: '처리시점',
    [tokens.common.processing_confirmation]: '처리여부',
    [tokens.common.processing_completed]: '처리완료',
    [tokens.common.processing_type]: '처리유형',
    [tokens.common.processing_type_reason]: '처리유형 / 사유',
    [tokens.common.processing_date]: '처리일',
    [tokens.common.processing_date_responsible_person]: '처리일 / 처리자',
    [tokens.common.processing_datetime]: '처리일시',
    [tokens.common.processing_date_query]: '처리일자',
    [tokens.common.processing_responsible]: '처리자',
    [tokens.common.search_processing_responsible]: '처리자 검색',
    [tokens.common.select_processing_handler]: '처리자를 검색 선택 해주세요',
    [tokens.common.processing_in_progress]: '처리중',
    [tokens.common.processing_history_only]: '처리중 이력만 보기',
    [tokens.common.execute_processing]: '처리하기',
    [tokens.common.cheonan]: '천안',
    [tokens.common.attach_contract_documents]: '첨부 계약 서류',
    [tokens.common.attach_file]: '첨부 파일',
    [tokens.common.attachment]: '첨부파일',
    [tokens.common.check_when_registering]: '체크 시 해당 계정으로 등록한 이력 중 처리중 내역만 노출',
    [tokens.common.checkbox]: '체크박스 양품화 반품 폐기',
    [tokens.common.checked_amount_and_reason]: '체크한 항목에 대해서 금액과 사유를 입력해주세요',
    [tokens.common.initial_target_setting]: '초기 대상 설정',
    [tokens.common.initial_month]: '초기 월',
    [tokens.common.reset]: '초기화',
    [tokens.common.initialization_processing]: '초기화처리',
    [tokens.common.total_1]: '총',
    [tokens.common.total_count_1]: '총 {{basicTotal}} 개',
    [tokens.common.total_route_count]: '총 개 라우트',
    [tokens.common.total_route_count]: '총 {{totalRoute}} 개 라우트',
    [tokens.common.total_amount_in_thousands]: '총 개 만원',
    [tokens.common.total_sales_details]: '총 개 매출 내역',
    [tokens.common.total_sales_source]: '총 {{totalSalesSource}}개 발주처',
    [tokens.common.total_logistics_code_count]: '총 {{totalLogisticCode}}개 물류코드',
    [tokens.common.total_logistics_code_selection]: '총 {{totalLogisticCode}}개 물류코드 선택',
    [tokens.common.total_products]: '총 {{totalProducts}} 개 상품',
    [tokens.common.total_packages]: '총 {{totalPackages}} 개 패키지',
    [tokens.common.total_positive_records]: '총 {{totalPositive}} 개 양수 내역',
    [tokens.common.total_entries]: '총 개의',
    [tokens.common.total_trading_companies]: '총 {{tradingCompanies}}개의 법인',
    [tokens.common.total_announcements]: '총 {{totalAnnouncements}} 개의 공지사항',
    [tokens.common.total_urgent_dispatch_history]: '총 {{totalUrgent}} 개의 긴급출고 이력',
    [tokens.common.total_locations]: '총 {{totalLocation}}개의 로케이션',
    [tokens.common.total_purchase_history]: '총 {{totalPurchaseHistory}} 개의 매입 내역',
    [tokens.common.total_inbound_history]: '총 {{totalPurchaseHistory}} 개의 입고 내역',
    [tokens.common.total_inbound_expected_qty]: '총 {{qty}} 개의 입고 예정 수량',
    [tokens.common.total_inbound_qty]: '총 {{qty}} 개의 입고 수량',
    [tokens.common.total_suppliers]: '총 {{totalPurchaser}} 개의 매입처',
    [tokens.common.total_sales_outlets]: '총 개의 발주처',
    [tokens.common.total_sales_outlets]: '총 {{totalCustomer}} 개의 발주처',
    [tokens.common.total_sales_outlets_selection]: '총 {{totalSelectedSales}}개의 발주처 선택',
    [tokens.common.total_unassigned_sales_outlets]: '총 개의 미배정 발주처',
    [tokens.common.total_return_exchange_history]: '총 {{returnExchange}} 개의 반품 & 교환 이력',
    [tokens.common.total_return_details]: '총 {{totalReturn}} 개의 반품 내역',
    [tokens.common.total_sale_history]: '총 {{totalSaleHistory}} 개의 매출 내역',
    [tokens.common.total_change_history]: '총 {{totalChangeHistory}}개의 변경이력',
    [tokens.common.total_sluggish_inventory]: '총 {{totalSluggishInventory}} 개의 부진재고',
    [tokens.common.total_brands]: '총 {{totalBrand}}개의 거래처',
    [tokens.common.total_consultation_history]: '총 {{totalConsultationHistory}} 개의 상담 이력',
    [tokens.common.total_items]: '총 {{totalGoods}} 개의 상품',
    [tokens.common.total_modification_history]: '총 {{totalModificationHistory}}개의 수정이력',
    [tokens.common.total_modification_items]: '총 {{totalModificationItem}}개의 수정항목',
    [tokens.common.total_issue_details]: '총 {{totalIssue}} 개의 이슈 내역',
    [tokens.common.total_inventory_history]: '총 {{totalInventoryHistory}} 개의 재고이력',
    [tokens.common.total_frequently_asked_questions]: '총 {{totalQuestions}} 개의 자주 묻는 질문',
    [tokens.common.total_statements]: '총 {{settlementTotal}} 개의 정산서',
    [tokens.common.total_adjustment_details]: '총 {{totalAdjustmentHistory}} 개의 조정 내역',
    [tokens.common.total_bonds]: '총 {{totalBonds}} 개의 채권',
    [tokens.common.total_claim_history]: '총 {{totalClaimHistory}} 개의 클레임 이력',
    [tokens.common.total_recovery_details]: '총 {{totalRecoveryHistory}} 개의 회수 내역',
    [tokens.common.total_cases]: '총 {{totalBasic2}} 건',
    [tokens.common.total_box]: '총 {{totalBox}} 박스',
    [tokens.common.total_sum_qty]: '총 합계 수량 {{totalQty}} EA',
    [tokens.common.confirm_total_case_download]: '총 {{totalHistory}} 건 의 내역을 다운로드 하시겠습니까',
    [tokens.common.confirm_total_order_details_download]: '총 {{totalOrderDetailExcelDownload}} 건 주문을 다운로드 하시겠습니까?',
    [tokens.common.total_urgent_dispatch_vehicle_cost]: '총 {{totalUrgent}} 건의 긴급배차',
    [tokens.common.total_purchase_order_history]: '총 {{totalPurchaseOrderHistory}}건의 발주내역',
    [tokens.common.total_labels]: '총 라벨수',
    [tokens.common.total_sales_outlets_count]: '총 발주처 수',
    [tokens.common.total_managers]: '총 {{totalManager}} 명의 매니저',
    [tokens.common.total_order_amount]: '총 발주금액',
    [tokens.common.total_dispatch_cost]: '총 배차비용',
    [tokens.common.total_product_count]: '총 상품 수',
    [tokens.common.total_count]: '총 수',
    [tokens.common.total_file_size_limit]: '총 파일 사이즈는 {{totalFileSizeLimit}}MB를 넘을 수 없습니다',
    [tokens.common.total_refund_scheduled_amount]: '총 환불(예정) 금액',
    [tokens.common.total_virtual_account_amount]: '총 {{totalVirtualAccount}} 개 가상계좌',
    [tokens.common.total_sessions]: '총 {{totalCount}} 회',
    [tokens.common.total_trading_volume]: '총거래량',
    [tokens.common.total_picking_output]: '총량 피킹지 출력',
    [tokens.common.print_all_searched_list]: '조회된 리스트 전체를 출력하시겠습니까?',
    [tokens.common.recent_order_details_last_days]: '최근 {{recentOrderDay}} 일의 주문내역이 노출됩니다',
    [tokens.common.recent_order_amount_last_days]: '최근 30일 주문금액',
    [tokens.common.recent_order_frequency_last_days]: '최근 30일 주문횟수',
    [tokens.common.maximum_storage_capacity]: '최대보관량',
    [tokens.common.minimum_order]: '최소 주문',
    [tokens.common.minimum_order_quantity]: '최소 주문 수량',
    [tokens.common.enter_minimum_order_quantity]: '최소 주문수량 입력',
    [tokens.common.minimum_order_quantity_required]: '최소 주문수량은 필수 입니다',
    [tokens.common.select_at_least_one_order_item]: '최소 하나의 주문 품목을 선택하세요',
    [tokens.common.final_fault]: '최종 귀책',
    [tokens.common.final_fault_required]: '최종 귀책은 필수입니다',
    [tokens.common.final_end_of_period]: '최종 기말',
    [tokens.common.final_consultation_type]: '최종 상담유형',
    [tokens.common.final_consultation_type_required]: '최종 상담유형은 필수입니다',
    [tokens.common.final_detail_type_required]: '최종 상세유형은 필수입니다',
    [tokens.common.final_modification]: '최종 수정',
    [tokens.common.final_completion_date]: '최종 처리완료일',
    [tokens.common.select_final_fault]: '최종귀책을 선택하세요',
    [tokens.common.last_change_datetime]: '최종변경일시',
    [tokens.common.final_quantity]: '최종수량',
    [tokens.common.last_modified]: '최종수정',
    [tokens.common.initial_registration]: '최초 등록',
    [tokens.common.initial_registration_last_modification]: '최초 등록 / 최종 수정',
    [tokens.common.initial_registrar]: '최초 등록자',
    [tokens.common.addition]: '추가',
    [tokens.common.livestock_product_history_report_needed]: '축산물이력신고 필요 여부',
    [tokens.common.livestock_product_history_reporting_required]: '축산물이력신고 필요여부',
    [tokens.common.livestock_product_history_report_number]: '축산물이력신고번호',
    [tokens.common.delivery_processing]: '출고 처리',
    [tokens.common.shipping_price_notice]: '출고가 불가능한 경우 확인 후 직접 취소 처리 하시기 바랍니다',
    [tokens.common.in_shipment_quantity_note]: '출고량에 따라 다소 시간이 소요될 수 있습니다',
    [tokens.common.expected_to_be_shipped]: '출고예정',
    [tokens.common.expected_warehouse_delivery_date]: '출고예정일',
    [tokens.common.empty_page_expected_to_be_shipped]: '출고 예정 내역이 없습니다.',
    [tokens.common.delivery_warehouse_type]: '출고유형',
    [tokens.common.shipping_issue_details]: '출고이슈 상세',
    [tokens.common.shipping_date_requirement]: '출고일 변경시 출고일은 필수입니다',
    [tokens.common.change_delivery_date]: '출고일변경',
    [tokens.common.delivery_datetime]: '출고일시',
    [tokens.common.shipping_work_instruction]: '출고작업',
    [tokens.common.shipping_work_in_progress]: '출고작업 지시 중입니다',
    [tokens.common.shipping_work_progress_popup]: '출고작업 진행중 팝업',
    [tokens.common.shipping_order_instruction]: '출고지시',
    [tokens.common.shipping_order_failure]: '출고지시 실패',
    [tokens.common.shipping_processing_status]: '출고처리',
    [tokens.common.shipping_processing_result]: '출고처리 되었습니다 (성공:{{successCount}} 실패:{{failCount}})',
    [tokens.common.delivery_turn]: '출고 회차',
    [tokens.common.select_delivery_turn]: '출고 회차 선택',
    [tokens.common.print_total_picking_list]: '{{outboundCounts}}개의 출고회차의 총량 피킹지를 출력하시겠습니까?',
    [tokens.common.print_piece_picking_list]: '{{outboundCounts}}개의 출고회차의 개별 피킹지를 출력하시겠습니까?',
    [tokens.common.please_select_delivery_turn]: '출고 회차를 선택해주세요.',
    [tokens.common.please_select_only_one_delivery_turn]: '라벨 출력 시 출고 회차는 한 건만 가능합니다.',
    [tokens.common.delivery_turn_format_example]: 'YYMM-n (예: 2511-1, 2511-2)',
    [tokens.common.output_of_power]: '출력',
    [tokens.common.output_of_power_quantity]: '출력 라벨 수량',
    [tokens.common.to_print_no_shipping_work]: '출력할 간선 출고 작업이 없습니다',
    [tokens.common.to_print_no_transaction_statement]: '출력할 거래명세서가 없습니다',
    [tokens.common.to_print_no_delivery_order]: '출력할 납품서가 없습니다',
    [tokens.common.to_print_no_outbound_label]: '출력할 라벨이 없습니다',
    [tokens.common.to_print_no_picking_turn]: '출력할 피킹 회차가 없습니다',
    [tokens.common.depart_from_location_code]: '출발 로케이션 코드',
    [tokens.common.departure_center]: '출발센터',
    [tokens.common.origin_information]: '출발지 정보',
    [tokens.common.exit_delivery_management]: '출차 배송관리',
    [tokens.common.exit_center]: '출차 센터',
    [tokens.common.change_exit_center]: '출차 센터 변경',
    [tokens.common.exit_center_change_completed]: '출차 센터 변경이 완료 되었습니다',
    [tokens.common.batch_change_of_exit_center]: '출차 센터 일괄 변경',
    [tokens.common.weekday_exit_center_input_time]: '출차 - {{inboundCenterName}} 입고 (예정시간 : 평일 -',
    [tokens.common.outbound_delivery_management]: '출차배송관리',
    [tokens.common.departure_center_update]: '출차센터',
    [tokens.common.change_of_exit_center]: '출차센터변경',
    [tokens.common.departure_center_code]: '출차센터코드',
    [tokens.common.departure_datetime]: '출차일시',
    [tokens.common.departure_point]: '출차지',
    [tokens.common.select_departure_point]: '출차지 선택',
    [tokens.common.departure_center_point_required]: '출차지 센터는 필수 입니다',
    [tokens.common.cancellation]: '취소',
    [tokens.common.cancellation_warning]: '취소 후에는 재처리가 불가합니다',
    [tokens.common.has_been_canceled]: '취소되었습니다',
    [tokens.common.cancellation_status]: '취소상태',
    [tokens.common.cancellation_quantity]: '취소수량',
    [tokens.common.category]: '카테고리',
    [tokens.common.category_management]: '카테고리 관리',
    [tokens.common.category_immutable_once_registered]: '카테고리 등록 후에는 삭제 및 수정이 불가 합니다',
    [tokens.common.category_change]: '카테고리 변경',
    [tokens.common.category_change_area]: '카테고리 변경 영역',
    [tokens.common.category_change_completed]: '카테고리 변경이 완료 되었습니다',
    [tokens.common.category_deletion]: '카테고리 삭제',
    [tokens.common.category_deletion_completed]: '카테고리 삭제가 완료 되었습니다',
    [tokens.common.select_category]: '카테고리 선택',
    [tokens.common.category_selection_required]: '카테고리 선택은 필수 입니다',
    [tokens.common.add_category]: '카테고리 추가',
    [tokens.common.category_addition_completed]: '카테고리 추가가 완료 되었습니다',
    [tokens.common.category_code]: '카테고리 코드',
    [tokens.common.category_code_required]: '카테고리 코드는 필수 입니다',
    [tokens.common.category_name]: '카테고리명',
    [tokens.common.enter_and_add_category_name]: '카테고리명을 입력하고 추가해주세요',
    [tokens.common.enter_category_name]: '카테고리명을 입력하세요',
    [tokens.common.please_enter_category_name]: '카테고리명을 입력해주세요',
    [tokens.common.category_name_duplicate]: '카테고리명이 중복되었습니다',
    [tokens.common.category_name_code_duplicate]: '카테고리명이 중복되었습니다 카테고리 코드가 중복되었습니다',
    [tokens.common.by_category_default_purchase_profit_rate]: '카테고리별 기본 구매 이익율',
    [tokens.common.by_category_set_profit_rate]: '카테고리별 설정한 이익율에 따라 정해진 판매가',
    [tokens.common.category_profit_rate_setting]: '카테고리별 이익율 설정',
    [tokens.common.code]: '코드',
    [tokens.common.quick_cost]: '퀵비용',
    [tokens.common.by_clicking]: '클릭하여 파일 추가',
    [tokens.common.by_clicking_maximum_files]: '클릭하여 파일 추가 이하 최대 개',
    [tokens.common.by_clicking_drag_and_drop_maximum_files]: '클릭하여 파일 추가 혹은 여기로 드래그 ({{lessCapacity}}이하 최대 {{maxFileCount}}개)',
    [tokens.common.get_on]: '타 전산 연동 정보',
    [tokens.common.get_on_required]: '타 전산 연동 필요 여부',
    [tokens.common.get_on_code_input]: '타 전산 코드 입력',
    [tokens.common.other_computers_code_input]: '바코드 입력',
    [tokens.common.classification_of_other_computer_systems]: '타전산구분',
    [tokens.common.other_computer_linkage_code]: '타전산연동코드',
    [tokens.common.other_computer_interconnection_codes_required]: '타전산연동코드는 필수 입니다',
    [tokens.common.whether_interconnection_with_other_computers_is_necessary]: '타전산연동필요여부',
    [tokens.common.other_computer_code]: '상품바코드',
    [tokens.common.goods_barcode_select]: '상품 바코드 선택',
    [tokens.common.duplicate_goods_barcode_select]: '중복 상품 바코드 선택',
    [tokens.common.other_computer_code_duplicate]: '타전산코드가 중복되었습니다',
    [tokens.common.other_computer_codes_required]: '타전산코드는 필수 입니다',
    [tokens.common.other_computerized_item_code]: '타전산품목코드',
    [tokens.common.other_item_code]: '바코드',
    [tokens.common.goods_barcode_required]: '상품바코드는 필수 입니다',
    [tokens.common.sales_code]: '발주처코드',
    [tokens.common.sales_code_input]: '발주처 코드 입력',
    [tokens.common.sales_code_required]: '발주처 코드는 필수 입니다',
    [tokens.common.sales_code_duplicate]: '발주처코드가 중복되었습니다',
    [tokens.common.test]: '테스트',
    [tokens.common.table]: '테이블',
    [tokens.common.table_area]: '테이블 영역',
    [tokens.common.significant]: '특이사항',
    [tokens.common.picking_delivery_statement_printYn]: '개별피킹 납품서 출력 여부',
    [tokens.common.print]: '출력',
    [tokens.common.not_print]: '미 출력',
    [tokens.common.significant_input]: '특이사항 입력',
    [tokens.common.team_come_id]: 'CMS ID',
    [tokens.common.team_come_input]: 'CMS ID 입력',
    [tokens.common.team_come_id_required]: 'CMS ID는 필수 입니다',
    [tokens.common.file_limit]: '파일 개수는 {{fileLimitCount}}개를 넘을 수 없습니다',
    [tokens.common.file_data_entry_warning]: '파일 내 데이터 오입력 발생 시 등록되지 않으니 다시 한번 확인하시기 바랍니다',
    [tokens.common.file_size_limit_per_file]: '파일 당 - MB를 넘을 수 없습니다',
    [tokens.common.file_upload]: '파일 업로드',
    [tokens.common.file_upload_status_window]: '파일 업로드 상태창',
    [tokens.common.file_too_large]: '파일 크기가 너무 큽니다',
    [tokens.common.file_size_limit]: '파일당 {{fileSizeLimit}}MB를 넘을 수 없습니다',
    [tokens.common.file_absent]: '파일이 없습니다',
    [tokens.common.sale_absent]: '판매 내역이 없습니다',
    [tokens.common.sale_delivery_day]: '판매(배송)일',
    [tokens.common.sale_conversion_quantity]: '판매 시 변환 수량',
    [tokens.common.sales_profit_margin_2]: '판매 이익율',
    [tokens.common.sales_status]: '판매 현황',
    [tokens.common.sale_price]: '판매가',
    [tokens.common.sale_date]: '판매일',
    [tokens.common.sale_price_setting]: '판매가 설정',
    [tokens.common.sale_price_setting_required]: '판매가 설정은 필수 입니다',
    [tokens.common.reserved_sale_price_product]: '판매가 예약 상품',
    [tokens.common.sale_price_ratio]: '판매가/율',
    [tokens.common.sale_price_application_date]: '판매가 적용일',
    [tokens.common.sale_price_adjustment]: '판매가 조정',
    [tokens.common.sale_price_adjustment_including_reserved_product]: '판매가 조정 예약중인 상품이 포함되어 있습니다',
    [tokens.common.sale_price_or_profit_margin_error]: '판매가 혹은 이익율 이 올바르지 않습니다',
    [tokens.common.selling_price_required]: '판매가는 필수입니다',
    [tokens.common.sales_price_setting_classification]: '판매가설정구분',
    [tokens.common.reservation_for_sale_price]: '판매가예약',
    [tokens.common.sales_amount_exclusion]: '판매금액(VAT제외)',
    [tokens.common.sales_quantity]: '판매수량',
    [tokens.common.popup]: '팝업',
    [tokens.common.material_code]: '품목코드',
    [tokens.common.material_name]: '품목명',
    [tokens.common.popup_area_sales_outlet_search_popup]: '팝업 영역 발주처 검색 팝업',
    [tokens.common.password_change]: '패스워드 변경',
    [tokens.common.password_change_button]: '패스워드 변경 시 이 버튼을 눌러주세요',
    [tokens.common.password_change_completed]: '패스워드 변경이 완료 되었습니다',
    [tokens.common.password_reset_prompt]: '패스워드 초기화를 하시겠습니까',
    [tokens.common.password_reset_completed]: '패스워드 초기화를 하였습니다',
    [tokens.common.password_verification]: '패스워드 확인',
    [tokens.common.password_incorrect]: '패스워드가 올바르지 않습니다',
    [tokens.common.password_mismatch_2]: '패스워드가 일치하지 않습니다',
    [tokens.common.password_match_2]: '패스워드가 일치합니다',
    [tokens.common.password_required]: '패스워드는 필수 입니다',
    [tokens.common.enter_password]: '패스워드를 입력하여 주십시오',
    [tokens.common.please_enter_password]: '패스워드를 입력해주세요',
    [tokens.common.page_absent]: '페이지가 존재하지 않습니다',
    [tokens.common.average_order_amount]: '평균 주문금액',
    [tokens.common.average_selling_price]: '평균판매가',
    [tokens.common.weekdays]: '평일',
    [tokens.common.weekdays_closure]: '평일 마감',
    [tokens.common.no_weekdays]: '평일 없음',
    [tokens.common.dispose]: '폐기',
    [tokens.common.scheduled_for_dispose]: '폐기 예정',
    [tokens.common.scheduled_for_disposal]: '폐기예정',
    [tokens.common.stock_holding]: '재고홀딩',
    [tokens.common.disposal_processing]: '폐기처리',
    [tokens.common.filter]: '필터',
    [tokens.common.filter_area]: '필터 영역',
    [tokens.common.filter_code]: '필터코드',
    [tokens.common.filter_code_length_limit]: '필터코드는 {{filterCodeLengthLimit}}자를 넘을 수 없습니다',
    [tokens.common.bottom]: '하단',
    [tokens.common.bottom_reference]: '하단 참조 입고예정서 참고',
    [tokens.common.down]: '하위 카테고리가 있을 경우 카테고리 코드를 삭제 할 수 없습니다',
    [tokens.common.piece]: '한개 이상 대기업을 등록해 주십시오',
    [tokens.common.hangeon]: '한건 이라도 실패 있으면 실패 강조 처리',
    [tokens.common.korean]: '한글 입력은 불가합니다',
    [tokens.common.limit]: '한도 금액 초과 시에는 주문이 불가능합니다',
    [tokens.common.limit_amount]: '한도 원 채권잔액 원',
    [tokens.common.temporary_limit_adjustment]: '한도 임시 조정',
    [tokens.common.the_limit_is_temporarily_adjusted]: '한도가 임시 조정 되었습니다',
    [tokens.common.total_2]: '합계',
    [tokens.common.total_amount_2]: '합계금액',
    [tokens.common.total_amount_inclusive_of_tax]: '합계금액은 소비세가 포함된 금액입니다',
    [tokens.common.delete_virtual_account]: '해당 가상계좌를 삭제하시겠습니까',
    [tokens.common.non_exposure_of_product_on_scheduled_delivery_date]: '해당 기간의 배송예정일에는 선택 된 상품이 노출되지 않습니다',
    [tokens.common.delete_menu]: '해당 메뉴를 삭제합니다 메뉴 삭제시 하위 메뉴도 삭제 됩니다 진행 하시겠습니까',
    [tokens.common.switch_product_require_password]: '해당 상품을 {{switchGoodsStatus}} 전환 하시는 경우 비밀번호를 입력해주세요',
    [tokens.common.data_irreversibility_after_approval]: '해당 승인 이후에는 데이터 원복이 불가하며 가상계좌번호가 다른 발주처에 연동될 수 있습니다',
    [tokens.common.no_return_details_in_statement]: '해당 정산서에 포함할 반품 내역이 없습니다',
    [tokens.common.process_receipt_of_order]: '해당 주문건에 대해 접수 처리를 하시겠습니까',
    [tokens.common.filter_only_included_orders]: '해당 주문에 포함되지 않는 값도 같이 넘어오기 때문에 해당 주문의 상품만 필터링',
    [tokens.common.no_assigned_route_for_turn]: '해당 회차에 배정된 라우트가 없습니다',
    [tokens.common.not_applicable]: '해당없음',
    [tokens.common.no_individual_picking_paper_available]: '해당하는 조건에 출력할 수 있는 개별피킹지가 없습니다',
    [tokens.common.no_total_picking_paper_available]: '해당하는 조건에 출력할 수 있는 총량피킹지가 없습니다',
    [tokens.common.order_qty]: '주문수량',
    [tokens.common.lot]: 'LOT',
    [tokens.common.enter_individual_picking_code_to_search]: '개별피킹코드를 입력하여 검수할 상품을 조회하세요',
    [tokens.common.no_label_available]: '해당하는 조건에 출력할 수 있는 라벨이 없습니다 조회하는 센터 기준과 착지가 동일할 수 없습니다',
    [tokens.common.view_only_termination_approval_status]: '해지 승인 대기 상태만 보기',
    [tokens.common.termination_approval_disconnection_of_virtual_account]:
        "해지 승인 시 해당 발주처와 가상계좌 번호의 연동이 끊기며 해당 가상계좌의 계좌 잔액이 '0'원으로 변경됩니다.",
    [tokens.common.termination_completed]: '해지 완료',
    [tokens.common.termination_request_1]: '해지 요청',
    [tokens.common.termination_status]: '해지상태',
    [tokens.common.termination_request_2]: '해지요청',
    [tokens.common.now]: '현재',
    [tokens.common.current_purchase_profit_rate]: '현재 구매 이익율',
    [tokens.common.current_password_matches]: '현재 패스워드와 동일합니다',
    [tokens.common.current_selling_price]: '현재판매가',
    [tokens.common.home]: '홈으로',
    [tokens.common.check]: '확인',
    [tokens.common.proceed_with_care]: '확인 후 신중하게 진행',
    [tokens.common.confirmation_required]: '확인필요',
    [tokens.common.confirmed]: '확정',
    [tokens.common.undisposed_confirmed_quantity]: '[미폐기]확정량',
    [tokens.common.confirmation_process]: '확정 처리',
    [tokens.common.confirmation_processor]: '확정 처리자',
    [tokens.common.post_confirmation_inventory_immediately_reflected]: '확정 후 재고수불부에 즉시 반영되며 수정이 불가하오니 다시 한번 확인해주세요.',
    [tokens.common.confirmed_closing_date_and_time]: '확정마감일시',
    [tokens.common.confirmed_date_and_time]: '확정일시',
    [tokens.common.confirmed_date]: '확정일자',
    [tokens.common.confirmed_person]: '확정자',
    [tokens.common.refund_amount]: '환불 금액',
    [tokens.common.expected_refund_amount_including_request_amount]: '환불예정금액 요청금액 포함',
    [tokens.common.episode]: '회',
    [tokens.common.company_name_required]: '회사명',
    [tokens.common.collection_and_processing_information]: '회수 및 처리 정보',
    [tokens.common.collection_and_processing_information_details]: '회수 및 처리정보',
    [tokens.common.collection_shipping_code_self_disposal]: '회수 배송 코드 자체폐기',
    [tokens.common.select_collection_reason]: '회수 사유 선택',
    [tokens.common.please_select_a_collection_reason]: '회수 사유를 선택해주세요',
    [tokens.common.view_recovery_photos_1]: '회수 사진 보기',
    [tokens.common.no_recovery_photos]: '회수 사진이 없습니다',
    [tokens.common.collection_quantity_order_unit]: '회수 수량 / 주문 단위',
    [tokens.common.collection_completed]: '회수 완료',
    [tokens.common.collection_completed_quantity]: '회수 완료 수량',
    [tokens.common.collection_request_cancellation]: '회수 요청 취소',
    [tokens.common.collection_request_deleted_customer_refund_procedure_cancelled]: '회수 요청이 삭제되고 고객 환불 절차가 모두 취소되며',
    [tokens.common.collection_incoming]: '회수 입고',
    [tokens.common.collection_receipt]: '회수/접수',
    [tokens.common.collection_progress_code_collection_completed]: '회수 진행 코드 회수완료',
    [tokens.common.collection_processing]: '회수 처리',
    [tokens.common.select_collection_processing_type]: '회수 처리 유형 선택',
    [tokens.common.please_select_a_collection_processing_type]: '회수 처리 유형을 선택해주세요',
    [tokens.common.collection_processing_code_partial_complete_complete]: '회수 처리 코드 부분완료 완료',
    [tokens.common.collection_processing_irreversible_post_processing_reflected_in_inventory]:
        '회수 처리 후에는 수정이 불가하며 재고수불부에 반영됩니다',
    [tokens.common.collection_processing_not_done]: '회수 처리가 되지 않았습니다',
    [tokens.common.collection_cancellation]: '회수 취소',
    [tokens.common.collection_cancellation_proceed_with_caution]:
        '회수 취소 시 배송매니저 회수 리스트에서 즉시 삭제되며, 해당 발주처에 환불이 확정 되오니 신중하게 확인 후 진행하시기 바랍니다.',
    [tokens.common.collection_required_quantity]: '회수 필요 수량',
    [tokens.common.number_of_collections]: '회수건수',
    [tokens.common.recovery_result]: '회수결과',
    [tokens.common.view_unprocessed_recovery_results_only]: '회수결과 미처리 만 보기',
    [tokens.common.collection_manager]: '회수매니저',
    [tokens.common.select_a_reason_for_recovery]: '회수사유 선택',
    [tokens.common.view_recovery_photos_2]: '회수사진보기',
    [tokens.common.recovery_status]: '회수상태',
    [tokens.common.recovery_status_option]: '회수여부',
    [tokens.common.select_whether_to_recover]: '회수여부를 선택하세요',
    [tokens.common.recovery_completed]: '회수완료',
    [tokens.common.recovery_completed_display]: '회수완료 후 회수 처리 결과를 표시',
    [tokens.common.recovery_request_immediate_refund]: '회수요청(즉시환불)',
    [tokens.common.collection_date]: '회수일',
    [tokens.common.recovering]: '회수중',
    [tokens.common.cancel_request_during_recovery]: '회수중 요청취소',
    [tokens.common.cancel_possible_during_recovery]: '회수중 체크 활성화 취소 가능',
    [tokens.common.recovery_processing_done]: '회수처리 되었습니다',
    [tokens.common.recovery_processing_type_return_disposal_recovery]: '회수처리 유형 양품화 반품 폐기',
    [tokens.common.cancellation_of_collection]: '회수취소',
    [tokens.common.cancellation_of_collection_done]: '회수취소 되었습니다',
    [tokens.common.recovery_code]: '회수코드',
    [tokens.common.recovery_code_details]: '회수코드 상품 상품명 발주처 회수매니저',
    [tokens.common.round]: '회차',
    [tokens.common.select_print_issue_for_round]: '[{{pickingRound}}회차] 이미 발급한 출력 건으로 피킹회차를 선택해주세요',
    [tokens.common.register_round]: '회차를 등록 해주세요',
    [tokens.common.select_round_mandatory]: '회차를 필수로 선택해주세요',
    [tokens.common.select_at_least_round]: '1회차 이상으로 선택해주세요',
    [tokens.common.select_up_to_round]: '10회차 이하로 선택해주세요',
    [tokens.common.mobile_phone_number_entry]: '휴대폰번호',
    [tokens.common.enter_mobile_phone_number_digits]: '휴대폰번호 11자리를 입력해주세요',
    [tokens.common.enter_accurate_mobile_phone_number]: '휴대폰번호를 정확히 입력하여 주십시오',
    [tokens.common.enter_id]: 'ID를 입력하여 주십시오',
    [tokens.common.excel_download_limit]: '{{maxExcelCount}}건 이하만 엑셀 다운로드가 가능합니다',
    [tokens.common.enter_up_to_n_digits]: 'n자리 이하로 입력하여 주십시오',
    [tokens.common.time]: '시간',
    [tokens.common.hour]: '시',
    [tokens.common.shipping_management]: '출고 관리',
    [tokens.common.shipping_wait]: '출고 대기',
    [tokens.common.shipping_work]: '출고 작업',
    [tokens.common.shipping_completed]: '출고 완료',
    [tokens.common.shipping_history_excel_download]: '출고 이력 엑셀 다운로드',
    [tokens.common.shipping_date]: '출고일',
    [tokens.common.total_shipping_history]: '총 {{totalShippingHistory}} 개의 출고 이력',
    [tokens.common.empty_page_shipping_history]: '출고 이력 내역이 없습니다',
    [tokens.common.history]: '내역',
    [tokens.common.empty_page_order_by_goods_list]: '주문이 없습니다.',
    [tokens.common.order_date]: '주문일',
    [tokens.common.view_unprocessed_only]: '미처리 내역만 보기',
    [tokens.common.inventory_history_inquiry]: '재고이력 조회',
    [tokens.common.inventory_audit_detail]: '재고 조사 상세',
    [tokens.common.inventory_audit_code]: '재고 조사 코드',
    [tokens.common.inventory_audit_date_and_time]: '재고 조사 일시',
    [tokens.common.inventory_audit_instruction]: '재고 조사 지시',
    [tokens.common.inventory_no_matching_count]: '재고불일치 상품 수',
    [tokens.common.inventory_no_matching_ratio]: '재고불일치 상품 비율',
    [tokens.common.view_no_audit_location_only]: '미조사 로케이션만 보기',
    [tokens.common.week]: '주',
    [tokens.common.warning_take_back_delete]: '회수 요청이 삭제되며, 취소 후에는 재처리가 불가합니다.',
    [tokens.common.shipping]: '출고',
    [tokens.common.warning_no_purchase_price_cant_use_y]: '매입가가 입력되지 않은 상품은 사용으로 전환 할 수 없습니다.',
    [tokens.common.unuse_conversion]: '미사용 전환',
    [tokens.common.excel_download_unuse_conversion_order_goods]: '미사용 전환 상품 주문 내역 엑셀 다운로드',
    [tokens.common.image_bulk_upload]: '이미지 대량 업로드',
    [tokens.common.register_goods]: '상품 등록',
    [tokens.common.update_goods]: '상품 수정',
    [tokens.common.purchase_manager_automatic_input]: '구매담당자 자동 입력',
    [tokens.common.input_specifications_for_order_goods_unit]: '상품 주문 단위에 대한 규격을 입력',
    [tokens.common.necessary]: '필요',
    [tokens.common.concealment]: '미노출',
    [tokens.common.max]: '최대',
    [tokens.common.each]: '개',
    [tokens.common.now_price]: '현재 판매가',
    [tokens.common.please_enter]: '입력해주세요',
    [tokens.common.include]: '포함',
    [tokens.common.sales_settlement_adjustment_handling]: '매출 정산 조정금 처리',
    [tokens.common.info_previous_month_sales_settlement_process_1]: '매출정산서의 조정금은 해당 정산서 내역에 반영됨에 따라,',
    [tokens.common.info_previous_month_sales_settlement_process_2]: "'전월' 기준만 가능하며, 매출반영 Y 로 자동 적용됩니다.",
    [tokens.common.view_non_exposure_purchaser]: '미노출 매입처 보기',
    [tokens.common.register_or_cancel_favorite]: '즐겨찾기 {{favoriteRegisterOrCancel}}완료되었습니다.',
    [tokens.common.view_non_exposed_product]: '미노출 상품보기',
    [tokens.common.not_confirmed]: '미확정',
    [tokens.common.settlement_adjustment_price]: '정산 조정금',
    [tokens.common.payment]: '결제',
    [tokens.common.person_in_charge_of_sales]: '발주처 담당자',
    [tokens.common.approve]: '승인',
    [tokens.common.error_message]: '에러 메시지',
    [tokens.common.file]: '파일',
    [tokens.common.virtual_account]: '가상계좌',
    [tokens.common.warning_purchase_order_request_update_1]: '발주 요청서 수정 시, 해당 상품의 매입처로 ',
    [tokens.common.warning_purchase_order_request_update_2]: '*수정된 발주 요청서*',
    [tokens.common.warning_purchase_order_request_update_3]: '가 발송 됩니다.',
    [tokens.common.warning_purchase_order_request_update_4]: '발송 후에는 취소할 수 없으니,',
    [tokens.common.warning_purchase_order_request_update_5]: '확인 후 신중하게 발주 ',
    [tokens.common.warning_purchase_order_request_update_6]: '하시기 바랍니다.',
    [tokens.common.warning_inbound_expected_request_update_1]: '입고 예정서 등록 후에는 취소할 수 없으니',
    [tokens.common.warning_inbound_expected_request_update_2]: '확인 후 신중하게 입고',
    [tokens.common.warning_inbound_expected_request_update_3]: '부탁드립니다.',
    [tokens.common.warning_inbound_expected_request_update_4]: '총 입고 예정 수량은 아래 수량 등록하시면 합산되어 표기 됩니다.',
    [tokens.common.warning_create_settlement_without_return_goods]: '반품 내역을 선택하지 않고, 정산서를 생성하시겠습니까?',
    [tokens.common.reflect]: '반영',
    [tokens.common.not_reflect]: '미반영',
    [tokens.common.unsettled_return_goods_history]: '미정산 반품내역',
    [tokens.common.total_return_history]: '반품 내역 갯수',
    [tokens.common.total_return_amount]: '반품 총 금액',
    [tokens.common.departure_place]: '발송지',
    [tokens.common.validate_required_logistic_code_1]: '물류코드는 필수입니다.',
    [tokens.common.validate_required_logistic_code_2]: '물류코드는 1개 이상 필수입니다.',
    [tokens.common.validate_change_outbound_date]: '출고 변경일은 오늘보다 이후 날짜여야 합니다',
    [tokens.common.re_shipping_order_instruction_complete]: '재출고 지시 완료 되었습니다.',
    [tokens.common.re_shipping_order_instruction]: '재출고 지시',
    [tokens.common.notice_to_customer_complete]: '고객에게 안내가 완료 된 건입니다.',
    [tokens.common.warn_cancel_order_1]: '주문 취소 시, 상품을',
    [tokens.common.warn_cancel_order_2]: '즉시 주문 취소',
    [tokens.common.warn_cancel_order_3]: '합니다.',
    [tokens.common.warn_cancel_order_4]: '주문 취소 시',
    [tokens.common.warn_cancel_order_5]: '자동 환불 ',
    [tokens.common.warn_cancel_order_6]: '되므로 신중하게',
    [tokens.common.warn_cancel_order_7]: '확인 후 처리 ',
    [tokens.common.warn_cancel_order_8]: '하시기 바랍니다.',
    [tokens.common.piece_picking_label_printing]: '개별피킹 라벨 출력',
    [tokens.common.not_need_trunk_plt_label_printing]: '간선 PLT 출력이 필요없는 대상입니다. (지선 출고만 있음)',
    [tokens.common.search_logistic_code_information]: '물류코드 정보 조회',
    [tokens.common.empty_page_list]: '목록이 존재하지 않습니다.',
    [tokens.common.empty_page_shipping_completed]: '출고 완료 내역이 없습니다.',
    [tokens.common.register_outbound_setting_completed]: '출고 설정 등록이 완료되었습니다.',
    [tokens.common.setting]: '설정',
    [tokens.common.picking_zone]: '피킹존',
    [tokens.common.ignore_picking_zone_inventory]: '피킹존 재고 무시',
    [tokens.common.check_picking_zone_inventory]: '피킹존 재고 확인',
    [tokens.common.instruct_shipping_work_completed]: '출고 작업 지시 되었습니다.',
    [tokens.common.instruct_shipping_work]: '출고 작업 지시',
    [tokens.common.shipping_setting]: '출고 설정',
    [tokens.common.empty_page_shipping_wait]: '출고 대기 작업이 없습니다.',
    [tokens.common.select_picking_turn]: '피킹회차 선택',
    [tokens.common.create_picking]: '피킹 생성',
    [tokens.common.picking_round]: '피킹 회차',
    [tokens.common.picking_round_format_example]: 'MMDD-n (예: 1125-1, 1125-2)',
    [tokens.common.empty_page_outbound_work]: '출고 작업이 없습니다',
    [tokens.common.picking_quantity]: '피킹 수량',
    [tokens.common.print_picking_list_no_outbound_logistics_code]: '피킹리스트 출력 - 선택된 출고 물류코드가 없습니다.',
    [tokens.common.print_picking_list]: '피킹리스트 출력',
    [tokens.common.order_registration_completed]: '주문 등록 완료되었습니다',
    [tokens.common.sales_channel_code]: '판매 채널 코드',
    [tokens.common.sales_channel_name]: '판매 채널명',
    [tokens.common.other_system_sales_channel_code]: '타 전산 발주처코드',
    [tokens.common.other_system_product_code]: '타 전산 상품코드',
    [tokens.common.title_2]: '타이틀',
    [tokens.common.app]: '앱',
    [tokens.common.folder]: '폴더',
    [tokens.common.link]: '링크',
    [tokens.common.child_app]: '자식앱',
    [tokens.common.monday]: '월요일',
    [tokens.common.tuesday]: '화요일',
    [tokens.common.wednesday]: '수요일',
    [tokens.common.thursday]: '목요일',
    [tokens.common.friday]: '금요일',
    [tokens.common.saturday]: '토요일',
    [tokens.common.sunday]: '일요일',
    [tokens.common.monday_short]: '월',
    [tokens.common.tuesday_short]: '화',
    [tokens.common.wednesday_short]: '수',
    [tokens.common.thursday_short]: '목',
    [tokens.common.friday_short]: '금',
    [tokens.common.saturday_short]: '토',
    [tokens.common.sunday_short]: '일',
    [tokens.common.january]: '1월',
    [tokens.common.february]: '2월',
    [tokens.common.march]: '3월',
    [tokens.common.april]: '4월',
    [tokens.common.may]: '5월',
    [tokens.common.june]: '6월',
    [tokens.common.july]: '7월',
    [tokens.common.august]: '8월',
    [tokens.common.september]: '9월',
    [tokens.common.october]: '10월',
    [tokens.common.november]: '11월',
    [tokens.common.december]: '12월',
    [tokens.common.adjustment_inventory_confirmed]: '재고 조정 확정',
    [tokens.common.ask_adjustment_inventory_confirmed]: '재고 조정 확정하시겠습니까?',
    [tokens.common.adjustment_inventory_required_quantity]:
        '재고 조정 수량은 0 ({{cancel}})이거나, {{adjustmentQuantity}} 수량으로 처리해 주시기 바랍니다.',
    [tokens.common.upload_batch_adjustment_inventory]: '재고 조정 일괄 업로드',
    [tokens.common.center_parameter]: '센터 파라미터',
    [tokens.common.no_center_parameter]: '센터 파라미터가 없습니다',
    [tokens.common.total_goods_selected]: '{{totalSelectedGoods}}개 상품 선택됨',
    [tokens.common.inventory_audit_confirmation_1]: '재고 조사 반영/확정 처리 시 재고 조정 리스트에 반영됩니다.',
    [tokens.common.inventory_audit_confirmation_2]: '손망실 처리',
    [tokens.common.inventory_audit_confirmation_3]: '처리자의 이름과 함께',
    [tokens.common.inventory_audit_confirmation_4]: '재고 수불부에 반영됩니다.',
    [tokens.common.inventory_audit_confirmation_5]: '확정 이후에는',
    [tokens.common.inventory_audit_confirmation_6]: '취소가 불가능합니다.',
    [tokens.common.inventory_audit_confirmation_7]: '오처리 시,',
    [tokens.common.inventory_audit_confirmation_8]: '직접 재고 조정을 통해',
    [tokens.common.inventory_audit_confirmation_9]: '재조정을 해야 하오니,',
    [tokens.common.inventory_audit_confirmation_10]: '신중하게 처리하시기 바랍니다.',
    [tokens.common.inventory_audit_confirmation_11]: '(미반영 시 재고 조사는 종료되지만 결과는 반영되지 않습니다.)',
    [tokens.common.inventory_audit_confirmed]: '재고 조사 확정 처리',
    [tokens.common.success_inventory_audit_confirmed]: '재고 조사 확정 처리 성공',
    [tokens.common.warn_inventory_investigation_1]: '재고 조사를 지시하는 경우 작업자 WEB에 재고조사 지시가 떨어지며,',
    [tokens.common.warn_inventory_investigation_2]: '센터 입・출고 작업이 모두 중단되오니, 신중하게 지시하시기 바랍니다.',
    [tokens.common.success_inventory_investigation_instruction]: '재고 조사 지시가 완료 되었습니다.',
    [tokens.common.fail_inventory_investigation_instruction]: '재고 조사 지시가 실패 되었습니다.',
    [tokens.common.in_progress_inventory_investigation_instruction]: '재고 조사 진행중 입니다.',
    [tokens.common.inventory_investigation_upload]: '재고 조사 업로드',
    [tokens.common.download_inventory_investigation_upload_form]: '재고조사 양식 다운로드',
    [tokens.common.inventory_investigation_information_excel_file]: '재고 조사 정보 Excel 파일',
    [tokens.common.required_purchase_request_form]: '발주 요청서 선택 필요',
    [tokens.common.confirmed_receiving_document]: '입고 확정서',
    [tokens.common.scheduled_receiving_document]: '입고 예정서',
    [tokens.common.scheduled_receiving_document_registration]: '입고 예정서 등록',
    [tokens.common.hourly_receiving_quantity]: '시간당 입고량',
    [tokens.common.check_return_detail]: '반품 내용 확인',
    [tokens.common.return]: '반품',
    [tokens.common.adjustment_inventory_detail]: '재고 조정 상세',
    [tokens.common.small]: '소',
    [tokens.common.success_upload]: '업로드가 완료 되었습니다.',
    [tokens.common.fail_upload]: '업로드에 실패하였습니다.',
    [tokens.common.expiration_date_adjustment_preorder_inventory_1]: '유통기한 마지노선 변경 시 재고 로스가 발생할 수 있으니,',
    [tokens.common.expiration_date_adjustment_preorder_inventory_2]: '설정한 기간에 따라 선주문 상품의 가용재고가 차감 됩니다.',
    [tokens.common.expiration_date_adjustment_preorder_inventory_3]: '다시 한번 신중하게 ',
    [tokens.common.expiration_date_adjustment_preorder_inventory_4]: '확인 후 진행',
    [tokens.common.expiration_date_adjustment_preorder_inventory_5]: '하시기 바랍니다.',
    [tokens.common.excel_download]: '엑셀 다운로드',
    [tokens.common.pre_order_inventory_deduction]: '선주문 재고차감',
    [tokens.common.tax_exemption]: '비과세',
    [tokens.common.manual_ordering]: '수동 발주',
    [tokens.common.resend]: '재전송',
    [tokens.common.exit_delivery_count]: '출차횟수',
    [tokens.common.designation]: '지정',
    [tokens.common.success_resend_url]: 'URL 재전송을 성공하였습니다.',
    [tokens.common.click_for_resend_url]: 'URL을 재전송하시려면 전송 버튼을 눌러주세요',
    [tokens.common.send_url]: 'URL 전송',
    [tokens.common.exposure_announcement]: '공지사항 노출',
    [tokens.common.final_detail_type]: '최종 상세유형',
    [tokens.common.first_consultation_type]: '1차 상담유형',
    [tokens.common.first_detail_type]: '1차 상세유형',
    [tokens.common.claim_content]: '클레임 내용',
    [tokens.common.claim_amount]: '클레임 금액',
    [tokens.common.claim_detail]: '클레임 상세',
    [tokens.common.prompt_claim_quantity]: '클레임수량을 입력하세요',
    [tokens.common.claim_quantity]: '클레임수량',
    [tokens.common.missing_treatment_classification]: '처리 구분 값 누락',
    [tokens.common.missing_attribution]: '귀책 값 누락',
    [tokens.common.missing_recovery_status]: '회수여부 값 누락',
    [tokens.common.missing_attribution_amount]: '귀책 금액 값 누락',
    [tokens.common.missing_treatment_quantity]: '처리 수량 값 누락',
    [tokens.common.missing_customer_refund_amount]: '발주처 환불 금액 값 누락',
    [tokens.common.register_return_exchange]: '반품 & 교환 접수',
    [tokens.common.processing_return_exchange]: '반품 & 교환 처리',
    [tokens.common.success_register_return_exchange]: '반품 & 교환 신청이 완료되었습니다.',
    [tokens.common.no_delivery]: '미배송',
    [tokens.common.order_timing]: '주문시점',
    [tokens.common.tax_goods_include_vat]: "'과세' 상품의 경우, 부가세가 포함되어 계산됩니다.",
    [tokens.common.collection_cancellation_proceed_with_caution_1]: '회수 취소 시, 배송매니저 회수 리스트에서',
    [tokens.common.collection_cancellation_proceed_with_caution_2]: '즉시 삭제되며 해당 발주처에 환불이 확정',
    [tokens.common.collection_cancellation_proceed_with_caution_3]: '되오니 신중하게',
    [tokens.common.collection_cancellation_proceed_with_caution_4]: '확인 후 진행',
    [tokens.common.collection_cancellation_proceed_with_caution_5]: '하시기 바랍니다.',
    [tokens.common.counselor_memo_delete]: '상담시 메모 삭제',
    [tokens.common.counselor_memo]: '상담사 메모',
    [tokens.common.prompt_memo]: '메모할 내용을 입력해주세요.',
    [tokens.common.empty_page_counselor_memo_history]: '상담사 메모 내역이 없습니다.',
    [tokens.common.ask_counselor_memo_delete]: '등록된 메모를 삭제하시겠습니까?',
    [tokens.common.receipt]: '접수',
    [tokens.common.approve_return]: '반품승인',
    [tokens.common.reject]: '반려',
    [tokens.common.return_exchange_detail]: '반품 & 교환 상세',
    [tokens.common.return_exchange_goods]: '반품 & 교환 상품',
    [tokens.common.empty_page_return_exchange_history]: '반품 & 교환 내역이 없습니다',
    [tokens.common.return_status]: '반품상태',
    [tokens.common.recovery_request]: '회수요청',
    [tokens.common.immediate_refund]: '즉시환불',
    [tokens.common.maximum_memo_prompt_over]: '최대 글자수가 초과되어 저장할 수 없습니다(2000자)',
    [tokens.common.save_memo]: '메모 저장',
    [tokens.common.expected_refund_amount]: '환불예정금액',
    [tokens.common.including_vat_request_amount]: '요청금액(VAT포함)',
    [tokens.common.request_1]: '요청',
    [tokens.common.except_1]: '외',
    [tokens.common.claim]: '클레임',
    [tokens.common.send_date_time]: '발송일시',
    [tokens.common.sender]: '발송자',
    [tokens.common.view_send_screen]: '발송 화면 보기',
    [tokens.common.success_send_message]: '메시지가 발송 되었습니다',
    [tokens.common.send_message]: '메시지 발송',
    [tokens.common.order_cancellation_immediate_1]: '주문 취소 시, 상품을 ',
    [tokens.common.order_cancellation_immediate_2]: '즉시 주문 취소합니다.',
    [tokens.common.order_cancellation_immediate_3]: '주문 취소 시',
    [tokens.common.order_cancellation_immediate_4]: '자동 환불',
    [tokens.common.order_cancellation_immediate_5]: '되므로 신중하게',
    [tokens.common.order_cancellation_immediate_6]: '확인 후 진행',
    [tokens.common.order_cancellation_immediate_7]: '하시기 바랍니다.',
    [tokens.common.total_urgent_delivery_vehicle_amount]: '총 긴급출고 차량비용',
    [tokens.common.batch_adjustment_irreversible_warning_1]: '일괄 조정 시에는 데이터 원복이 불가능하므로,',
    [tokens.common.batch_adjustment_irreversible_warning_2]: '다시 한번 신중하게,',
    [tokens.common.batch_adjustment_irreversible_warning_3]: '확인 후 진행',
    [tokens.common.batch_adjustment_irreversible_warning_4]: '하시기 바랍니다.',
    [tokens.common.purchase.order_request_date_time]: '발주요청일시',
    [tokens.common.adjustment_fee_processing_impact_1]: '조정금 처리 시 조정금액이',
    [tokens.common.adjustment_fee_processing_impact_2]: '즉시 채권에 반영되며,',
    [tokens.common.adjustment_fee_processing_impact_3]: '정산서에 반영 청구 되오니',
    [tokens.common.adjustment_fee_processing_impact_4]: '다시 한번 확인 후 처리하시기 바랍니다',
    [tokens.common.product_adjustment_by_item]: '상품별 조정 금액',
    [tokens.common.error_occurred]: '오류가 발생했습니다.',
    [tokens.common.update_contract_information]: '계약정보 수정',
    [tokens.common.pre_pay]: '선불',
    [tokens.common.post_pay]: '후불',
    [tokens.common.notice_sales_contract_type_update_1]: '발주처 계약형태 수정에 따른 내용에 대해 반드시',
    [tokens.common.notice_sales_contract_type_update_2]: '사전 확인 후 진행',
    [tokens.common.notice_sales_contract_type_update_3]: '하시기 바랍니다.',
    [tokens.common.select_japanese]: '선택(일본어)',
    [tokens.common.sprout_customer]: '새싹 고객',
    [tokens.common.weekend_closure_time]: '주말 마감 시간',
    [tokens.common.weekday_closure_time]: '주말 마감 시간',
    [tokens.common.order_info]: '주문 정보',
    [tokens.common.modify_information]: '정보 수정',
    [tokens.common.temporary_credit_limit]: '임시 여신 한도',
    [tokens.common.limit_1]: '한도',
    [tokens.common.customer_contact_name_1]: '발주처 담당자 1) 이름',
    [tokens.common.customer_contact_phone_1]: '발주처 담당자 1) 연락처',
    [tokens.common.customer_contact_email_1]: '발주처 담당자 1) 이메일',
    [tokens.common.customer_contact_name_2]: '발주처 담당자 2) 이름',
    [tokens.common.customer_contact_phone_2]: '발주처 담당자 2) 연락처',
    [tokens.common.customer_contact_email_2]: '발주처 담당자 2) 이메일',
    [tokens.common.transaction_statement_receipt_time]: '거래명세서 수취 시간',
    [tokens.common.contract_start_date]: '계약 시작일',
    [tokens.common.departure_center_id]: '출차센터 ID',
    [tokens.common.order_id]: '주문 ID',
    [tokens.common.order_content_2]: '주문 내용',
    [tokens.common.sales_transfer_irreversible_1]: '매출이관 완료 시',
    [tokens.common.sales_transfer_irreversible_2]: '원복은 불가하며,',
    [tokens.common.sales_transfer_irreversible_3]: '수관 발주처 정산 내 반영, 청구 되오니,',
    [tokens.common.sales_transfer_irreversible_4]: '다시 한 번 확인 후 처리하시기',
    [tokens.common.sales_transfer_irreversible_5]: '바랍니다.',
    [tokens.common.sales_transfer_max_logistic_code]:
        '{{salesTransferRound}}회 이관 처리 시, 최대 {{salesTransferLogisticCodeLimit}}개의 물류코드만 가능합니다',
    [tokens.common.receive_sales_select]: '수관 발주처 선택',
    [tokens.common.warn_upload_batch_sales_price_reservation_1]: '잦은 대량 데이터 업로드는 서버 부하를 일으킬 수 있으며,',
    [tokens.common.warn_upload_batch_sales_price_reservation_2]: '고객 주문 또는 출고에 영향을 미칠 수 있으니 한번 더 파일을 확인하시기 바랍니다.',
    [tokens.common.warn_upload_batch_sales_price_reservation_3]: '이미 판매가 예약이 되어 있는 상품의 경우 최종 업로드 기준으로 변경됩니다.',
    [tokens.common.contract_renewal_processing_warning_1]: '재계약 처리 시에는',
    [tokens.common.contract_renewal_processing_warning_2]: '신규 가상계좌번호가 부여되며,',
    [tokens.common.contract_renewal_processing_warning_3]: '기존 계약정보가 원복되오니',
    [tokens.common.contract_renewal_processing_warning_4]: '반드시 재확인',
    [tokens.common.contract_renewal_processing_warning_5]: '하시기 바랍니다.',
    [tokens.common.max_code_group_name]: '코드 그룹 명은 {{maxCodeGroupName}}자를 넘을 수 없습니다.',
    [tokens.common.password_2]: '패스워드',
    [tokens.common.re_enter_password]: '재입력 패스워드',
    [tokens.common.select_purchase_manager]: '구매담당자 선택',
    [tokens.common.upload_failure]: '업로드 실패',
    [tokens.common.code_id]: '코드 ID',
    [tokens.common.code_group_id]: '코드 그룹 ID',
    [tokens.common.required_code_id]: '코드 ID는 필수입니다.',
    [tokens.common.code_group_id_length_limit]: '코드 그룹 ID는 {{codeGroupIdLengthLimit}}자를 넘을 수 없습니다.',
    [tokens.common.code_group_name_length_limit]: '코드 그룹 명은 {{codeGroupNameLengthLimit}}자를 넘을 수 없습니다.',
    [tokens.common.chain_code_length_limit]: '연관 코드는 {{chainCodeLengthLimit}}자를 넘을 수 없습니다.',
    [tokens.common.korean_code_name_required]: '코드 명(한국어)은 필수입니다.',
    [tokens.common.japanese_code_name_required]: '코드 명(일본어)은 필수입니다.',
    [tokens.common.korean_code_display_name_length_limit]: '코드 노출 명(한국어)은 {{koreanCodeDisplayNameLengthLimit}}자를 넘을 수 없습니다.',
    [tokens.common.japanese_code_display_name_length_limit]: '코드 노출 명(일본어)은 {{japaneseCodeDisplayNameLengthLimit}}자를 넘을 수 없습니다.',
    [tokens.common.add_code]: '코드 추가',
    [tokens.common.korean_code_name]: '코드 명(한국어)',
    [tokens.common.japanese_code_name]: '코드 명(일본어)',
    [tokens.common.korean_display_code_name]: '코드 노출 명(한국어)',
    [tokens.common.japanese_display_code_name]: '코드 노출 명(일본어)',
    [tokens.common.add_code_group]: '코드그룹 추가',
    [tokens.common.modify_code_group]: '코드그룹 수정',
    [tokens.common.code_group_name]: '코드 그룹 명',
    [tokens.common.code_group_explain]: '코드 그룹 설명',
    [tokens.common.code_group_explain_length_limit]: '코드 그룹 설명은 {{codeGroupExplainLengthLimit}}자를 넘을 수 없습니다.',
    [tokens.common.code_group_id_required]: '코드 그룹 ID는 필수입니다.',
    [tokens.common.korean_code_group_name_required]: '코드 그룹 명(한국어)은 필수입니다.',
    [tokens.common.japanese_code_group_name_required]: '코드 그룹 명(일본어)은 필수입니다.',
    [tokens.common.korean_code_group_explain_required]: '코드 그룹 설명(한국어)은 필수입니다.',
    [tokens.common.japanese_code_group_explain_required]: '코드 그룹 설명(일본어)은 필수입니다.',
    [tokens.common.statement]: '정산',
    [tokens.common.total_sales_amount_percentage]: '전체 발주처 매출액의 {{totalSalesAmountPercentage}}',
    [tokens.common.months]: '개월',
    [tokens.common.post_number_is_required]: '우편번호는 필수입니다',
    [tokens.common.adjustment_inventory]: '재고 조정',
    [tokens.common.enter]: '입력',
    [tokens.common.select_return_process_result]: '반품 처리 결과 선택',
    [tokens.common.circulation_sales]: '유통 매출',
    [tokens.common.logistic_sales]: '물류 매출',
    [tokens.common.no_settlement]: '정산 없음',
    [tokens.common.monthly_settlement]: '월 단위 정산',
    [tokens.common.monthly_installment_settlement]: '월 분할 정산',
    [tokens.common.next_month]: '익월',
    [tokens.common.not_received]: '미입고',
    [tokens.common.terminated]: '종결',
    [tokens.common.last_short]: '말',
    [tokens.common.ten_thousand_currency_unit]: '만엔',
    [tokens.common.location_row]: '열',
    [tokens.common.location_col]: '단',
    [tokens.common.select_file]: '파일 선택',
    [tokens.common.empty_selected_file]: '선택된 파일이 없습니다.',
    [tokens.common.network_error]: '네트워크 에러',
    [tokens.common.cannot_connect_server]: '서버와 연결할 수 없습니다. 잠시 후 다시 시도해 주십시오.',
    [tokens.common.lot_no]: 'LOT',
    [tokens.common.lot_input]: 'LOT 번호 입력',
    [tokens.common.order_client_cd]: '발주처코드',
    [tokens.common.order_client_nm]: '발주처명',
    [tokens.common.mall_order_no]: '몰 주문 번호',
    [tokens.common.slip_no]: '전표 번호',
    [tokens.common.ship_scheduled_dt]: '출하 예정일',
    [tokens.common.delivery_request_dt]: '지정납품일',
    [tokens.common.delivery_request_tm]: '지정 납품 시간',
    [tokens.common.delivery_nm]: '배송지명',
    [tokens.common.delivery_zip]: '배송지 우편번호',
    [tokens.common.delivery_prefecture]: '도도부현',
    [tokens.common.delivery_addr_rest]: '상세주소',
    [tokens.common.delivery_tel]: '배송지 전화번호',
    [tokens.common.order_goods_barcode]: '바코드',
    [tokens.common.product_nm]: '상품명',
    [tokens.common.order_upload_quantity]: '수량',
    [tokens.common.order_upload_unit_price]: '단가',
    [tokens.common.total_price]: '상품금액 계',
    [tokens.common.processing_div]: '가공 구분 ※ 라벨 부착의 경우 1 입력',
    [tokens.common.note_1]: '기사란 1',
    [tokens.common.note_2]: '기사란 2',
    [tokens.common.sku_code]: 'SKU 코드',
    [tokens.common.goodsIrCd]: '센터 관리코드',
    [tokens.common.address_valid_yn]: '주소 검증 실패 주문만 보기',
    [tokens.common.address_edit]: '주소 변경',
    [tokens.common.address_edit_success]: '주소 변경 완료 되었습니다.',
    [tokens.common.address_valid_warning]: '출고예정일이 오늘 이전인 주문들은 주소 검증이 되지 않습니다.\n 주소 검증을 진행하시겠습니까?',

    [tokens.code.brd_stl_stt_cd_ny]: '미확정',
    [tokens.code.brd_stl_stt_cd_cf]: '확정',
    [tokens.code.brd_stl_stt_cd_er]: '정산에러',
    [tokens.code.brd_stl_typ_cd_dist]: '유통매출',
    [tokens.code.brd_stl_typ_cd_logi]: '물류매출',
    [tokens.code.brd_stl_typ_cd_none]: '정산없음',
    [tokens.code.gd_typ_e]: '전용',
    [tokens.code.gd_typ_g]: '범용',
    [tokens.code.invn_typ_day]: '일재고',
    [tokens.code.invn_typ_direct]: '직송',
    [tokens.code.invn_typ_keep]: '보관재고',
    [tokens.code.gd_tmp_typ_c]: '냉장',
    [tokens.code.gd_tmp_typ_f]: '냉동',
    [tokens.code.gd_tmp_typ_r]: '실온',
    [tokens.code.orgn_typ_d]: '일본산',
    [tokens.code.orgn_typ_i]: '수입산',
    [tokens.code.orgn_typ_o]: '기타',
    [tokens.code.sls_stt_bfe]: '종료임박',
    [tokens.code.sls_stt_con]: '계약중',
    [tokens.code.sls_stt_end]: '종료',
    [tokens.code.sls_stt_stp]: '이용정지',
    [tokens.code.sls_rtt_asign]: '배정',
    [tokens.code.sls_rtt_unasign]: '미배정',
    [tokens.code.gd_use_typ_end]: '종결',
    [tokens.code.gd_use_typ_unuse]: '미사용',
    [tokens.code.gd_use_typ_use]: '사용',
    [tokens.code.nation_ae]: '아랍에미리트', // united arab emirates
    [tokens.code.nation_am]: '미국', // USA
    [tokens.code.nation_an]: '아르헨티나', // Argentina
    [tokens.code.nation_as]: '오스트리아', // Austria
    [tokens.code.nation_au]: '호주', // オーストラリア
    [tokens.code.nation_bg]: '벨기에', // Belgium
    [tokens.code.nation_br]: '바레인', // Bahrain
    [tokens.code.nation_bz]: '브라질', // brazil
    [tokens.code.nation_ca]: '캐나다', // Canada
    [tokens.code.nation_cb]: '콜롬비아', // Colombia
    [tokens.code.nation_ch]: '칠레', // Chile
    [tokens.code.nation_cn]: '중국', // china
    [tokens.code.nation_cr]: '코스타리카', // Costa Rica
    [tokens.code.nation_dm]: '덴마크', // Denmark
    [tokens.code.nation_dn]: '도미니카', // dominica
    [tokens.code.nation_eg]: '이집트', // Egypt
    [tokens.code.nation_etc]: '외국산', // 外国産
    [tokens.code.nation_fg]: '피지', // Fiji
    [tokens.code.nation_fl]: '핀란드', // Finland
    [tokens.code.nation_fr]: '프랑스', // france
    [tokens.code.nation_gm]: '독일', // germany
    [tokens.code.nation_gn]: '기니', // Guinea
    [tokens.code.nation_gr]: '그리스', // Greece
    [tokens.code.nation_hk]: '홍콩', // Hong Kong
    [tokens.code.nation_id]: '인도', // India
    [tokens.code.nation_idn]: '인도네시아', // Indonesia
    [tokens.code.nation_il]: '아일랜드', // Ireland
    [tokens.code.nation_ir]: '이란', // Iran
    [tokens.code.nation_is]: '이스라엘', // Israel
    [tokens.code.nation_it]: '이탈리아', // Italy
    [tokens.code.nation_jp]: '일본', // japan
    [tokens.code.nation_mc]: '멕시코', // Mexico
    [tokens.code.nation_mgc]: '마다가스카르', // Madagascar
    [tokens.code.nation_mn]: '모나코', // monaco
    [tokens.code.nation_mr]: '모로코', // morocco
    [tokens.code.nation_ms]: '말레이시아', // malaysia
    [tokens.code.nation_mt]: '모리타니아', // mauritania
    [tokens.code.nation_my]: '미얀마', // Myanmar
    [tokens.code.nation_nd]: '네덜란드', // Netherlands
    [tokens.code.nation_ng]: '나이지리아', // Nigeria
    [tokens.code.nation_nw]: '노르웨이', // Norway
    [tokens.code.nation_nz]: '뉴질랜드', // New Zealand
    [tokens.code.nation_pc]: '파키스탄', // Pakistan
    [tokens.code.nation_pf]: '태평양', // Pacific
    [tokens.code.nation_pfc]: '태평양', //
    [tokens.code.nation_pg]: '파라과이', // Paraguay
    [tokens.code.nation_pl]: '폴란드', // Poland
    [tokens.code.nation_pp]: '필리핀', // Philippines
    [tokens.code.nation_pr]: '페루', // peru
    [tokens.code.nation_pt]: '포르투갈', // Portugal
    [tokens.code.nation_rsa]: '남아프리카공화국', // south africa
    [tokens.code.nation_ru]: '러시아', // russia
    [tokens.code.nation_sb]: '세르비아', // Serbia
    [tokens.code.nation_sd]: '사우디아라비아', // Saudi Arabia
    [tokens.code.nation_sea]: '원양', // 遠洋
    [tokens.code.nation_sg]: '세네갈', // Senegal
    [tokens.code.nation_sgp]: '싱가포르', // singapore
    [tokens.code.nation_sl]: '스리랑카', // sri lanka
    [tokens.code.nation_sp]: '스페인', // spain
    [tokens.code.nation_ss]: '스위스', // Swiss
    [tokens.code.nation_sw]: '스웨덴', // sweden
    [tokens.code.nation_tk]: '튀르키예', // Turkye
    [tokens.code.nation_tl]: '태국', // thailand
    [tokens.code.nation_ts]: '튀니지', // Tunisia
    [tokens.code.nation_tw]: '대만', // taiwan
    [tokens.code.nation_ub]: '우즈베키스탄', // Uzbekistan
    [tokens.code.nation_uk]: '영국', // England
    [tokens.code.nation_vt]: '베트남', // Vietnam
    [tokens.code.brd_stat_ei]: '종료임박',
    [tokens.code.brd_stat_en]: '종료',
    [tokens.code.brd_stat_st]: '정상',
    [tokens.code.sls_ctt_postpay]: '후불',
    [tokens.code.sls_ctt_prepay]: '선불',
    [tokens.code.pc_grnt_typ_e]: '종료',
    [tokens.code.pc_grnt_typ_i]: '종료임박',
    [tokens.code.pc_grnt_typ_n]: '정상',
    [tokens.code.pc_grnt_typ_none]: '상태없음',
    [tokens.code.pr_stt_direct]: '자체배송',
    [tokens.code.pr_stt_ic]: '입고완료',
    [tokens.code.pr_stt_if]: '입고확정',
    [tokens.code.pr_stt_ik]: '입고확인',
    [tokens.code.pr_stt_iw]: '입고대기',
    [tokens.code.pr_stt_pr]: '발주요청',
    [tokens.code.pr_stt_px]: '발주취소',
    [tokens.code.rtrn_prog_ab]: '발주취소',
    [tokens.code.rtrn_prog_rx]: '반품취소',
    [tokens.code.rtrn_prog_rr]: '반품접수',
    [tokens.code.rtrn_prog_rc]: '반품요청(확정)',
    [tokens.code.rtrn_typ_bd]: '상품 불량',
    [tokens.code.rtrn_typ_bk]: '상품 파손',
    [tokens.code.rtrn_typ_sp]: '유통기한 경과',
    [tokens.code.pc_stl_typ_cf]: '확정완료',
    [tokens.code.pc_stl_typ_ny]: '미확정',
    [tokens.code.bond_pay_stt_npaid]: '미납',
    [tokens.code.bond_pay_stt_paid]: '상환',
    [tokens.code.crdt_stt_cd_e]: '종료',
    [tokens.code.crdt_stt_cd_n]: '정상',
    [tokens.code.crdt_stt_cd_s]: '정지',
    [tokens.code.adj_price_category_bond_adj]: '채권조정',
    [tokens.code.adj_price_category_claim]: '클레임',
    [tokens.code.adj_price_category_coast]: '비용청구',
    [tokens.code.adj_price_category_etc]: '기타',
    [tokens.code.adj_price_category_purchase]: '사입비',
    [tokens.code.adj_price_category_quick]: '퀵비',
    [tokens.code.adj_price_category_quick_purchase]: '퀵/사입',
    [tokens.code.adj_price_category_sales_adj]: '매출조정',
    [tokens.code.sbjct_rspns_center_mng]: '센터관리자',
    [tokens.code.sbjct_rspns_consultant]: '상담원',
    [tokens.code.sbjct_rspns_dlvr_mng]: '배송매니저',
    [tokens.code.sbjct_rspns_inbound]: '입고지센터',
    [tokens.code.sbjct_rspns_logistics]: '물류사',
    [tokens.code.sbjct_rspns_outbound]: '출차지센터',
    [tokens.code.sbjct_rspns_pc_mng]: '구매담당자',
    [tokens.code.sbjct_rspns_purchase]: '매입처',
    [tokens.code.sbjct_rspns_sales]: '발주처',
    [tokens.code.sbjct_rspns_sales_mng]: '영업담당자',
    [tokens.code.sls_stl_typ_cf]: '확정완료',
    [tokens.code.sls_stl_typ_er]: '정산에러',
    [tokens.code.sls_stl_typ_ff]: '강제확정',
    [tokens.code.sls_stl_typ_ny]: '미확정',
    [tokens.code.pr_stt_direct]: '자체배송',
    [tokens.code.po_inb_stt_fi]: '강제입고',
    [tokens.code.po_inb_stt_mi]: '미입고',
    [tokens.code.po_inb_stt_ni]: '정상입고',
    [tokens.code.po_inb_stt_pi]: '부분입고',
    [tokens.code.rqsts_bad_02]: '상품불량',
    [tokens.code.rqsts_bad_break]: '상품불량 파손',
    [tokens.code.rqsts_brk_crm_2]: '파손',
    [tokens.code.rqsts_chn_mind]: '단순변심',
    [tokens.code.rqsts_cop_crm_2]: '전산문의',
    [tokens.code.rqsts_cor_dlvr_02]: '대응배송',
    [tokens.code.rqsts_cre_crm_2]: '결제문의',
    [tokens.code.rqsts_dlvr_crm_2]: '배송문의',
    [tokens.code.rqsts_dmg_py_2]: '재화파손',
    [tokens.code.rqsts_doc_crm_2]: '서류요청',
    [tokens.code.rqsts_dor_lck_2]: '출입문미시건',
    [tokens.code.rqsts_err_code_02]: '에러코드',
    [tokens.code.rqsts_err_stack_02]: '오적재',
    [tokens.code.rqsts_error]: '오배송',
    [tokens.code.rqsts_etc]: '기타',
    [tokens.code.rqsts_etc_02]: '기타문의',
    [tokens.code.rqsts_expired]: '유통기한',
    [tokens.code.rqsts_miss]: '미배송',
    [tokens.code.rqsts_no_st_crm2]: '미입고',
    [tokens.code.rqsts_open_clo_2]: '냉장고개폐',
    [tokens.code.rqsts_ord_crm_02]: '발주문의',
    [tokens.code.rqsts_over_st_2]: '과입고',
    [tokens.code.rqsts_pro_crm_2]: '제품문의',
    [tokens.code.rqsts_sup_data_02]: '증빙자료',
    [tokens.code.rqsts_unrecover2]: '미회수',
    [tokens.code.rqsts_wrg_ord_2]: '오발주',
    [tokens.code.rqsts_wrg_sto_2]: '오입고',
    [tokens.code.tkbck_prog_tc]: '회수완료',
    [tokens.code.tkbck_prog_tg]: '회수중',
    [tokens.code.tkbck_prog_tx]: '회수취소',
    [tokens.code.tkbck_prcsn_done]: '회수정상종료',
    [tokens.code.tkbck_prcsn_fc]: '완료',
    [tokens.code.tkbck_prcsn_n]: '미처리',
    [tokens.code.tkbck_prcsn_pc]: '부분완료',
    [tokens.code.tkbck_prcsn_r]: '대기중',
    [tokens.code.sbjct_rspns_center_mng]: '센터관리자',
    [tokens.code.sbjct_rspns_consultant]: '상담원',
    [tokens.code.sbjct_rspns_dlvr_mng]: '배송매니저',
    [tokens.code.sbjct_rspns_inbound]: '입고지센터',
    [tokens.code.sbjct_rspns_logistics]: '물류사',
    [tokens.code.sbjct_rspns_outbound]: '출차지센터',
    [tokens.code.sbjct_rspns_pc_mng]: '구매담당자',
    [tokens.code.sbjct_rspns_purchase]: '매입처',
    [tokens.code.sbjct_rspns_sales]: '발주처',
    [tokens.code.sbjct_rspns_sales_mng]: '영업담당자',
    [tokens.code.tkbck_inb_ab]: '폐기',
    [tokens.code.tkbck_inb_gq]: '양품화',
    [tokens.code.tkbck_inb_qw]: '양품대기',
    [tokens.code.tkbck_inb_ret]: '반품',
    [tokens.code.tkbck_dlv_ab]: '자체폐기',
    [tokens.code.tkbck_dlv_c]: '센터회수',
    [tokens.code.mdlml_inb_stt_ic]: '입고완료',
    [tokens.code.mdlml_inb_stt_in_dlv]: '배송중',
    [tokens.code.mdlml_inb_stt_iw]: '입고대기',
    [tokens.code.mdlml_inb_stt_prtl_dlv]: '부분배송',
    [tokens.code.mdlml_inb_stt_xi]: '미입고',
    [tokens.code.ord_prog_dc]: '배송완료',
    [tokens.code.ord_prog_dd]: '배송지연',
    [tokens.code.ord_prog_dw]: '배송중',
    [tokens.code.ord_prog_oc]: '주문확정',
    [tokens.code.ord_prog_or]: '주문접수',
    [tokens.code.ord_prog_ox]: '주문취소',
    [tokens.code.ord_prog_pd]: '부분배송',
    [tokens.code.ord_prog_sw]: '출고중',
    [tokens.code.ord_prog_pc]: '패킹완료',
    [tokens.code.ord_prog_sc]: '출고완료',
    [tokens.code.ord_prog_address_fail]: '주소오류',
    [tokens.code.ord_cancel_ok]: '정상',
    [tokens.code.ord_cancel_ox]: '전체취소',
    [tokens.code.ord_cancel_pc]: '부분취소',
    [tokens.code.outb_stt_e]: '미출',
    [tokens.code.outb_stt_el]: '미상차',
    [tokens.code.outb_stt_k]: '확인필요',
    [tokens.code.outb_stt_n]: '정상',
    [tokens.code.outb_stt_pd]: '부분배송',
    [tokens.code.outb_stt_q]: '선출고',
    [tokens.code.outb_stt_ro]: '재출고',
    [tokens.code.outb_stt_x]: '취소',
    [tokens.code.outb_typ_emrg]: '긴급출고',
    [tokens.code.outb_typ_last]: '지선',
    [tokens.code.outb_typ_mid]: '간선',
    [tokens.code.issu_src_e]: '미출',
    [tokens.code.issu_src_el]: '미상차',
    [tokens.code.issu_src_k]: '확인필요',
    [tokens.code.issu_src_n]: '정상',
    [tokens.code.issu_src_pd]: '부분배송',
    [tokens.code.issu_src_q]: '선출고',
    [tokens.code.issu_src_ro]: '재출고',
    [tokens.code.issu_src_x]: '취소',
    [tokens.code.center_issu_e]: '긴급출고',
    [tokens.code.center_issu_o]: '출고지시',
    [tokens.code.center_issu_r]: '요청취소',
    [tokens.code.center_issu_ro]: '재출고지시',
    [tokens.code.center_issu_x]: '주문취소',
    [tokens.code.issu_prcsn_cr]: '고객요청',
    [tokens.code.issu_prcsn_dd]: '배송지연',
    [tokens.code.issu_prcsn_et]: '기타',
    [tokens.code.issu_prcsn_gb]: '상품불량,파손',
    [tokens.code.issu_prcsn_ie]: '재고부족',
    [tokens.code.invn_adjs_typ_ab]: '폐기',
    [tokens.code.invn_adjs_typ_defective]: '불량',
    [tokens.code.invn_adjs_typ_los]: '손망실 처리',
    [tokens.code.invn_adjs_typ_ml]: '미상차',
    [tokens.code.invn_adjs_typ_rcv]: '손망실복구',
    [tokens.code.invn_adjs_typ_shl]: '유통기한 조정',
    [tokens.code.invn_adjs_typ_lot]: 'LOT번호 수정',
    [tokens.code.invnsu_prog_c]: '완료',
    [tokens.code.invnsu_prog_f]: '확정',
    [tokens.code.invnsu_prog_w]: '진행중',
    [tokens.code.invn_prcsn_ab]: '폐기',
    [tokens.code.invn_prcsn_ci]: '창간입고',
    [tokens.code.invn_prcsn_co]: '창간출고',
    [tokens.code.invn_prcsn_defective]: '불량',
    [tokens.code.invn_prcsn_in]: '입고',
    [tokens.code.invn_prcsn_los]: '손망실 처리',
    [tokens.code.invn_prcsn_mov]: '이동',
    [tokens.code.invn_prcsn_out]: '출고',
    [tokens.code.invn_prcsn_rcv]: '손망실복구',
    [tokens.code.invn_prcsn_ret]: '반품',
    [tokens.code.invn_prcsn_shl]: '유통기한 조정',
    [tokens.code.invn_prcsn_tb]: '회수',
    [tokens.code.lct_typ_bd]: '조정존',
    [tokens.code.lct_typ_db]: '분배존',
    [tokens.code.lct_typ_et]: '기타',
    [tokens.code.lct_typ_in]: '입고존',
    [tokens.code.lct_typ_jb]: '작업존',
    [tokens.code.lct_typ_kp]: '보관존',
    [tokens.code.lct_typ_mv]: '이동존',
    [tokens.code.lct_typ_ot]: '출고존',
    [tokens.code.lct_typ_pk]: '피킹존',
    [tokens.code.lct_typ_rt]: '반품존',
    [tokens.code.lct_typ_tk]: '회수존',
    [tokens.code.tm_dlv_stat_dlv_cpl]: '배송완료',
    [tokens.code.tm_dlv_stat_in_dlv]: '배송중',
    [tokens.code.tm_dlv_stat_inb_wait]: '입차대기중',
    [tokens.code.tm_dlv_stat_load_inspc]: '상차검수중',
    [tokens.code.tm_dlv_stat_load_wait]: '상차대기중',
    [tokens.code.dlv_ml_last]: '지선',
    [tokens.code.dlv_ml_mid]: '간선',
    [tokens.code.tm_biz_type_prsnl]: '개인',
    [tokens.code.tm_biz_type_trnsp]: '운수사',
    [tokens.code.tm_cntr_stat_cntr_end]: '계약종료',
    [tokens.code.tm_cntr_stat_under_cntr]: '계약중',
    [tokens.code.stlprg_mnt_next_mth]: '익월',
    [tokens.code.stand_dt_1]: '1',
    [tokens.code.stand_dt_10]: '10',
    [tokens.code.stand_dt_15]: '15',
    [tokens.code.stand_dt_20]: '20',
    [tokens.code.stand_dt_25]: '25',
    [tokens.code.stand_dt_5]: '5',
    [tokens.code.stand_dt_last]: '말일',
    [tokens.code.cnsln_typ_cd_claim]: '클레임',
    [tokens.code.cnsln_typ_cd_common]: '일반',
    [tokens.code.cnsln_typ_cd_issue]: '출고이슈',
    [tokens.code.cnsln_typ_cd_msg]: '문자발송',
    [tokens.code.cnsln_typ_cd_recall]: '반품/교환',
    [tokens.code.cnsln_typ_cd_urgnt_dlvr]: '긴급출고',
    [tokens.code.crm_gnr_inq_break_crm_01]: '파손',
    [tokens.code.crm_gnr_inq_comp_crm_01]: '전산문의',
    [tokens.code.crm_gnr_inq_cr_dlvr_1]: '대응배송',
    [tokens.code.crm_gnr_inq_cred_crm_01]: '결제문의',
    [tokens.code.crm_gnr_inq_dlvr_crm_01]: '배송문의',
    [tokens.code.crm_gnr_inq_dlvr_rt]: '배송 • 회수 문의',
    [tokens.code.crm_gnr_inq_dmg_py_01]: '재화파손',
    [tokens.code.crm_gnr_inq_docu_crm_01]: '서류요청',
    [tokens.code.crm_gnr_inq_door_lo_1]: '출입문미시건',
    [tokens.code.crm_gnr_inq_er_code_1]: '에러코드',
    [tokens.code.crm_gnr_inq_err_st_1]: '오적재',
    [tokens.code.crm_gnr_inq_etc]: '기타 문의',
    [tokens.code.crm_gnr_inq_etc_01]: '기타문의',
    [tokens.code.crm_gnr_inq_goods_inq]: '상품 문의',
    [tokens.code.crm_gnr_inq_no_st_cr_1]: '미입고',
    [tokens.code.crm_gnr_inq_open_cl_1]: '냉장고개폐',
    [tokens.code.crm_gnr_inq_ord_crm_01]: '발주문의',
    [tokens.code.crm_gnr_inq_ord_stl]: '주문 • 정산 문의',
    [tokens.code.crm_gnr_inq_over_st_1]: '과입고',
    [tokens.code.crm_gnr_inq_prod_crm_01]: '제품문의',
    [tokens.code.crm_gnr_inq_sup_da_01]: '증빙자료',
    [tokens.code.crm_gnr_inq_sys]: '시스템 문의',
    [tokens.code.crm_gnr_inq_unrecover_01]: '미회수',
    [tokens.code.crm_gnr_inq_wng_or_1]: '오발주',
    [tokens.code.crm_gnr_inq_wng_st_1]: '오입고',
    [tokens.code.crm_dtl_ty_bad]: '상품불량',
    [tokens.code.crm_dtl_ty_bad_pack]: '포장불량',
    [tokens.code.crm_dtl_ty_break]: '상품파손',
    [tokens.code.crm_dtl_ty_break_crm]: '파손',
    [tokens.code.crm_dtl_ty_comp_crm]: '전산문의',
    [tokens.code.crm_dtl_ty_cor_dlvr]: '대응배송',
    [tokens.code.crm_dtl_ty_cred_crm]: '결제문의',
    [tokens.code.crm_dtl_ty_dlvr_crm]: '배송문의',
    [tokens.code.crm_dtl_ty_dly_dlvr]: '지연배송',
    [tokens.code.crm_dtl_ty_dmg_pry]: '재화파손',
    [tokens.code.crm_dtl_ty_docu_crm]: '서류요청',
    [tokens.code.crm_dtl_ty_door_lock]: '출입문미시건',
    [tokens.code.crm_dtl_ty_err_code]: '에러코드',
    [tokens.code.crm_dtl_ty_err_ln_bd]: '여신・채권 오류',
    [tokens.code.crm_dtl_ty_err_ord]: '주문불가 오류',
    [tokens.code.crm_dtl_ty_err_price]: '정산금액 오류',
    [tokens.code.crm_dtl_ty_err_recall]: '오회수',
    [tokens.code.crm_dtl_ty_err_stack]: '오적재',
    [tokens.code.crm_dtl_ty_etc]: '기타',
    [tokens.code.crm_dtl_ty_expired_dt]: '유통기한',
    [tokens.code.crm_dtl_ty_misdlvr]: '오배송',
    [tokens.code.crm_dtl_ty_no_st_cr]: '미입고',
    [tokens.code.crm_dtl_ty_open_close]: '냉장고개폐',
    [tokens.code.crm_dtl_ty_ord_crm]: '발주문의',
    [tokens.code.crm_dtl_ty_over_st]: '과입고',
    [tokens.code.crm_dtl_ty_prod_crm]: '제품문의',
    [tokens.code.crm_dtl_ty_sup_da]: '증빙자료',
    [tokens.code.crm_dtl_ty_undlvr]: '미배송',
    [tokens.code.crm_dtl_ty_unrecover]: '미회수',
    [tokens.code.crm_dtl_ty_wrg_ord]: '오발주',
    [tokens.code.crm_dtl_ty_wrg_st]: '오입고',
    [tokens.code.return_stt_cd_approve]: '반품승인',
    [tokens.code.return_stt_cd_receipt]: '접수',
    [tokens.code.return_stt_cd_reject]: '반려',
    [tokens.code.prcsn_stt_cd_done]: '완료',
    [tokens.code.prcsn_stt_cd_incomplete]: '미완료',
    [tokens.code.prcsn_stt_cd_rc]: '요청취소',
    [tokens.code.crm_process_type_e]: '교환',
    [tokens.code.crm_process_type_r]: '반품',
    [tokens.code.crm_type_basc_ask]: '일반문의',
    [tokens.code.crm_type_break_bad]: '상품 파손 • 불량',
    [tokens.code.crm_type_claim_ask]: '클레임',
    [tokens.code.crm_type_dlvr_rt]: '배송 • 회수',
    [tokens.code.crm_type_etc_ask]: '기타',
    [tokens.code.crm_type_ord_stl]: '주문 • 정산',
    [tokens.code.noti_state_noti]: '공지중',
    [tokens.code.noti_state_noti_end]: '공지 종료',
    [tokens.code.notice_ctg_brand_cal]: '채권•정산',
    [tokens.code.notice_ctg_etc]: '기타',
    [tokens.code.notice_ctg_goods]: '상품',
    [tokens.code.notice_ctg_ord_deli]: '주문•배송',
    [tokens.code.notice_ctg_system]: '시스템',
    [tokens.code.grnt_typ_cash]: '현금',
    [tokens.code.grnt_typ_credit]: '신용',
    [tokens.code.grnt_typ_pgrnt]: '이행보증보험',
    [tokens.code.tm_dlv_cpl_stat_dlv_cpl]: '배송완료',
    [tokens.code.tm_dlv_cpl_stat_in_dlv]: '배송중',
    [tokens.code.tm_dlv_cpl_stat_no_dlv]: '미배송',
    [tokens.code.tm_dlv_cpl_stat_prtl_dlv]: '부분배송',
    [tokens.code.bond_typ_cd_adj]: '조정금',
    [tokens.code.bond_typ_cd_en]: '해지',
    [tokens.code.bond_typ_cd_in]: '입금',
    [tokens.code.bond_typ_cd_mig]: '매출이관',
    [tokens.code.bond_typ_cd_out]: '출금',
    [tokens.code.bond_typ_cd_st]: '생성',
    [tokens.code.parcel]: '택배',
    [tokens.code.truck]: '트럭',
    [tokens.code.ft20]: '20FT',
    [tokens.code.ft40]: '40FT',
    [tokens.code.invn_splm_stt_c]: '보충 완료',
    [tokens.code.invn_splm_stt_o]: '보충 지시',
    [tokens.code.invn_splm_stt_r]: '보충 대기',
    [tokens.code.inb_method_typ_receipt_official]: '정식입고',
    [tokens.code.inb_method_typ_rt_vendor]: '거래처 반품',
    [tokens.code.inb_method_typ_rt_head_of]: '본사 반품',
    [tokens.code.inb_method_typ_rt_amazon]: '아마존 반품',
    [tokens.code.inb_method_typ_rt_jojo]: '조조 반품',
    [tokens.code.inb_method_typ_rt_popup]: '팝업 반품',
    [tokens.code.inb_method_typ_rt_qt]: '큐텐 반품',
    [tokens.common.invoice_bulk_down]: '송장발번',
    [tokens.common.invoice_re_print]: '송장 재출력',
    [tokens.common.invoice_print]: '송장 출력',
    [tokens.common.invoice_bulk_down_description]: '동일한 규격으로 선택한 주문들의 송장을 발번합니다.',
    [tokens.common.invoice_list_not_found]: '출력 가능한 송장이 없습니다.',
    [tokens.common.print_option]: '출력 옵션',
    [tokens.common.selected_order_print]: '선택한 주문의 송장 일괄 출력',
    [tokens.common.selected_invoice_number_print]: '송장번호 선택하여 출력',
    [tokens.common.invoice_down]: '납품서 다운로드',
    [tokens.common.ida_invoice_down]: '이다 납품서 다운로드',
    [tokens.common.other_invoice_down]: '이다 외 납품서 다운로드',
    [tokens.common.packing_start]: '패킹 시작',
    [tokens.common.packing_inspection]: '패킹검수',
    [tokens.common.individual_picking_code]: '개별피킹 코드',
    [tokens.common.purchaser_name]: '발주처명',
    [tokens.common.goods_barcode]: '상품 바코드',
    [tokens.common.goods_barcode_scan]: '상품 바코드 스캔',
    [tokens.common.packing_complete]: '패킹 종료',
    [tokens.common.next_box_packing]: '다음 박스 패킹',
    [tokens.common.box_packing]: '박스 패킹',
    [tokens.common.total_picking_code]: '토탈피킹 코드',
    [tokens.common.packed_quantity]: '검수수량',
    [tokens.common.input_quantity]: '입수량',
    [tokens.common.box_code]: '박스 코드',
    [tokens.common.packaging_box]: '포장 박스',
    [tokens.common.box_modification]: '박스변경',
    [tokens.common.box_barcode]: '박스 바코드',
    [tokens.common.enter_box_barcode]: '박스 바코드를 입력해주세요',
    [tokens.common.invoice_number]: '송장 번호',
    [tokens.common.status]: '상태',
    [tokens.common.expiry_date]: '유통기한',
    [tokens.common.area]: '권역',
    [tokens.common.select_area]: '권역선택',
    [tokens.common.all]: '전체',
    [tokens.common.packing_complete]: '패킹완료',
    [tokens.common.start_date]: '시작일',
    [tokens.common.end_date]: '종료일',
    [tokens.common.inspection_status]: '검수상태',
    [tokens.common.partial_inspection]: '부분검수',
    [tokens.common.inspection_complete]: '검수완료',
    [tokens.common.box_cnt]: '박스 수',
    [tokens.common.total_qty]: '합계수량',
    [tokens.common.urgent_outbound]: '긴급출고',
    [tokens.common.urgent_outbound_type]: '긴급출고 유형',
    [tokens.common.type]: '유형',
    [tokens.common.cargo]: '화물',
    [tokens.common.parcel]: '택배',
    [tokens.common.delivery_status]: '배송상태',
    [tokens.common.delivery_in_progress]: '배송중',
    [tokens.common.delivery_completed]: '배송완료',
    [tokens.common.invoice_registration]: '송장접수',
    [tokens.common.packing_completion_date]: '패킹완료일',
    [tokens.common.packing_start_date]: '패킹 시작일시',
    [tokens.common.individual_picking_code]: '개별피킹코드',
    [tokens.common.product]: '상품',
    [tokens.common.scheduled_outbound_date]: '출고예정일',
    [tokens.common.one_or_more]: '1개 이상',
    [tokens.common.three_or_more]: '3개 이상',
    [tokens.common.five_or_more]: '5개 이상',
    [tokens.common.ten_or_more]: '10개 이상',
    [tokens.common.total_packed_quantity]: '총 패킹수량',
    [tokens.common.packing_status]: '패킹상태',
    [tokens.common.quantity_input]: '수량 입력',
    [tokens.common.box_size]: '박스 규격',
    [tokens.common.now_box_size]: '현재 포장박스 규격',
    [tokens.common.goods_name]: '상품명',
    [tokens.common.order_qty]: '주문수량',
    [tokens.common.inspection_quantity]: '검수수량',
    [tokens.common.packing_work_end]: '패킹 작업 종료',
    [tokens.common.packing_work_end_confirm_message_1]: '페이지를 벗어날 경우',
    [tokens.common.packing_work_end_confirm_message_2]: '패킹완료 되지 않은 상품은 검수 초기화 됩니다.',
    [tokens.common.packing_work_end_confirm_message_3]: '박스에 입수되어 있는 상품을 꺼내주세요.',
    [tokens.common.packing_incomplete_items]: '아직 검수되지 않은 상품이 있습니다. 그래도 종료하시겠습니까?',
    [tokens.common.packing_incomplete_items_for_invoice]: '검수가 완료되지 않은 상품이 있습니다.',
    [tokens.common.packing_complete_auto]: '패킹 완료',
    [tokens.common.packing_complete_auto_message]: '모든 상품이 검수완료되었습니다. 패킹완료 처리합니다.',
    [tokens.common.packing_already_completed]: '이미 완료된 패킹',
    [tokens.common.packing_complete_confirm_info]: '실제 박스 수량과 일치하는지 확인 후 확인을 눌러주세요.',
    [tokens.common.packing_already_completed_message]: '이미 송장번호와 박스번호가 발번된 패킹입니다. 초기화면으로 돌아갑니다.',
    [tokens.common.cargo_outbound_no_invoice_print]: '화물출고로 처리합니다. 송장이 출력되지 않습니다.',
    [tokens.common.bulk_inspection_complete]: '일괄검수완료',
    [tokens.common.bulk_inspection_confirm]: '선택하신 주문을 일괄 검수 처리합니다.\n정말 진행하시겠습니까?',
    [tokens.common.cargo_outbound]: '화물출고',
    [tokens.common.inspection_start]: '검수 시작',
    [tokens.common.cargo_complete_with_box_count]: '패킹완료 및 박스수량 입력',
    [tokens.common.batch_inspection_reinspection_not_allowed]: '일괄검수완료 건은 패킹재검수를 할 수 없습니다',
    [tokens.common.individual_picking_code_length_error]: '개별피킹코드를 10자리 또는 14자리 입력해주세요',
    [tokens.common.cancel]: '취소',
    [tokens.common.confirm]: '확인',
    [tokens.common.location_alias_modification_message]: '로케이션 명칭을 수정하시겠습니까?',
    [tokens.common.location_alias_modification_success_message]: '로케이션 명칭이 수정이 완료되었습니다.',
    [tokens.common.location_alias_modification_error_message]: '로케이션 명칭 수정을 실패하였습니다.',
    [tokens.common.outbound_pending]: '출고대기',
    [tokens.common.outbound_work]: '출고작업',
    [tokens.common.outbound_complete]: '출고완료',
    [tokens.common.outbound_complete_old]: '출고완료_old',
    [tokens.common.invoice_number]: '송장번호',
    [tokens.common.purchaser]: '브랜드',
    [tokens.common.logistics_number]: '물류번호',
    [tokens.common.goods_id]: '상품ID',
    [tokens.common.product_name]: '상품명',
    [tokens.common.order_quantity]: '주문수량',
    [tokens.common.loading_quantity]: '배송수량',
    [tokens.common.unit]: '단위',
    [tokens.common.outbound_date]: '출고일',
    [tokens.common.canceled]: '취소',
    [tokens.common.region]: '권역',
    [tokens.common.select_region]: '권역 선택',
    [tokens.common.outbound_complete_processing]: '출고완료 처리',
    [tokens.common.selected_orders_outbound_complete_processing]: '선택된 {{count}}개 주문의 출고완료 처리를 진행합니다',
    [tokens.common.outbound_complete_processing_under_conditions]: '아래 조건의 출고완료 처리를 진행합니다',
    [tokens.common.sales_partner]: '발주처',
    [tokens.common.select_sales_partner]: '발주처 선택',
    [tokens.common.outbound_complete_processing_according_to_selected_conditions]: '선택된 조건에 따라 출고완료 처리가 진행됩니다',
    [tokens.common.completion]: '완료',
    [tokens.common.individual_order_code]: '개별 주문 코드',
    [tokens.common.invoice_registration_status]: '송장접수상태',
    [tokens.common.not_registered]: '미접수',
    [tokens.common.partial_registration]: '부분접수',
    [tokens.common.registration_complete]: '접수완료',
    [tokens.common.sender_name]: '발송인명',
    [tokens.common.sender_address]: '발송인주소',
    [tokens.common.sender_tel]: '발송인전화번호',
    [tokens.common.inventory_snapshot_excel_down]: 'SKU 가용재고리스트',
    [tokens.common.inventory_snapshot_detail_excel_down]: '재고상세(로케이션, LOT, EXP)',
    [tokens.common.inventory_excel_down]: 'SKU 가용재고리스트',
    [tokens.common.inventory_detail_excel_down]: '재고상세(로케이션, LOT, EXP)',
    [tokens.common.packing_inspection_data_fetch_failed]: '패킹검수 데이터 조회 실패: {{error}}',
    [tokens.common.no_items_available_for_assignment]: '할당 가능한 상품이 없습니다',
    [tokens.common.server_connection_error]: '서버에 연결할 수 없습니다. 네트워크 상태를 확인해주세요.',
    [tokens.common.next_box_packing_failed]: '다음 박스 패킹 실패: {{error}}',
    [tokens.common.packing_complete_failed]: '패킹 완료 실패: {{error}}',
    [tokens.common.quantity_must_be_at_least_one]: '수량은 1 이상이어야 합니다',
    [tokens.common.over_packing_not_allowed]:
        '오버검수 불가능! 주문수량({{orderQty}}) - 현재검수수량({{currentPackedQty}}) = 남은검수가능수량({{remainingQty}})개입니다.',
    [tokens.common.packing_inspection_reset_failed]: '패킹검수 초기화 실패: {{error}}',
    [tokens.common.box_reset]: '박스 초기화',
    [tokens.common.box_reset_confirm]: 'Box {{boxSeq}}을(를) 초기화하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
    [tokens.common.box_reset_success]: '박스가 초기화되었습니다.',
    [tokens.common.inspection_qty_edit]: '검수 수량 수정',
    [tokens.common.box_reset_select]: '박스 초기화 - 박스 선택',
    [tokens.common.inspection_qty_edit_select]: '검수 수량 수정 - 박스 선택',
    [tokens.common.no_box_found]: '조회된 박스가 없습니다.',
    [tokens.common.please_scan_picking_code]: '개별피킹코드를 먼저 스캔해주세요.',
    [tokens.common.inspection_qty_edit_success]: '검수 수량이 수정되었습니다.',
    [tokens.common.same_quantity_warning]: '현재와 동일한 수량입니다.',
    [tokens.common.max_modifiable_qty_warning]: '최대 수정 가능 수량은 {{max}}개 입니다.',
    [tokens.common.modify_quantity]: '수정 수량',
    [tokens.common.current_assigned_qty]: '현재 할당수량',
    [tokens.common.max_modifiable_qty]: '최대 수정 가능 수량',
    [tokens.common.packing_re_inspection]: '패킹 재검수',
    [tokens.common.packing_re_inspection_complete]: '패킹 재검수 완료',
    [tokens.common.re_inspection_incomplete_warning]: '모든 수량이 박스에 할당되지 않았습니다. 할당 완료 후 종료해주세요.',
    [tokens.common.box_barcode_required]: '박스바코드를 스캔해주세요.',
    [tokens.common.re_inspection_must_complete]: '박스 수정 또는 수량 수정 이력이 있어 패킹 재검수 완료를 해야 합니다.',
    [tokens.common.re_inspection_reprint_confirm]: '패킹 재검수시 송장을 모두 재출력해서 새로 부착 해야합니다.',
    [tokens.common.inquiry]: '조회',
    [tokens.common.scan_goods_barcode]: '상품바코드를 스캔하세요',
    [tokens.common.enter_inspection_quantity]: '검수할 수량을 입력하세요',
    [tokens.common.packing_status_not_started]: '미시작',
    [tokens.common.packing_status_complete]: '완료',
    [tokens.common.packing_status_in_progress]: '진행중',
    [tokens.common.inspection_status_not_inspected]: '미검수',
    [tokens.common.inspection_status_partial]: '부분검수',
    [tokens.common.inspection_status_complete]: '검수완료',
}
